(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7124],{

/***/ 94356:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10166);


var Block = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e154o9z80"
})("position:fixed;display:flex;align-items:center;justify-content:center;height:100vh;width:100%;top:0;left:0;background-color:rgba(21,22,25,0.5);z-index:10;visibility:", function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "visible" : "hidden";
}, ";transition:0.1s;");
var Dimmer = function(param) {
    var children = param.children, isOpen = param.isOpen;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(Block, {
        isOpen: isOpen,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Dimmer);


/***/ }),

/***/ 8665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10166);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94829);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18722);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80871);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97349);







var EmmptyItemBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div", {
    target: "e1nxlzni0"
})("display:flex;flex-direction:column;justify-content:center;align-items:center;span{margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .spacing.xl */ .W0.xl, ";}");
var EmptyItem = function(param) {
    var _text = param.text, text = _text === void 0 ? "Sorry, No item found" : _text, children = param.children;
    var isMdDownScreen = (0,react_use__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,lib_util__WEBPACK_IMPORTED_MODULE_3__/* .getBreakpointQuery */ .XR)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .breakpoints.down */ .AV.down("md")));
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(EmmptyItemBlock, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_components_Image__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                prefix: "local",
                src: "/folder.png",
                alt: "empty",
                width: isMdDownScreen ? 117 : 146,
                height: isMdDownScreen ? 80 : 100
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                type: isMdDownScreen ? "h5" : "h3",
                children: text
            }),
            children
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmptyItem);


/***/ }),

/***/ 7590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);


var MetaTag = function(param) {
    var _title = param.title, title = _title === void 0 ? "PlayDapp : The Premier Marketplace for NFTs" : _title, _description = param.description, description = _description === void 0 ? "The Premier Marketplace for NFTs" : _description, _image = param.image, image = _image === void 0 ? "https://images.playdapp.com/marketplace/meta/og-image.png" : _image, _keywords = param.keywords, keywords = _keywords === void 0 ? "NFT, Marketplace" : _keywords;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                name: "keywords",
                content: keywords
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                name: "author",
                content: "PlayDapp"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:url",
                content: "https://market.playdapp.com"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "twitter:url",
                content: "https://market.playdapp.com"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("meta", {
                property: "twitter:image",
                content: image
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("title", {
                children: title
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MetaTag);


/***/ }),

/***/ 70027:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(20414);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18722);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88767);
/* harmony import */ var api_order__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28171);
/* harmony import */ var hooks_useFeeValues__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39086);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69583);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97349);
/* harmony import */ var _components_Video__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(85900);
/* harmony import */ var _components_WarningText__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(3385);












var ModalContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian20"
})("display:flex;flex-direction:column;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xxl */ .W0.xxl, ";");
var ModalTitleBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian21"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";}");
var ModalTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h3", {
    target: "e4vian22"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h3 */ .JB.h3, ";font-weight:900;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.h5 */ .JB.h5, ";}");
var ModalContentsBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian23"
})("display:flex;flex-direction:column;");
var ItemColumn = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian24"
})("display:flex;justify-content:space-between;margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, ";", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{display:none;}");
var Label = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "e4vian25"
})("font-weight:700;color:", function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.black */ .DG.black;
}, ";");
var LabelValue = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "e4vian26"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p3 */ .JB.p3, ";color:", function(param) {
    var color = param.color;
    return color !== null && color !== void 0 ? color : _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.black */ .DG.black;
}, ";");
var ItemInfoBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian27"
})("display:flex;align-items:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, ";padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, " 0;border-top:1px solid ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray400 */ .DG.gray400, ";border-bottom:1px solid ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray400 */ .DG.gray400, ";");
var InfoBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian28"
})("display:flex;flex-direction:column;justify-content:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";");
var ImageBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("figure", {
    target: "e4vian29"
})("max-width:80px;max-height:80px;video{border-radius:16px;}");
var ItemName = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p", {
    target: "e4vian210"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p3 */ .JB.p3, ";");
var PriceBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian211"
})("display:flex;", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{flex-direction:column;}");
var IconBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian212"
})("display:flex;align-items:center;");
var Price = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "e4vian213"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p3 */ .JB.p3, ";margin:0 ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";");
var CurrencyBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian214"
})(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{display:block;}");
var UsdPrice = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("span", {
    target: "e4vian215"
})("font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p4 */ .JB.p4, ";color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray900 */ .DG.gray900, ";");
var FeeBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian216"
})("margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xxl */ .W0.xxl, ";margin-bottom:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, ";", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.xl */ .W0.xl, ";}");
var LoadingContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian217"
})("display:flex;align-items:center;justify-content:center;");
var FeeBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian218"
})("display:flex;flex-direction:column;gap:10px;margin-top:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.m */ .W0.m, ";padding:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.l */ .W0.l, ";border:1px solid\n    ", function(param) {
    var isError = param.isError;
    return isError ? _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.red */ .DG.red : _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray400 */ .DG.gray400;
}, ";border-radius:0.75rem;");
var FeeColumn = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian219"
})("display:flex;flex-direction:column;");
var FeeRow = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian220"
})("display:flex;justify-content:space-between;");
var TotalBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian221"
})("padding-top:10px;border-top:1px solid ", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.gray400 */ .DG.gray400, ";");
var DescriptionText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p", {
    target: "e4vian222"
})("word-break:break-all;");
var ButtonGroup = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e4vian223"
})("display:flex;align-items:center;justify-content:center;gap:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.s */ .W0.s, ";button{flex:1;font-weight:600;}", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .breakpoints.down */ .AV.down("md"), "{flex-direction:column;button{width:100%;max-width:100%;}}");
var OfferAcceptModal = function(param) {
    var isOpen = param.isOpen, isClicked = param.isClicked, isLoading = param.isLoading, name = param.name, currency = param.currency, toUsdPrice = param.toUsdPrice, price = param.price, contractAddress = param.contractAddress, imgUrl = param.imgUrl, network = param.network, isPostable = param.isPostable, handleOpen = param.handleOpen, handleAccept = param.handleAccept;
    var ref = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)("Fee", /*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(function() {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_10__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api_order__WEBPACK_IMPORTED_MODULE_3__/* .getFeeValue */ .Kr)({
                            network: network,
                            contractAddress: contractAddress
                        })
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    }), {
        refetchOnWindowFocus: false
    }), fee = ref.data, isFeeLoading = ref.isLoading, isFeeError = ref.isError;
    var feeValues = (0,hooks_useFeeValues__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(fee, price.toString()).feeValues;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Modal */ .u_, {
        width: {
            xl: "500px",
            xxl: "500px"
        },
        isOpen: isOpen,
        handleOpen: handleOpen,
        shouldCloseOnOverlayClick: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ModalTitleBlock, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ModalTitle, {
                        children: "Accept this offer"
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(ModalContentsBlock, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(ItemColumn, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Label, {
                                    children: "Item"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(LabelValue, {
                                    children: "Subtotal"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(ItemInfoBlock, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ImageBox, {
                                    children: /.(mp4|mov)$/.test(imgUrl) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_components_Video__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                        isPlaydapp: false,
                                        src: imgUrl,
                                        muted: true,
                                        autoPlay: true,
                                        playsInline: true,
                                        loop: true
                                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_components_Image__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        src: imgUrl,
                                        alt: name
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(InfoBox, {
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ItemName, {
                                            children: name
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(PriceBox, {
                                            children: [
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(IconBox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_components_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                                            name: "currency-".concat(currency.toLowerCase()),
                                                            size: "24px"
                                                        }),
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Price, {
                                                            children: price
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(CurrencyBox, {
                                                    children: toUsdPrice && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(UsdPrice, {
                                                        children: [
                                                            "(≈ $",
                                                            toUsdPrice,
                                                            ")"
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FeeBlock, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Label, {
                                    children: "Fee"
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(FeeBox, {
                                    isError: isFeeError,
                                    children: isFeeLoading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(LoadingContainer, {
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Progress */ .Ex, {
                                            type: "spinner",
                                            color: _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.primary600 */ .DG.primary600
                                        })
                                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .Fragment */ .HY, {
                                        children: [
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FeeRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Label, {
                                                        children: "PlayDapp"
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(LabelValue, {
                                                        children: [
                                                            feeValues.playdapp.price,
                                                            " ",
                                                            currency,
                                                            " (",
                                                            (feeValues.playdapp.percent * 100).toFixed(1),
                                                            "%)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FeeRow, {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FeeColumn, {
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Label, {
                                                                children: "Developer "
                                                            }),
                                                            "(or Creator)"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(LabelValue, {
                                                        children: [
                                                            feeValues.developer.price,
                                                            " ",
                                                            currency,
                                                            " (",
                                                            (feeValues.developer.percent * 100).toFixed(1),
                                                            "%)"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(TotalBlock, {
                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(FeeRow, {
                                                    children: [
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(Label, {
                                                            color: _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.primary600 */ .DG.primary600,
                                                            children: "Total"
                                                        }),
                                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(LabelValue, {
                                                            color: _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.primary600 */ .DG.primary600,
                                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("b", {
                                                                children: [
                                                                    feeValues.total.price,
                                                                    " ",
                                                                    currency,
                                                                    " (",
                                                                    (feeValues.total.percent * 100).toFixed(1),
                                                                    "%)"
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        isFeeError ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(DescriptionText, {
                            children: "An error occurred while getting fee data."
                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(DescriptionText, {
                            children: [
                                "You can get",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)(Label, {
                                    color: _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.primary600 */ .DG.primary600,
                                    children: [
                                        (isFeeLoading ? 0 : Number(price) - feeValues.total.price).toFixed(4),
                                        " ",
                                        currency,
                                        " ",
                                        toUsdPrice && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsxs */ .BX)("span", {
                                            children: [
                                                "(≈ $",
                                                toUsdPrice,
                                                ")"
                                            ]
                                        })
                                    ]
                                }),
                                " ",
                                "when the sale completes."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(ButtonGroup, {
                    children: isLoading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Progress */ .Ex, {
                        type: "spinner",
                        color: _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .palette.primary600 */ .DG.primary600
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zx, {
                        onClick: handleAccept,
                        isActive: isClicked,
                        disabled: isClicked || !isPostable,
                        children: "Accept"
                    })
                }),
                !isPostable && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__/* .jsx */ .tZ)(_components_WarningText__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                    marginTop: "-20px",
                    children: "This asset does not have metadata and cannot be accepted for offer."
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OfferAcceptModal);


/***/ }),

/***/ 7681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10166);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70917);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69293);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(18722);
/* harmony import */ var _components_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69583);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      width: 100%;\n      font-size: ",
        ";\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      background: ",
        ";\n      color: ",
        ";\n      cursor: not-allowed;\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








var DropDownBlock = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "e6jhujf0"
})("display:flex;position:relative;flex-direction:column;");
var FilterArrowIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_components_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e6jhujf1"
})("transition:0.3s;");
var DropDownBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "e6jhujf2"
})("display:flex;align-items:center;justify-content:space-between;width:", function(param) {
    var width = param.width;
    return !width ? "340px" : "".concat(width, "px");
}, ";height:", function(param) {
    var height = param.height;
    return height && height;
}, "px;padding:", function(param) {
    var isDropBox = param.isDropBox;
    return isDropBox ? "".concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .spacing.s */ .W0.s, " ").concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .spacing.l */ .W0.l) : _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .spacing.s */ .W0.s;
}, ";border:", function(param) {
    var isBorder = param.isBorder;
    return isBorder && "1px solid ".concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray500 */ .DG.gray500);
}, ";border-bottom:", function(param) {
    var isMobile = param.isMobile;
    return !isMobile && "1px solid ".concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray600 */ .DG.gray600);
}, ";border-radius:", function(param) {
    var isBorder = param.isBorder;
    return isBorder && _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .spacing.xs */ .W0.xs;
}, ";font-size:", function(param) {
    var isDropBox = param.isDropBox;
    return isDropBox ? _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.p3 */ .JB.p3 : _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.p4 */ .JB.p4;
}, ";font-weight:400;background-color:", function(param) {
    var isOpen = param.isOpen;
    return isOpen ? "".concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray200 */ .DG.gray200) : "".concat(_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.white */ .DG.white);
}, ";color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.dgray400 */ .DG.dgray400, ";cursor:pointer;", function(param) {
    var isMobile = param.isMobile;
    return isMobile && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject(), _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .fontSize.p5 */ .JB.p5);
}, " ", function(param) {
    var disabled = param.disabled;
    return disabled && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject1(), _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray200 */ .DG.gray200, _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray600 */ .DG.gray600);
}, "    &:hover{background-color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.gray100 */ .DG.gray100, ";}", FilterArrowIcon, "{transform:", function(param) {
    var isOpen = param.isOpen;
    return isOpen && "rotateX(180deg)";
}, ";}");
var DropDownContent = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("div", {
    target: "e6jhujf3"
})("display:flex;position:", function(param) {
    var floatingContent = param.floatingContent;
    return floatingContent && "absolute";
}, ";top:", function(param) {
    var floatingContent = param.floatingContent, top = param.top;
    return floatingContent && top ? top : "0";
}, "px;flex-direction:column;width:100%;min-width:", function(param) {
    var isMobile = param.isMobile, theme = param.theme;
    return isMobile && theme.rem(200);
}, ";z-index:", function(param) {
    var floatingContent = param.floatingContent;
    return floatingContent && "10";
}, ";color:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.dgray200 */ .DG.dgray200, ";", (0,_playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .fontStyle */ .p_)("p3"), "  border-radius:8px;border:1px solid #f5f5f7;box-shadow:0px 20px 32px rgba(76,79,110,0.1);background:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_4__/* .palette.white */ .DG.white, ";&:last-of-type{border-bottom:0;}");
var SortByDropDown = function(param) {
    var className = param.className, title = param.title, collectionName = param.collectionName, width = param.width, height = param.height, isBorder = param.isBorder, floatingContent = param.floatingContent, top = param.top, children = param.children, isMobile = param.isMobile, isDropBox = param.isDropBox, isClose = param.isClose, disabled = param.disabled;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var containerElement = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react_use__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(containerElement, function() {
        setIsOpen(false);
    });
    var handleToggle = function() {
        setIsOpen(!isOpen);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setIsOpen(collectionName === "all");
    }, [
        collectionName
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (isClose) {
            setIsOpen(false);
        }
    }, [
        isClose
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(DropDownBlock, {
        className: className,
        ref: containerElement,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(DropDownBox, {
                width: width,
                height: height,
                isBorder: isBorder,
                onClick: handleToggle,
                isMobile: isMobile,
                isDropBox: isDropBox,
                disabled: disabled,
                isOpen: isOpen,
                children: [
                    title,
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(FilterArrowIcon, {
                        name: "chevron-down-0206",
                        size: 10,
                        className: classnames__WEBPACK_IMPORTED_MODULE_3___default()({
                            open: isOpen
                        })
                    })
                ]
            }),
            isOpen && !disabled && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(DropDownContent, {
                floatingContent: !!floatingContent,
                top: top,
                isMobile: isMobile,
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                children: children
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SortByDropDown);


/***/ }),

/***/ 3385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10166);
/* harmony import */ var _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18722);


var WarningText = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("p", {
    target: "ehdr51h0"
})("margin-top:", function(param) {
    var marginTop = param.marginTop;
    return marginTop || _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .spacing.l */ .W0.l;
}, ";font-size:", _playdapp_ui__WEBPACK_IMPORTED_MODULE_1__/* .fontSize.p4 */ .JB.p4, ";color:#ef586e;");
/* harmony default export */ __webpack_exports__["Z"] = (WarningText);


/***/ }),

/***/ 97124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ contents_MyPageContent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/@playdapp/ui/dist/index.esm.js
var index_esm = __webpack_require__(18722);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(94829);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/lib/auth.ts
var auth = __webpack_require__(62913);
// EXTERNAL MODULE: ./src/lib/util.ts
var util = __webpack_require__(80871);
// EXTERNAL MODULE: ./src/store/merge.ts
var merge = __webpack_require__(8858);
// EXTERNAL MODULE: ./src/store/hooks.ts
var hooks = __webpack_require__(57345);
// EXTERNAL MODULE: ./src/api/user.ts
var user = __webpack_require__(50101);
// EXTERNAL MODULE: ./src/hooks/useTokenCurrency.ts
var useTokenCurrency = __webpack_require__(27475);
// EXTERNAL MODULE: ./src/components/LoadingLayer.tsx
var LoadingLayer = __webpack_require__(59479);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/lib/network/index.ts
var lib_network = __webpack_require__(94511);
// EXTERNAL MODULE: ./src/hooks/useOpenControl.ts
var useOpenControl = __webpack_require__(60335);
// EXTERNAL MODULE: ./src/hooks/useLIstingCancel.ts
var useLIstingCancel = __webpack_require__(25752);
// EXTERNAL MODULE: ./src/hooks/useCheckNetwork.ts
var useCheckNetwork = __webpack_require__(4046);
// EXTERNAL MODULE: ./src/api/order.ts
var order = __webpack_require__(28171);
// EXTERNAL MODULE: ./src/store/marketplace.ts
var marketplace = __webpack_require__(60152);
// EXTERNAL MODULE: ./src/store/marketplaceSolana.ts + 9 modules
var marketplaceSolana = __webpack_require__(75090);
// EXTERNAL MODULE: ./src/components/Button.tsx
var components_Button = __webpack_require__(68663);
// EXTERNAL MODULE: ./src/components/SortByDropDown.tsx
var components_SortByDropDown = __webpack_require__(7681);
// EXTERNAL MODULE: ./src/components/Table/index.tsx + 7 modules
var Table = __webpack_require__(54179);
// EXTERNAL MODULE: ./src/components/Modal/CancelModal.tsx
var CancelModal = __webpack_require__(91169);
// EXTERNAL MODULE: ./src/components/Modal/CancelSuccessModal.tsx
var CancelSuccessModal = __webpack_require__(40385);
// EXTERNAL MODULE: ./src/components/Modal/TransactionModal.tsx + 2 modules
var TransactionModal = __webpack_require__(91097);
// EXTERNAL MODULE: ./src/components/Modal/OfferAcceptModal.tsx
var OfferAcceptModal = __webpack_require__(70027);
// EXTERNAL MODULE: ./src/components/Modal/TransactionResultModal.tsx
var TransactionResultModal = __webpack_require__(20508);
// EXTERNAL MODULE: ./src/components/EmptyItem.tsx
var EmptyItem = __webpack_require__(8665);
// EXTERNAL MODULE: ./src/components/MetaTag.tsx
var MetaTag = __webpack_require__(7590);
// EXTERNAL MODULE: ./src/components/ErrorContents.tsx
var ErrorContents = __webpack_require__(2732);
;// CONCATENATED MODULE: ./src/components/MyOffers.tsx































var OffersBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq10"
})("position:relative;");
var SelectOptionArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq11"
})("display:flex;justify-content:flex-end;align-items:center;width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{flex-direction:column;justify-content:space-between;align-items:flex-start;width:100%;height:auto;margin-bottom:1rem;}");
var OfferEventDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e1870nq12"
})("position:relative;align-items:flex-end;font-size:", index_esm/* fontSize.b4 */.JB.b4, ";font-weight:600;", index_esm/* breakpoints.down */.AV.down("lg"), "{display:none;}");
var MobileOfferEventDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e1870nq13"
})("display:none;", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;align-items:flex-end;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(200);
}, ";order:2;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:block;align-items:flex-end;width:100%;max-width:100%;margin-right:", index_esm/* spacing.m */.W0.m, ";order:1;}");
var ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq14"
})("width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(540);
}, ";");
var DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq15"
})("display:flex;flex-direction:column;border-radius:", index_esm/* spacing.xs */.W0.xs, ";");
var CollectionLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq16"
})("display:flex;justify-content:flex-start;width:100%;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";font-size:", index_esm/* fontSize.b3 */.JB.b3, ";font-weight:600;border:none;cursor:pointer;& > span{flex:none;}&:first-of-type{border-top-left-radius:", index_esm/* spacing.xs */.W0.xs, ";border-top-right-radius:", index_esm/* spacing.xs */.W0.xs, ";}&:last-of-type{border-bottom-left-radius:", index_esm/* spacing.xs */.W0.xs, ";border-bottom-right-radius:", index_esm/* spacing.xs */.W0.xs, ";}p{margin-left:", index_esm/* spacing.s */.W0.s, ";padding-top:1px;margin-bottom:-1px;}&:hover{background-color:", index_esm/* palette.gray300 */.DG.gray300, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.b4 */.JB.b4, ";}");
var CategoryListBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq17"
})("display:flex;flex-direction:column;align-items:flex-start;");
var LoadMore = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e1870nq18"
})("display:flex;align-items:center;height:", index_esm/* spacing.xxl */.W0.xxl, ";padding:6px ", index_esm/* spacing.m */.W0.m, ";margin:", index_esm/* spacing.l */.W0.l, " auto;border-radius:6px;& + a,a + &{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}");
var EmptyItemBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1870nq19"
})("display:flex;flex-direction:column;align-items:center;margin-top:10rem;gap:", index_esm/* spacing.xl */.W0.xl, ";button{color:", index_esm/* palette.white */.DG.white, ";font-weight:600;border-radius:1.5rem;}");
var offerEvent = {
    Made: "Offers made",
    Received: "Offers received"
};
var MyOffers = function() {
    var ref, ref1, ref2;
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var ref3 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), activeChainId = ref3.activeChainId, account = ref3.account;
    var alias = (0,hooks/* useAppSelector */.C)(function(param) {
        var user = param.user;
        return user;
    }).alias;
    var ref4 = (0,react.useState)(null), transactionModalStatus = ref4[0], setTransactionModalStatus = ref4[1];
    var ref5 = (0,hooks/* useAppSelector */.C)(function(param) {
        var marketplace = param.marketplace;
        return marketplace;
    }), txStatus = ref5.txStatus, transactionHash = ref5.transactionHash;
    var ref6 = (0,hooks/* useAppSelector */.C)(function(param) {
        var marketplaceSolana = param.marketplaceSolana;
        return marketplaceSolana;
    }), solanaTxStatus = ref6.txStatus;
    var ref7 = (0,useTokenCurrency/* default */.Z)(), currencyList = ref7.currencyList, convertToUsd = ref7.convertToUsd;
    var network = (0,react.useMemo)(function() {
        return lib_network/* chainIdToMainNetworkName */.$4[activeChainId];
    }, [
        activeChainId
    ]);
    var ref8 = (0,react.useState)(false), isClose = ref8[0], setIsClose = ref8[1];
    var ref9 = (0,react.useState)(false), isClicked = ref9[0], setIsClicked = ref9[1];
    var ref10 = (0,react.useState)({
        title: "All Event",
        value: "All"
    }), event = ref10[0], setEvent = ref10[1];
    var ref11 = (0,react.useState)(null), selectedOffer = ref11[0], setSelectedOffer = ref11[1];
    var ref12 = (0,react.useState)(false), isCancelLoading = ref12[0], setIsCancelLoading = ref12[1];
    var ref13 = (0,react.useState)(false), isAcceptLoading = ref13[0], setIsAcceptLoading = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isTransactionResultModalOpen = ref14[0], handleTransactionResultModalOpen = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isTransactionModalOpen = ref15[0], handleTransactionModalOpen = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isAcceptModalOpen = ref16[0], handleAcceptModalOpen = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isCancelModalOpen = ref17[0], handleCancelModalOpen = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isCancelSuccessModalOpen = ref18[0], handleCancelSuccessModalOpen = ref18[1];
    var ref19 = (0,react.useState)("success"), transactionResultModalType = ref19[0], setTransactionResultModalType = ref19[1];
    var isPostable = (0,react.useMemo)(function() {
        return selectedOffer ? !!selectedOffer.name : false;
    }, [
        selectedOffer
    ]);
    var ref20 = (0,useLIstingCancel/* default */.Z)(), isCancelListing = ref20.isCancelListing, handleCancelListing = ref20.handleCancelListing;
    var checkIsWrongNetwork = (0,useCheckNetwork/* default */.Z)().checkIsWrongNetwork;
    var fetchOfferList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 0 : _pageParam;
                        return [
                            4,
                            (0,user/* getMyOffers */.cI)({
                                network: network,
                                offset: pageParam,
                                count: 10,
                                type: event.value,
                                account: account
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                from: pageParam * 10,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchOfferList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref21 = (0,es.useInfiniteQuery)([
        "myOffers",
        event.value,
        alias
    ], fetchOfferList, {
        getNextPageParam: function(lastPage) {
            if (Math.floor(lastPage.count / 10) >= lastPage.nextPage && lastPage.count > 10) {
                return lastPage.nextPage;
            }
        },
        enabled: !!alias,
        refetchOnWindowFocus: false,
        cacheTime: 0
    }), isLoading = ref21.isLoading, offersData = ref21.data, fetchNextPage = ref21.fetchNextPage, refetch = ref21.refetch, hasNextPage = ref21.hasNextPage, error = ref21.error;
    var handleClearTxStatus = function() {
        dispatch((0,marketplace/* clearTxStatus */.Tz)());
        dispatch((0,marketplaceSolana/* clearTxStatus */.Tz)());
    };
    var toggleAcceptModal = function(isOpen, offer) {
        return function() {
            handleAcceptModalOpen(isOpen);
            setSelectedOffer(offer);
        };
    };
    var toggleCancelModal = function(isOpen, offer) {
        handleCancelModalOpen(isOpen);
        setSelectedOffer(offer);
    };
    var handleEvent = function(offerEventParam) {
        return function() {
            if (event.value !== offerEventParam.value) {
                setEvent(offerEventParam);
            }
            setIsClose(true);
        };
    };
    var handleLoadMore = function() {
        fetchNextPage();
    };
    var toggleTransactionResultModal = function(isOpen) {
        handleTransactionResultModalOpen(isOpen);
        refetch();
        handleClearTxStatus();
    };
    var analyticsToPurchase = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var contractAddress, ref, ref1, ref2, ref3, resFee, ref4, usd, fee, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(selectedOffer && selectedOffer.contractAddress)) return [
                        3,
                        4
                    ];
                    contractAddress = selectedOffer.contractAddress;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0,order/* getFeeValue */.Kr)({
                            network: network,
                            contractAddress: contractAddress
                        })
                    ];
                case 2:
                    ref3 = _state.sent(), resFee = ref3.data;
                    usd = (ref4 = convertToUsd(selectedOffer.price, network, selectedOffer.currency)) !== null && ref4 !== void 0 ? ref4 : 0;
                    fee = ((ref = resFee.playdapp) === null || ref === void 0 ? void 0 : ref.eventFee) ? resFee === null || resFee === void 0 ? void 0 : (ref1 = resFee.playdapp) === null || ref1 === void 0 ? void 0 : ref1.eventFee : resFee === null || resFee === void 0 ? void 0 : (ref2 = resFee.playdapp) === null || ref2 === void 0 ? void 0 : ref2.baseFee;
                    window.dataLayer.push({
                        event: "purchase",
                        transaction_id: transactionHash !== null && transactionHash !== void 0 ? transactionHash : "".concat(selectedOffer.tokenId, "-").concat(selectedOffer.price),
                        affiliation: "PlayDapp Marketplace",
                        value: +selectedOffer.price * +fee * (1 / 100) * +usd,
                        currency: "usd",
                        fee: fee,
                        tax: 0,
                        shipping: 0,
                        items: {
                            item_id: selectedOffer.tokenId,
                            item_name: selectedOffer.name,
                            affiliation: "PlayDapp Marketplace"
                        }
                    });
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    // TODO: failure sending data to analytics
                    console.error(e);
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }), [
        network,
        selectedOffer,
        transactionHash,
        convertToUsd
    ]);
    var handleAccept = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var orderId, tokenId, contractAddress, pda, params, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        if (!account) {
                            return [
                                2
                            ];
                        }
                        if (checkIsWrongNetwork(network)) {
                            return [
                                2
                            ];
                        }
                        if (!selectedOffer) return [
                            2
                        ];
                        orderId = selectedOffer.orderId, tokenId = selectedOffer.tokenId, contractAddress = selectedOffer.contractAddress, pda = selectedOffer.pda;
                        if (network === "solana") {
                            setIsAcceptLoading(true);
                            dispatch((0,marketplaceSolana/* fulfillBuyOffer */.Vb)({
                                pda: pda || ""
                            }));
                            return [
                                2
                            ];
                        }
                        params = {
                            tokenId: tokenId,
                            assetId: contractAddress,
                            accountAddress: account,
                            orderId: orderId
                        };
                        setIsClicked(true);
                        return [
                            4,
                            dispatch((0,marketplace/* manageAcceptRequest */.f9)(params))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsClicked(false);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleAccept() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCancel = function() {
        if (!selectedOffer) {
            return;
        }
        var orderId = selectedOffer.orderId, from = selectedOffer.from, pda = selectedOffer.pda;
        if (network === "solana") {
            setIsCancelLoading(true);
            dispatch((0,marketplaceSolana/* cancelBuyOrder */.L8)({
                pda: pda || ""
            }));
            return;
        }
        handleCancelListing({
            orderId: orderId,
            network: network,
            address: from,
            callback: function() {
                handleCancelSuccessModalOpen(true);
                handleCancelModalOpen(false);
                setSelectedOffer(null);
                refetch();
            }
        });
    };
    (0,react.useEffect)(function() {
        if (!selectedOffer) return;
        switch(txStatus || solanaTxStatus){
            case "INITIALIZE_PROXY":
            case "APPROVE_ALL_ASSETS":
            case "APPROVE_ASSET":
                setTransactionModalStatus(txStatus);
                handleTransactionModalOpen(true);
                handleAcceptModalOpen(false);
                break;
            case "APPROVE_CURRENCY":
                setTransactionModalStatus("APPROVE_CURRENCY_".concat(selectedOffer.currency.toUpperCase()));
                handleTransactionModalOpen(true);
                handleAcceptModalOpen(false);
                break;
            case "FULFILL_ORDER":
                setTransactionModalStatus("FULFILL_ORDER_OFFER_ACCEPT");
                handleTransactionModalOpen(true);
                handleAcceptModalOpen(false);
                break;
            case "TX_SUCCESS":
                handleTransactionResultModalOpen(true);
                setTransactionResultModalType("success");
                handleTransactionModalOpen(false);
                setTransactionModalStatus("");
                analyticsToPurchase();
                setIsCancelLoading(false);
                setIsAcceptLoading(false);
                if (solanaTxStatus) {
                    toggleCancelModal(false, null);
                    toggleAcceptModal(false, null);
                }
                break;
            case "TX_FAILED":
                handleTransactionResultModalOpen(true);
                setTransactionResultModalType("error");
                handleTransactionModalOpen(false);
                setTransactionModalStatus("");
                setIsCancelLoading(false);
                setIsAcceptLoading(false);
                if (solanaTxStatus) {
                    toggleCancelModal(false, null);
                    toggleAcceptModal(false, null);
                }
                break;
            default:
                break;
        }
    }, [
        txStatus,
        solanaTxStatus,
        selectedOffer,
        handleAcceptModalOpen,
        handleTransactionModalOpen,
        handleTransactionResultModalOpen,
        analyticsToPurchase, 
    ]);
    (0,react.useEffect)(function() {
        if (isClose) {
            setIsClose(function() {
                return false;
            });
        }
    }, [
        isClose
    ]);
    (0,react.useEffect)(function() {
        refetch();
    }, [
        alias,
        refetch
    ]);
    (0,react.useEffect)(function() {
        return function() {
            handleClearTxStatus();
        };
    }, [
        dispatch
    ]);
    var _name;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaTag/* default */.Z, {
                title: "My Offers | PlayDapp"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OffersBlock, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectOptionArea, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferEventDrop, {
                                title: event.title,
                                width: "266",
                                height: "48",
                                top: "48",
                                isBorder: true,
                                isDropBox: true,
                                floatingContent: true,
                                isClose: isClose,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropDownSortContent, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CategoryListBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "All Event",
                                                    value: "all"
                                                }),
                                                children: "All Event"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "Offers received",
                                                    value: "Received"
                                                }),
                                                children: "Offers received"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "Offers made",
                                                    value: "Made"
                                                }),
                                                children: "Offers made"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileOfferEventDrop, {
                                title: event.title,
                                width: "100%",
                                height: "36",
                                top: "40",
                                isBorder: true,
                                isDropBox: true,
                                floatingContent: true,
                                isMobile: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DropDownSortContent, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CategoryListBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "All Event",
                                                    value: "all"
                                                }),
                                                children: "All Event"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "Offers received",
                                                    value: "offersReceived"
                                                }),
                                                children: "Offers received"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionLink, {
                                                onClick: handleEvent({
                                                    title: "Offers made",
                                                    value: "offersMade"
                                                }),
                                                children: "Offers made"
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentBody, {
                        children: [
                            !error && (offersData === null || offersData === void 0 ? void 0 : offersData.pages) && (offersData === null || offersData === void 0 ? void 0 : offersData.pages.length) > 0 && ((ref = offersData === null || offersData === void 0 ? void 0 : offersData.pages[0].offers) === null || ref === void 0 ? void 0 : ref.length) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyItemBlock, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {
                                        text: "No Offers yet"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Button/* default */.Z, {
                                        to: "/nfts/".concat(network, "/all"),
                                        children: "Find assets you can bid on"
                                    })
                                ]
                            }),
                            !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItemBlock, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                            }),
                            ((ref1 = offersData === null || offersData === void 0 ? void 0 : offersData.pages[0].offers) === null || ref1 === void 0 ? void 0 : ref1.length) !== 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default */.Z, {
                                        title: "Offers",
                                        headers: [
                                            "Event",
                                            "Token ID",
                                            "NFT Name",
                                            "Offer Price",
                                            "Date",
                                            "Status", 
                                        ],
                                        children: offersData === null || offersData === void 0 ? void 0 : offersData.pages.map(function(offerData) {
                                            var offers = offerData.offers;
                                            return offers === null || offers === void 0 ? void 0 : offers.map(function(info, idx) {
                                                var ref;
                                                /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default.MyOfferItem */.Z.MyOfferItem, {
                                                    name: info.tokenName,
                                                    event: offerEvent[info.type],
                                                    tokenId: info.tokenId,
                                                    tokenAddress: info.assetAddress,
                                                    price: info.price,
                                                    currency: (ref = info.currencySymbol) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
                                                    toUsdPrice: convertToUsd(info.price, network, info.currencySymbol.toUpperCase()),
                                                    expirationTime: info.statusTime,
                                                    isOwner: info.type === "Received",
                                                    isBidder: info.type === "Made",
                                                    status: info.status,
                                                    network: network,
                                                    image: info.tokenImgUrl,
                                                    handleAccept: toggleAcceptModal(true, {
                                                        orderId: info.orderId,
                                                        name: info.tokenName,
                                                        imgUri: info.tokenImgUrl,
                                                        tokenId: info.tokenId,
                                                        price: info.price,
                                                        from: info.maker,
                                                        currency: info.currencySymbol,
                                                        contractAddress: info.assetAddress,
                                                        pda: info.pda
                                                    }),
                                                    handleCancel: function() {
                                                        return toggleCancelModal(true, {
                                                            orderId: info.orderId,
                                                            name: info.tokenName,
                                                            imgUri: info.tokenImgUrl,
                                                            price: info.price,
                                                            from: info.maker,
                                                            currency: info.currencySymbol,
                                                            pda: info.pda
                                                        });
                                                    }
                                                }, "my-offer-item-".concat(info.orderId, "-").concat(idx));
                                            });
                                        })
                                    }),
                                    hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadMore, {
                                        onClick: handleLoadMore,
                                        size: "xs",
                                        variant: "outline",
                                        color: "secondary",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            color: "dgray600",
                                            type: "p5",
                                            children: "Load More +"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    !!offersData && currencyList && selectedOffer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OfferAcceptModal/* default */.Z, {
                        isOpen: isAcceptModalOpen,
                        isClicked: isClicked,
                        isLoading: isAcceptLoading,
                        imgUrl: selectedOffer.imgUri,
                        name: (_name = selectedOffer.name) !== null && _name !== void 0 ? _name : "",
                        toUsdPrice: convertToUsd(selectedOffer === null || selectedOffer === void 0 ? void 0 : selectedOffer.price, network, selectedOffer === null || selectedOffer === void 0 ? void 0 : selectedOffer.currency.toUpperCase()),
                        price: selectedOffer === null || selectedOffer === void 0 ? void 0 : selectedOffer.price,
                        currency: selectedOffer === null || selectedOffer === void 0 ? void 0 : selectedOffer.currency.toUpperCase(),
                        network: network,
                        contractAddress: selectedOffer.contractAddress,
                        isPostable: isPostable,
                        handleOpen: toggleAcceptModal(false, null),
                        handleAccept: handleAccept
                    }),
                    !!offersData && selectedOffer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CancelModal/* default */.Z, {
                        isOpen: isCancelModalOpen,
                        isCancelListing: isCancelListing || isCancelLoading,
                        title: selectedOffer.name,
                        type: "offer",
                        images: [
                            selectedOffer.imgUri
                        ],
                        handleOpen: handleCancelModalOpen,
                        handleClose: function() {
                            return toggleCancelModal(false, null);
                        },
                        handleCancel: handleCancel
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CancelSuccessModal/* default */.Z, {
                        isOpen: isCancelSuccessModalOpen,
                        network: network,
                        handleOpen: handleCancelSuccessModalOpen,
                        type: ""
                    }),
                    selectedOffer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransactionModal/* default */.Z, {
                        isOpen: isTransactionModalOpen,
                        handleOpen: handleTransactionModalOpen,
                        status: transactionModalStatus,
                        network: network,
                        shouldCloseOnOverlayClick: false,
                        stepTypeSubFix: "AcceptOffer",
                        currency: selectedOffer === null || selectedOffer === void 0 ? void 0 : (ref2 = selectedOffer.currency) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase(),
                        txHash: transactionHash
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransactionResultModal/* default */.Z, {
                        isOpen: isTransactionResultModalOpen,
                        handleOpen: function() {
                            return toggleTransactionResultModal(false);
                        },
                        type: transactionResultModalType,
                        network: network,
                        txHash: transactionHash
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var components_MyOffers = (MyOffers);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var react_redux_es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/react-intersection-observer.m.js
var react_intersection_observer_m = __webpack_require__(70131);
// EXTERNAL MODULE: ./node_modules/lodash/times.js
var times = __webpack_require__(98913);
var times_default = /*#__PURE__*/__webpack_require__.n(times);
// EXTERNAL MODULE: ./node_modules/graphql-request/dist/index.js
var dist = __webpack_require__(28687);
// EXTERNAL MODULE: ./src/lib/parseData.ts
var parseData = __webpack_require__(19673);
// EXTERNAL MODULE: ./src/api/graphql/fragments.ts
var fragments = __webpack_require__(71181);
// EXTERNAL MODULE: ./src/api/graphql/index.ts
var graphql = __webpack_require__(80082);
;// CONCATENATED MODULE: ./src/api/graphql/getMyAssets.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query GetAssets(\n    $count: Int!\n    $from: Int!\n    $orOperations: [[MatchFilter]]\n    $andOperations: [MatchFilter]\n    $rangeFilters: [RangeFilter]\n    $sortBy: SortBy\n    $sortAscending: Boolean\n    $fieldKeysForGroupBy: [String]\n    $fieldKeysForRange: [String]\n  ) {\n    asset(\n      count: $count\n      from: $from\n      orOperations: $orOperations\n      andOperations: $andOperations\n      rangeFilters: $rangeFilters\n      sortBy: $sortBy\n      sortAscending: $sortAscending\n      fieldKeysForGroupBy: $fieldKeysForGroupBy\n      fieldKeysForRange: $fieldKeysForRange\n    ) {\n      total\n      groupByFieldKey\n      rangeByFieldKey\n      assets {\n        ...Asset\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var GET_MY_ITEMS = (0,dist.gql)(_templateObject(), fragments/* Asset */.xR);
var getMyItemsData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(params) {
        var data, _asset, total, assets, assetList;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        graphql/* default.request */.ZP.request(GET_MY_ITEMS, params)
                    ];
                case 1:
                    data = _state.sent();
                    _asset = data.asset, total = _asset.total, assets = _asset.assets;
                    assetList = (0,parseData/* parseAssets */.Z)(assets);
                    return [
                        2,
                        {
                            total: total,
                            assets: assetList
                        }
                    ];
            }
        });
    });
    return function getMyItemsData(params) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var getMyAssets = (getMyItemsData);

// EXTERNAL MODULE: ./src/api/index.ts + 1 modules
var src_api = __webpack_require__(23773);
;// CONCATENATED MODULE: ./src/api/bridge.ts

var bridgeSend = function(param) {
    var tokenId = param.tokenId;
    return src_api/* default.post */.ZP.post("/bridge/send?network=ethereum", {
        tokenId: tokenId
    });
};
var bridgeReceive = function() {
    return src_api/* default.post */.ZP.post("/bridge/receive?network=polygon");
};
var bridgeCheck = function() {
    return api.get("/bridge?network=polygon");
};

// EXTERNAL MODULE: ./src/hooks/useToastMessage.tsx
var useToastMessage = __webpack_require__(35395);
// EXTERNAL MODULE: ./src/store/my-account.ts
var my_account = __webpack_require__(48318);
// EXTERNAL MODULE: ./src/components/Icon.tsx
var Icon = __webpack_require__(69583);
// EXTERNAL MODULE: ./src/components/Card.tsx + 2 modules
var Card = __webpack_require__(13851);
// EXTERNAL MODULE: ./src/components/Image.tsx
var components_Image = __webpack_require__(97349);
;// CONCATENATED MODULE: ./src/components/Modal/BridgeSendModal.tsx






var ModalContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt0"
})("display:flex;flex-direction:column;");
var ImageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt1"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;padding:", index_esm/* spacing.m */.W0.m, " 0;margin-bottom:", index_esm/* spacing.m */.W0.m, ";background-color:", index_esm/* palette.gray300 */.DG.gray300, ";border-radius:1rem;");
var ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt2"
})("display:flex;align-items:center;justify-content:center;position:relative;");
var ImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("figure", {
    target: "e1exa2vt3"
})("display:flex;align-items:center;margin-bottom:0;", index_esm/* breakpoints.down */.AV.down("md"), "{max-height:100px;max-width:100px;}");
var PlusImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(ImageBlock, {
    target: "e1exa2vt4"
})("margin:0;padding:0;", index_esm/* breakpoints.down */.AV.down("md"), "{max-height:30px;max-width:30px;}");
var ModalTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt5"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;gap:", index_esm/* spacing.s */.W0.s, ";margin-bottom:", index_esm/* spacing.xxl */.W0.xxl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{margin-bottom:", index_esm/* spacing.s */.W0.s, ";}");
var ModalTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "e1exa2vt6"
})("font-size:", index_esm/* fontSize.h3 */.JB.h3, ";font-weight:900;text-align:center;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.h5 */.JB.h5, ";}");
var ModalSubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt7"
})("font-size:", index_esm/* fontSize.p3 */.JB.p3, ";color:", index_esm/* palette.gray900 */.DG.gray900, ";text-align:center;");
var ButtonGroup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1exa2vt8"
})("display:flex;align-items:center;justify-content:center;gap:", index_esm/* spacing.s */.W0.s, ";button{flex:1;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(205);
}, ";font-weight:600;}", index_esm/* breakpoints.down */.AV.down("md"), "{flex-direction:column-reverse;button{width:100%;}}");
var BridgeSendModal = function(param) {
    var isOpen = param.isOpen, isSendClicked = param.isSendClicked, image = param.image, handleOpen = param.handleOpen, handleSend = param.handleSend;
    var ref = (0,react.useState)(0), step = ref[0], setStep = ref[1];
    var handleBridgeModal = function(isModalOpen) {
        handleOpen(isModalOpen);
        setStep(0);
    };
    var handleClickSendToPolygon = (0,react.useCallback)(function() {
        handleSend();
    }, [
        handleSend
    ]);
    var handleNext = function() {
        setStep(function(prev) {
            return prev + 1;
        });
    };
    var steps = (0,react.useMemo)(function() {
        return [
            {
                buttonName: "Next",
                clickEvent: handleNext,
                line1: "Convert the selected NFT to a 'Polygon' network version",
                line2: "When you convert for the first time, you’ll receive an additional PlayDapp Town R grade NFT"
            },
            {
                buttonName: "Send to Polygon",
                clickEvent: handleClickSendToPolygon,
                line1: "Network converting may take up to 3 days",
                line2: "Follow your wallet's instructions to send your asset"
            }, 
        ];
    }, [
        handleClickSendToPolygon
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
        isOpen: isOpen,
        handleOpen: handleBridgeModal,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalContent, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageBlock, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ImageContainer, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageBox, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                    src: image,
                                    alt: "random-r",
                                    width: "200px",
                                    height: "200px"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlusImage, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    name: "random-plus",
                                    size: 50
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageBox, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                    src: "/assets/images/random-r.png",
                                    alt: "random-r",
                                    width: "200px",
                                    height: "200px"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalTitleBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalTitle, {
                            children: [
                                "Send to Polygon (",
                                step + 1,
                                "/2)"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ModalSubTitle, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: steps[step].line1
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: steps[step].line2
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ButtonGroup, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                        onClick: steps[step].clickEvent,
                        isActive: isSendClicked,
                        size: "lg",
                        children: steps[step].buttonName
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_BridgeSendModal = (BridgeSendModal);

;// CONCATENATED MODULE: ./src/components/Modal/BridgeReceiveModal.tsx






var BridgeReceiveModal_ModalContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg0"
})("display:flex;flex-direction:column;");
var BridgeReceiveModal_ImageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg1"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;padding:", index_esm/* spacing.m */.W0.m, " 0;margin-bottom:", index_esm/* spacing.m */.W0.m, ";background-color:", function(param) {
    var isAvailable = param.isAvailable;
    return isAvailable ? index_esm/* palette.gray300 */.DG.gray300 : index_esm/* palette.white */.DG.white;
}, ";border-radius:1rem;");
var BridgeReceiveModal_ImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg2"
})("display:flex;align-items:center;justify-content:center;position:relative;");
var BridgeReceiveModal_ImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("figure", {
    target: "eivuojg3"
})("display:flex;align-items:center;margin-bottom:0;", index_esm/* breakpoints.down */.AV.down("md"), "{max-height:100px;max-width:100px;}");
var BridgeReceiveModal_ModalTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg4"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;gap:", index_esm/* spacing.s */.W0.s, ";margin-bottom:", index_esm/* spacing.xxl */.W0.xxl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{margin-bottom:", index_esm/* spacing.s */.W0.s, ";}");
var BridgeReceiveModal_ModalTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("h3", {
    target: "eivuojg5"
})("font-size:", index_esm/* fontSize.h3 */.JB.h3, ";font-weight:900;text-align:center;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.h5 */.JB.h5, ";}");
var BridgeReceiveModal_ModalSubTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg6"
})("font-size:", index_esm/* fontSize.p3 */.JB.p3, ";color:", index_esm/* palette.gray900 */.DG.gray900, ";text-align:center;");
var BridgeReceiveModal_ButtonGroup = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eivuojg7"
})("display:flex;align-items:center;justify-content:center;gap:", index_esm/* spacing.s */.W0.s, ";button{flex:1;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(205);
}, ";font-weight:600;}", index_esm/* breakpoints.down */.AV.down("md"), "{flex-direction:column-reverse;button{width:100%;}}");
var BridgeReceivedModal = function(param) {
    var isOpen = param.isOpen, handleOpen = param.handleOpen, handleReceive = param.handleReceive, items = param.items, _isAvailable = param.isAvailable, isAvailable = _isAvailable === void 0 ? false : _isAvailable, _isClicked = param.isClicked, isClicked = _isClicked === void 0 ? false : _isClicked;
    var info = (0,react.useMemo)(function() {
        return [
            {
                title: "Receive from ETH",
                line1: function(count) {
                    return "There are [".concat(count, "] NFTs transferred from the ETH market.");
                },
                line2: "Would you like to receive NFTs?"
            },
            {
                title: "There is no NFT to receive",
                line1: function() {
                    return "Make sure that the transaction of the NFT transferred from the ETH market has been completed.";
                }
            }, 
        ];
    }, []);
    var toggleClose = function(isModalOpen) {
        return function() {
            handleOpen(isModalOpen);
        };
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
        isOpen: isOpen,
        handleOpen: toggleClose(false),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BridgeReceiveModal_ModalContent, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal_ImageBlock, {
                    isAvailable: isAvailable,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal_ImageContainer, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal_ImageBox, {
                            children: isAvailable && items.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                src: items[0].image,
                                alt: "random-r",
                                width: "200px",
                                height: "200px"
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                name: "close-red",
                                size: 72
                            })
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BridgeReceiveModal_ModalTitleBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal_ModalTitle, {
                            children: isAvailable ? info[0].title : info[1].title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal_ModalSubTitle, {
                            children: isAvailable ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        children: info[0].line1(items.length)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        children: info[0].line2
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                children: info[1].line1()
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BridgeReceiveModal_ButtonGroup, {
                    children: [
                        isAvailable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                            onClick: handleReceive,
                            isActive: isClicked,
                            size: "lg",
                            children: "Receive"
                        }),
                        !isAvailable && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                            onClick: toggleClose(false),
                            size: "lg",
                            children: "OK"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BridgeReceiveModal = (BridgeReceivedModal);

// EXTERNAL MODULE: ./node_modules/@ethersproject/units/lib.esm/index.js + 1 modules
var lib_esm = __webpack_require__(61744);
// EXTERNAL MODULE: ./node_modules/@ethersproject/contracts/lib.esm/index.js + 1 modules
var contracts_lib_esm = __webpack_require__(64146);
// EXTERNAL MODULE: ./node_modules/@ethersproject/constants/lib.esm/bignumbers.js
var bignumbers = __webpack_require__(21046);
// EXTERNAL MODULE: ./src/api/merge.ts
var api_merge = __webpack_require__(60355);
// EXTERNAL MODULE: ./src/store/filters.ts
var filters = __webpack_require__(19215);
// EXTERNAL MODULE: ./src/lib/web3/contract-address.ts
var contract_address = __webpack_require__(33942);
// EXTERNAL MODULE: ./src/data/merge.ts
var data_merge = __webpack_require__(66533);
// EXTERNAL MODULE: ./src/data/contracts/plaToken.json
var plaToken = __webpack_require__(85046);
;// CONCATENATED MODULE: ./src/data/contracts/presaleToken.json
var presaleToken_namespaceObject = JSON.parse('[{"inputs":[{"internalType":"uint256","name":"cap","type":"uint256"},{"internalType":"string","name":"tokenURIBase","type":"string"},{"internalType":"uint256","name":"tokenIdBase","type":"uint256"}],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"approved","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"owner","type":"address"},{"indexed":true,"internalType":"address","name":"operator","type":"address"},{"indexed":false,"internalType":"bool","name":"approved","type":"bool"}],"name":"ApprovalForAll","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousSaleContract","type":"address"},{"indexed":true,"internalType":"address","name":"newSaleContract","type":"address"}],"name":"SaleContractTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"from","type":"address"},{"indexed":true,"internalType":"address","name":"to","type":"address"},{"indexed":true,"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"approve","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"baseURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"burn","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"getApproved","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"address","name":"operator","type":"address"}],"name":"isApprovedForAll","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"name","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"ownerOf","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"renounceOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"safeTransferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"operator","type":"address"},{"internalType":"bool","name":"approved","type":"bool"}],"name":"setApprovalForAll","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes4","name":"interfaceId","type":"bytes4"}],"name":"supportsInterface","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"symbol","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"owner","type":"address"},{"internalType":"uint256","name":"index","type":"uint256"}],"name":"tokenOfOwnerByIndex","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"tokenURI","outputs":[{"internalType":"string","name":"","type":"string"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"totalSupply","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"from","type":"address"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"}],"name":"transferFrom","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"newOwner","type":"address"}],"name":"transferOwnership","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"_tokenId","type":"uint256"}],"name":"exists","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"string","name":"tokenURIBase","type":"string"}],"name":"setBaseTokenURI","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"_to","type":"address"}],"name":"mint","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"cap","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[],"name":"saleContract","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function","constant":true},{"inputs":[{"internalType":"address","name":"newSaleContract","type":"address"}],"name":"setSaleContract","outputs":[],"stateMutability":"nonpayable","type":"function"}]');
// EXTERNAL MODULE: ./src/components/Modal/BalanceModal.tsx
var BalanceModal = __webpack_require__(74903);
// EXTERNAL MODULE: ./src/components/Modal/EmailVerifyModal.tsx
var EmailVerifyModal = __webpack_require__(1797);
// EXTERNAL MODULE: ./src/components/Redirect.tsx
var Redirect = __webpack_require__(20282);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);

;// CONCATENATED MODULE: ./src/lib/recaptcha.ts
var recaptcha = {
    develop: "6Lej-CcdAAAAAEigVoP1O90eEW-1s1iqpCLotr8G",
    production: "6Lc9iCgdAAAAAIdhEeFiaeKYgLTKm7hRMWwJPFSN"
};
/* harmony default export */ var lib_recaptcha = (recaptcha);

;// CONCATENATED MODULE: ./src/components/GoogleReCaptcha.tsx





var Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14zzjlg0"
})("display:", function(param) {
    var isHidden = param.isHidden;
    return isHidden ? "none" : "flex";
}, ";align-items:center;justify-content:center;margin-top:", index_esm/* spacing.m */.W0.m, ";");
var GoogleReCaptcha = function(param) {
    var recaptcha = param.recaptcha, handleChange = param.handleChange;
    var siteKey =  true ? lib_recaptcha.production : 0;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container, {
        isHidden: !!recaptcha,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(esm, {
            sitekey: siteKey,
            onChange: handleChange,
            theme: "light",
            type: "image",
            hl: "en"
        })
    });
};
/* harmony default export */ var components_GoogleReCaptcha = (GoogleReCaptcha);

// EXTERNAL MODULE: ./src/styles/Color.ts
var Color = __webpack_require__(56933);
;// CONCATENATED MODULE: ./src/components/Merge/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: #ffffff;\n      color: ",
        ";\n\n      ::after {\n        content: '';\n        position: absolute;\n        bottom: -1px;\n        width: 100%;\n        border-bottom: 1px solid white;\n      }\n    "
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        grid-template-columns: repeat(2, 1fr);\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: block;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      height: 100%;\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 100%;\n      "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        display: grid;\n        grid-template-columns: repeat(3, 1fr);\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      filter: grayscale(100%);\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: 156px;\n      height: 180px;\n      margin-right: ",
        ";\n\n      ",
        " {\n        margin-right: 0;\n      }\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background: #ffffff;\n\n      a {\n        display: block;\n      }\n\n      :hover {\n        background: ",
        ";\n      }\n\n      :active {\n        background: ",
        ";\n      }\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}




var slideLeft = /*#__PURE__*/ (0,emotion_react_browser_esm/* keyframes */.F4)("0%{transform:translateX(100%);}100%{transform:translateX(0);}");
var PageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke00"
})(index_esm/* breakpoints.down */.AV.down("md"), "{position:fixed;top:0;left:0;width:100%;height:100%;overflow-y:auto;z-index:10;background-color:#ffffff;transition:left 0.5s;animation:", slideLeft, " 0.5s;}");
var PageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke01"
})(index_esm/* breakpoints.down */.AV.down("md"), "{padding:0 ", index_esm/* spacing.xl */.W0.xl, ";margin-top:-42px;}");
var MobileHeader = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke02"
})("display:none;", index_esm/* breakpoints.down */.AV.down("md"), "{position:sticky;top:0;left:0;display:flex;justify-content:space-between;align-items:center;width:100%;height:4rem;padding:0 ", index_esm/* spacing.xl */.W0.xl, ";background-color:#ffffff;z-index:3;}");
var MobileButtonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke03"
})("display:none;", index_esm/* breakpoints.down */.AV.down("md"), "{position:sticky;top:calc(100% - 62px);display:flex;justify-content:center;align-items:center;width:", function(param) {
    var theme = param.theme;
    return theme.rem(318);
}, ";height:2.5rem;margin:0 auto;z-index:2;}");
var MobileClearButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke04"
})("margin-right:", index_esm/* spacing.m */.W0.m, ";");
var MobileButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke05"
})("z-index:2;");
var MobileHeaderTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke06"
})("span{font-weight:600;color:", index_esm/* palette.primary600 */.DG.primary600, ";}");
var MergeBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke07"
})("width:100%;", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.xs */.W0.xs, ";}");
var TabBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke08"
})("display:flex;width:100%;height:3rem;");
var TabItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke09"
})("position:relative;display:flex;align-items:center;justify-content:center;flex:1;max-width:274px;height:100%;border:1px solid ", index_esm/* palette.gray400 */.DG.gray400, ";border-radius:8px 8px 0 0;border-bottom:none;z-index:2;background-color:", index_esm/* palette.gray400 */.DG.gray400, ";cursor:pointer;font-weight:600;color:", index_esm/* palette.gray900 */.DG.gray900, ";:nth-of-type(2){margin-left:", index_esm/* spacing.xxs */.W0.xxs, ";margin-right:", index_esm/* spacing.xxs */.W0.xxs, ";}", function(param) {
    var isSelected = param.isSelected;
    return isSelected && (0,emotion_react_browser_esm/* css */.iv)(style_templateObject(), index_esm/* palette.black */.DG.black);
}, ";", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p4 */.JB.p4, ";}@media (max-width:480px){:nth-of-type(2){margin-left:2px;margin-right:2px;}}");
var TabNotification = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke010"
})("position:absolute;top:8px;right:8px;width:0.5rem;height:0.5rem;border-radius:50%;background-color:", index_esm/* palette.red500 */.DG.red500, ";");
var DragonTextBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke011"
})("text-align:center;line-height:16px;.light{font-weight:400;}");
var CharacterBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke012"
})("display:grid;grid-template-columns:2fr 1fr;padding:", index_esm/* spacing.xl */.W0.xl, ";padding-right:0 !important;background-color:#ffffff;border:1px solid ", index_esm/* palette.gray400 */.DG.gray400, ";border-radius:0 16px 16px 16px;z-index:1;overflow:hidden;", index_esm/* breakpoints.down */.AV.down("xxl"), "{", function(param) {
    var isDragon = param.isDragon;
    return isDragon && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1());
}, "}", index_esm/* breakpoints.down */.AV.down("lg"), "{padding:", index_esm/* spacing.m */.W0.m, ";}@media (max-width:900px){border-radius:0 0 16px 16px;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:block;padding:0;}");
var CharacterSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke013"
})("display:grid;grid-template-columns:", function(param) {
    var isDragon = param.isDragon;
    return !isDragon && "repeat(2, 1fr)";
}, ";grid-gap:", index_esm/* spacing.m */.W0.m, ";z-index:2;", index_esm/* breakpoints.down */.AV.down("xxl"), "{", function(param) {
    var isDragon = param.isDragon;
    return isDragon && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2());
}, "}", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;}");
var CharacterBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke014"
})("display:flex;flex-direction:column;align-items:center;padding:", index_esm/* spacing.xl */.W0.xl, ";background-color:", index_esm/* palette.gray100 */.DG.gray100, ";border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";border-radius:12px;", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0 0 ", index_esm/* spacing.m */.W0.m, " 0;background-color:#ffffff;border:none;border-bottom:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";}@media (max-width:359px){padding:", index_esm/* spacing.s */.W0.s, " 0;}");
var CharacterTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke015"
})("display:flex;margin-bottom:", index_esm/* spacing.l */.W0.l, ";span{font-size:", index_esm/* fontSize.p3 */.JB.p3, ";font-weight:600;color:", index_esm/* palette.black */.DG.black, ";}span.joker{display:flex;align-items:center;justify-content:center;width:50px;height:15px;margin-top:", index_esm/* spacing.xxs */.W0.xxs, ";margin-left:", index_esm/* spacing.xs */.W0.xs, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";border-radius:2px;color:#ffffff;background:linear-gradient(136.35deg,#9b6cea 1.37%,#06acf9 97.61%);}");
var CharacterListBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke016"
})("display:grid;grid-template-columns:repeat(3,1fr);grid-gap:", index_esm/* spacing.l */.W0.l, ";", function(param) {
    var isSingle = param.isSingle;
    return isSingle && (0,emotion_react_browser_esm/* css */.iv)(_templateObject3());
}, ";", index_esm/* breakpoints.up */.AV.up("xxl"), "{", function(param) {
    var isDragon = param.isDragon;
    return isDragon && (0,emotion_react_browser_esm/* css */.iv)(_templateObject4());
}, ";}", index_esm/* breakpoints.down */.AV.down("xxl"), "{grid-template-columns:", function(param) {
    var isSrPlaydappTown = param.isSrPlaydappTown;
    return isSrPlaydappTown ? "repeat(3, 1fr)" : "repeat(2, 1fr)";
}, ";", function(param) {
    var isDragon = param.isDragon;
    return isDragon && (0,emotion_react_browser_esm/* css */.iv)(_templateObject5());
}, "}", index_esm/* breakpoints.down */.AV.down("xl"), "{grid-template-columns:", function(param) {
    var isDragon = param.isDragon;
    return isDragon ? "repeat(3, 1fr)" : "repeat(2, 1fr)";
}, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{grid-template-columns:repeat(3,1fr);grid-gap:", index_esm/* spacing.s */.W0.s, ";}");
var Character = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke017"
})("position:relative;border:3px solid transparent;border-radius:8px;background-image:linear-gradient(#fff,#fff),linear-gradient(to right,#74d1fc 0%,#2bcab0 100%);background-origin:border-box;background-clip:content-box,border-box;cursor:", function(param) {
    var isCursorPointer = param.isCursorPointer;
    return isCursorPointer ? "pointer" : "auto";
}, ";", function(param) {
    var isPurchase = param.isPurchase;
    return isPurchase && (0,emotion_react_browser_esm/* css */.iv)(_templateObject6());
}, ";div.selected{position:absolute;display:flex;align-items:center;justify-content:center;top:0;width:100%;height:100%;border-radius:4px;background:rgba(71,215,191,0.4);backdrop-filter:blur(4px);}");
var CharacterCount = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke018"
})("position:absolute;display:flex;align-items:center;justify-content:center;right:-12px;top:-12px;width:1.5rem;height:1.5rem;font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:600;color:#ffffff;background-color:", index_esm/* palette.primary600 */.DG.primary600, ";border-radius:50%;z-index:1;");
var CharacterButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke019"
})("display:flex;align-items:center;justify-content:center;width:6.875rem;height:1.5rem;margin-top:", index_esm/* spacing.s */.W0.s, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:600;", index_esm/* breakpoints.down */.AV.down("sm"), "{max-width:84px;}@media (max-width:359px){max-width:64px;font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}");
var JokerCountBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke020"
})("display:flex;justify-content:space-between;align-items:center;width:110px;height:1.5rem;margin-top:", index_esm/* spacing.s */.W0.s, ";", index_esm/* breakpoints.down */.AV.down("sm"), "{width:84px;}@media (max-width:359px){width:64px;}");
var JokerCountButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke021"
})("width:1.5rem;height:1.5rem;padding:0;border-radius:50%;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p4 */.JB.p4, ";}@media (max-width:359px){width:1.25rem;height:1.25rem;padding:0;font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}");
var MergeButtonSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke022"
})("position:relative;display:flex;align-items:center;justify-content:center;flex-direction:", function(param) {
    var isDragon = param.isDragon;
    return isDragon ? "row" : "column";
}, ";width:100%;z-index:1;.merge-button-bg01,.merge-button-bg02{position:absolute;width:100%;height:100%;background-repeat:no-repeat;}.merge-button-bg01{top:-5%;left:-30%;background-image:-webkit-image-set(\n      url(https://images.playdapp.com/marketplace-dev/merge/merge-button-bg01.png) 1x,url(https://images.playdapp.com/marketplace-dev/merge/merge-button-bg01@2x.png) 2x\n    );background-size:100% 100%;}.merge-button-bg02{top:0;left:10%;background-image:-webkit-image-set(\n      url(https://images.playdapp.com/marketplace-dev/merge/merge-button-bg02_2.png) 1x,url(https://images.playdapp.com/marketplace-dev/merge/merge-button-bg02_2@2x.png) 2x\n    );background-size:100% 100%;}span{width:100% !important;max-width:155.45px;}", index_esm/* breakpoints.down */.AV.down("xxl"), "{.merge-button-bg01{left:-40%;background-size:100% 75%;}}", index_esm/* breakpoints.down */.AV.down("lg"), "{flex-direction:column;.merge-button-bg01{top:5%;left:-40%;background-size:110% 60%;}}", index_esm/* breakpoints.down */.AV.down("md"), "{display:none;}");
var MergeButtonImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke023"
})("width:183px;height:209px;background-image:", function(param) {
    var selectedTab = param.selectedTab;
    return selectedTab && "-webkit-image-set(\n    url(https://images.playdapp.com/marketplace-dev/merge/".concat(selectedTab.toLocaleLowerCase(), "_result2.png) 1x,\n    url(https://images.playdapp.com/marketplace-dev/merge/").concat(selectedTab.toLocaleLowerCase(), "_result2@2x.png) 2x\n  )");
}, ";z-index:1;", function(param) {
    var selectedTab = param.selectedTab;
    return selectedTab === "PLAYDAPP_DRAGON_R" && (0,emotion_react_browser_esm/* css */.iv)(_templateObject7(), index_esm/* spacing.xxl */.W0.xxl, index_esm/* breakpoints.down */.AV.down("lg"));
});
var MergeButtonBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke024"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;");
var SelectedStatusBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke025"
})("z-index:0;span{color:", index_esm/* palette.black */.DG.black, ";&.strong{font-size:", index_esm/* fontSize.h3 */.JB.h3, ";font-weight:600;color:", index_esm/* palette.primary600 */.DG.primary600, ";}&.max{font-size:", index_esm/* fontSize.p1 */.JB.p1, ";font-weight:600;}}");
var SelectedJokerStatusBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke026"
})("z-index:0;text-align:center;span.strong{font-size:", index_esm/* fontSize.p1 */.JB.p1, ";font-weight:600;color:", index_esm/* palette.primary600 */.DG.primary600, ";}");
var CustomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke027"
})("margin-top:", index_esm/* spacing.m */.W0.m, ";z-index:0;");
var CostBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke028"
})("margin-top:", index_esm/* spacing.xs */.W0.xs, ";z-index:0;span{font-size:", index_esm/* fontSize.p3 */.JB.p3, ";color:", index_esm/* palette.black */.DG.black, ";}");
var ExplainBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke029"
})("display:flex;justify-content:space-between;margin-top:2.5rem;padding:0 ", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.down */.AV.down("xl"), "{padding:0;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:block;padding-bottom:1rem;}");
var ExplainSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke030"
})("width:calc(100% - 360px);padding-right:10rem;p.title{font-weight:600;}p.desc{font-size:", index_esm/* fontSize.p3 */.JB.p3, ";margin-top:", index_esm/* spacing.xs */.W0.xs, ";}p.desc + p.title{margin-top:", index_esm/* spacing.xxl */.W0.xxl, ";}", index_esm/* breakpoints.down */.AV.down("xxl"), "{padding-right:4rem;}", index_esm/* breakpoints.down */.AV.down("xl"), "{padding-right:6rem;}", index_esm/* breakpoints.down */.AV.down("lg"), "{width:calc(100% - 312px);padding-right:", index_esm/* spacing.xl */.W0.xl, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;padding-right:0;p.desc + p.title{margin-top:", index_esm/* spacing.xl */.W0.xl, ";}}");
var GuideSection = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke031"
})("width:22.5rem;", index_esm/* breakpoints.down */.AV.down("lg"), "{width:19.5rem;}", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;margin-top:2.5rem;margin-bottom:4rem;}");
var GuideBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke032"
})("padding:", index_esm/* spacing.m */.W0.m, ";box-shadow:0px 4px 8px rgba(21,22,25,0.05);backdrop-filter:blur(4px);border-radius:16px;cursor:pointer;background:linear-gradient(90deg,#fbfffb 10.87%,#eafbfc 97.01%);transition:background-color 0.2s;a{display:flex;justify-content:space-between;align-items:center;}:hover{background:linear-gradient(\n        0deg,rgba(9,81,149,0.05),rgba(9,81,149,0.05)\n      ),linear-gradient(90deg,#ffffff 10.87%,#fbfffb 74.13%,#eafbfc 97.01%);}:active{background:linear-gradient(\n        0deg,rgba(9,81,149,0.1),rgba(9,81,149,0.1)\n      ),linear-gradient(90deg,#ffffff 10.87%,#fbfffb 74.13%,#eafbfc 97.01%);}:nth-of-type(n + 2){margin-top:", index_esm/* spacing.l */.W0.l, ";}", function(param) {
    var isExplore = param.isExplore;
    return isExplore && (0,emotion_react_browser_esm/* css */.iv)(_templateObject8(), index_esm/* palette.gray100 */.DG.gray100, index_esm/* palette.gray200 */.DG.gray200);
});
var GuideTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke033"
})("width:100%;max-width:", function(param) {
    var isExplore = param.isExplore;
    return isExplore ? "none" : "210px";
}, ";");
var GuideTitleBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke034"
})("span{font-weight:600;color:", index_esm/* palette.blue700 */.DG.blue700, ";}");
var GuideDescBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke035"
})("margin-top:", index_esm/* spacing.s */.W0.s, ";line-height:16px;span{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";color:", index_esm/* palette.black */.DG.black, ";}");
var GuideExploreButtonBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke036"
})("display:flex;justify-content:flex-end;margin-top:", index_esm/* spacing.s */.W0.s, ";");
var GuideExploreButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e4koke037"
})("padding:", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.m */.W0.m, ";background-color:", index_esm/* palette.blue500 */.DG.blue500, ";color:#ffffff;font-size:", index_esm/* fontSize.p3 */.JB.p3, ";font-weight:600;border-radius:24px;transition:background-color 0.2s;:hover{background-color:", function() {
    return (0,Color/* default */.Z)(index_esm/* palette.blue500 */.DG.blue500).darker(5);
}, ";}");
var ErrorBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke038"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;", index_esm/* breakpoints.down */.AV.down("md"), "{height:", function(param) {
    var theme = param.theme;
    return theme.rem(400);
}, ";}");
var ErrorTitleBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke039"
})("margin-top:", index_esm/* spacing.xl */.W0.xl, ";span{font-size:", index_esm/* fontSize.h4 */.JB.h4, ";font-weight:800;color:", index_esm/* palette.black */.DG.black, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.l */.W0.l, ";span{font-size:", index_esm/* fontSize.p3 */.JB.p3, ";}}");
var ErrorDescBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e4koke040"
})("text-align:center;margin-top:", index_esm/* spacing.s */.W0.s, ";p{color:", index_esm/* palette.gray900 */.DG.gray900, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.xs */.W0.xs, ";p{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}}");
var RefreshButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e4koke041"
})("display:flex;align-items:center;margin-top:", index_esm/* spacing.m */.W0.m, ";span{margin-left:", index_esm/* spacing.xs */.W0.xs, ";font-weight:600;}", index_esm/* breakpoints.down */.AV.down("md"), "{span{font-size:", index_esm/* fontSize.p4 */.JB.p4, ";}}");
var ClearButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e4koke042"
})("position:absolute;top:-8px;right:16px;z-index:1;border:none;font-weight:600;font-size:", index_esm/* fontSize.p4 */.JB.p4, ";color:", index_esm/* palette.purple600 */.DG.purple600, ";padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.m */.W0.m, ";border-radius:12px;transition:background-color 0.2s;:hover{background-color:", (0,Color/* default */.Z)(index_esm/* palette.purple600 */.DG.purple600).fade(0.9), ";}");

;// CONCATENATED MODULE: ./src/components/Modal/MergeConfirmModal.tsx







var DRAGON_NAME_LIST = [
    "aeormara",
    "brisalid",
    "failaker",
    "hrosveru",
    "palamekid",
    "tyconros",
    "demetalir", 
];
var FlexDisplay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi0"
})("display:flex;align-items:center;justify-content:center;");
var MergeConfirmModal_ModalContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi1"
})("display:flex;flex-direction:column;");
var TokenBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi2"
})("width:100%;height:100%;min-height:164px;padding:", index_esm/* spacing.m */.W0.m, ";border-radius:0.5rem;border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";background-color:", index_esm/* palette.gray100 */.DG.gray100, ";text-align:center;");
var MergeConfirmModal_ImageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(FlexDisplay, {
    target: "eh36vsi3"
})("height:auto;min-height:72px;margin:", index_esm/* spacing.s */.W0.s, " 2px;");
var MergeConfirmModal_ImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi4"
})("position:relative;");
var TokenCount = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(CharacterCount, {
    target: "eh36vsi5"
})("right:-8px;top:-8px;width:1rem;height:1rem;font-size:", index_esm/* fontSize.p5 */.JB.p5, ";");
var MergeStatusBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi6"
})("width:100%;height:100%;margin-top:", index_esm/* spacing.xl */.W0.xl, ";text-align:center;", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.l */.W0.l, ";}");
var TokenBlockTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "eh36vsi7"
})("font-size:", index_esm/* fontSize.b4 */.JB.b4, ";font-weight:600;color:", index_esm/* palette.dgray300 */.DG.dgray300, ";", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.b4 */.JB.b4, ";}");
var StatusTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi8"
})("margin-bottom:", index_esm/* spacing.s */.W0.s, ";font-size:", index_esm/* fontSize.h3 */.JB.h3, ";font-weight:800;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.h4 */.JB.h4, ";font-weight:800;}");
var StatusDesc = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eh36vsi9"
})("color:", index_esm/* palette.gray900 */.DG.gray900, ";p + p{margin-top:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.b3 */.JB.b3, ";}");
var AgreeButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_Button/* default */.Z, {
    target: "eh36vsi10"
})("margin-top:", index_esm/* spacing.xxl */.W0.xxl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.l */.W0.l, ";}");
var MergeConfirmModal = function(param) {
    var isOpen = param.isOpen, selectedTab = param.selectedTab, selectedTokens = param.selectedTokens, isApproved = param.isApproved, recaptcha = param.recaptcha, handleOpen = param.handleOpen, handleFetchMerge = param.handleFetchMerge, handleReCAPTCHA = param.handleReCAPTCHA;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
        width: {
            lg: "500px",
            xl: "500px"
        },
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        handleOpen: handleOpen,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeConfirmModal_ModalContent, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenBlock, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TokenBlockTitle, {
                            children: "NFT characters to be used for merging"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MergeConfirmModal_ImageBlock, {
                            children: selectedTokens.map(function(item, idx) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeConfirmModal_ImageBox, {
                                    children: [
                                        DRAGON_NAME_LIST.includes(item.name) && item.tokens.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TokenCount, {
                                            children: item.tokens.length
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                            prefix: "s3",
                                            src: "/merge/".concat(item.name, "_").concat(selectedTab === "PLAYDAPP_TOWN_SR" ? "sr" : "r", "_success.png"),
                                            width: "72px",
                                            height: "72px",
                                            alt: item.name,
                                            layout: "intrinsic"
                                        })
                                    ]
                                }, "merge-confirm-modal-image-".concat(idx));
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                            type: "b5",
                            color: "red",
                            children: "NFT characters used for merging will be burned."
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeStatusBox, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusTitle, {
                            children: "Merge in progress..."
                        }),
                        isApproved && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StatusDesc, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: "By merging, your NFTs used for merging will be disabled."
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: "This prompt and wallet information will only appear once during the merge process."
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: "The detailed information about GAS FEE required for the merge will shown in the next step of meta mask approval stage."
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                    children: "please click OK to continue."
                                })
                            ]
                        }),
                        !isApproved && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatusDesc, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                children: "If all is correct, click OK to continue."
                            })
                        })
                    ]
                }),
                recaptcha ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AgreeButton, {
                    onClick: handleFetchMerge,
                    children: "OK"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_GoogleReCaptcha, {
                    recaptcha: recaptcha,
                    handleChange: handleReCAPTCHA
                })
            ]
        })
    });
};
/* harmony default export */ var Modal_MergeConfirmModal = (MergeConfirmModal);

// EXTERNAL MODULE: ./src/components/Modal/MergeErrorModal.tsx
var MergeErrorModal = __webpack_require__(78040);
;// CONCATENATED MODULE: ./src/components/Merge/index.tsx
/* eslint-disable no-continue */ /* eslint-disable no-plusplus */ /* eslint-disable no-await-in-loop */ /* eslint-disable no-nested-ternary */ 





































var Merge = function(param) {
    var handleToggleMerge = param.handleToggleMerge;
    var ref = (0,react.useState)("PLAYDAPP_TOWN_R"), selectedTab = ref[0], setSelectedTab = ref[1];
    var ref1 = (0,react.useState)([]), normalList = ref1[0], setNormalList = ref1[1];
    var ref2 = (0,react.useState)([]), jokerList = ref2[0], setJokerList = ref2[1];
    var ref3 = (0,react.useState)(null), mergeFee = ref3[0], setMergeFee = ref3[1];
    var ref4 = (0,react.useState)([]), selectedTokens = ref4[0], setSelectedTokens = ref4[1];
    var ref5 = (0,react.useState)(false), isJokerSelected = ref5[0], setIsJokerSelected = ref5[1];
    var ref6 = (0,react.useState)(false), isOwnerCheckLoading = ref6[0], setIsOwnerCheckLoading = ref6[1];
    var ref7 = (0,react.useState)([]), ownerTokenIds = ref7[0], setOwnerTokenIds = ref7[1];
    var ref8 = (0,react.useState)(data_merge/* INIT_MERGE_AVAILABLE */.C5), mergeAvailable = ref8[0], setMergeAvailable = ref8[1];
    var ref9 = (0,react.useState)(false), isOwnerCheckFail = ref9[0], setIsOwnerCheckFail = ref9[1];
    var ref10 = (0,react.useState)(false), isNeedPlayzV1Approve = ref10[0], setIsNeedPlayzV1Approve = ref10[1];
    var ref11 = (0,react.useState)(false), isNeedPlayzV2Approve = ref11[0], setIsNeedPlayzV2Approve = ref11[1];
    var ref12 = (0,react.useState)(false), isNeedDragonApprove = ref12[0], setIsNeedDragonApprove = ref12[1];
    var ref13 = (0,react.useState)(null), recaptcha = ref13[0], setRecaptcha = ref13[1];
    var ref14 = (0,react.useMemo)(function() {
        var selectedNormalCount = normalList ? Object.values(normalList).filter(function(item) {
            return item.isSelected;
        }).length : 0;
        var selectedJokerCounts = jokerList.map(function(item) {
            return item.tokens.filter(function(item2) {
                return "isSelected" in item2;
            }).length;
        });
        var selectedJokerCount = selectedJokerCounts.length ? selectedJokerCounts.reduce(function(acc, num) {
            return acc + num;
        }) : 0;
        var selectedTotalCount = selectedNormalCount + selectedJokerCount;
        return {
            selectedJokerCount: selectedJokerCount,
            selectedTotalCount: selectedNormalCount + selectedJokerCount,
            isSubmit: selectedTotalCount === data_merge/* MAX_SELECT_COUNT */._H && !isOwnerCheckLoading
        };
    }, [
        normalList,
        jokerList,
        isOwnerCheckLoading
    ]), selectedJokerCount = ref14.selectedJokerCount, selectedTotalCount = ref14.selectedTotalCount, isSubmit = ref14.isSubmit;
    var isDragon = (0,react.useMemo)(function() {
        return selectedTab === "PLAYDAPP_DRAGON_R";
    }, [
        selectedTab
    ]);
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isBalanceModalOpen = ref15[0], handleBalanceModalOpen = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isEmailModalOpen = ref16[0], handleEmailModalOpen = ref16[1];
    var ref17 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isMergeModalOpen = ref17[0], handleMergeModalOpen = ref17[1];
    var ref18 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isMergeErrorModalOpen = ref18[0], handleMergeErrorModalOpen = ref18[1];
    var ref19 = (0,useToastMessage/* default */.Z)({
        position: "top",
        duration: 5000
    }), handleUpdateToast = ref19.handleUpdateToast, handleCloseToast = ref19.handleCloseToast;
    var isMdDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")));
    var pageBlock = (0,react.useRef)(null);
    var ref20 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref20.account, activeChainId = ref20.activeChainId, balance = ref20.balance, library = ref20.library;
    var isVerified = (0,hooks/* useAppSelector */.C)(function(param) {
        var user = param.user;
        return user;
    }).isVerified;
    var mergeStatus = (0,hooks/* useAppSelector */.C)(function(param) {
        var merge = param.merge;
        return merge;
    }).mergeStatus;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var networkName = (0,react.useMemo)(function() {
        return activeChainId ? lib_network/* chainIdToMainNetworkName */.$4[activeChainId] : "";
    }, [
        activeChainId
    ]);
    var PLA_CONTRACT = library && new contracts_lib_esm/* Contract */.CH(contract_address["default"].token.pla[activeChainId || 137], plaToken, library.getSigner());
    var PLAYZ_V1_CONTRACT = (0,react.useMemo)(function() {
        if (!activeChainId) return null;
        return library && networkName === "polygon" ? new contracts_lib_esm/* Contract */.CH(contract_address["default"].token.playzV1[activeChainId || 137], presaleToken_namespaceObject, library.getSigner()) : null;
    }, [
        library,
        networkName
    ]);
    var PLAYZ_V2_CONTRACT = (0,react.useMemo)(function() {
        if (!activeChainId) return null;
        return library && networkName === "polygon" ? new contracts_lib_esm/* Contract */.CH(contract_address["default"].token.playzV2[activeChainId || 137], presaleToken_namespaceObject, library.getSigner()) : null;
    }, [
        library,
        networkName
    ]);
    var DRAGON_CONTRACT = (0,react.useMemo)(function() {
        if (!activeChainId) return null;
        return library && networkName === "polygon" ? new contracts_lib_esm/* Contract */.CH(contract_address["default"].token.playdappDragon[activeChainId || 137], presaleToken_namespaceObject, library.getSigner()) : null;
    }, [
        library,
        networkName
    ]);
    var PLAYDAPP_CONTRACT = contract_address["default"].token.playdapp[activeChainId || 137];
    var token = localStorage.getItem("PDMP_AUTH_TOKEN");
    var handleOwnerOf = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(tokenId, assetTitle) {
            var contract, ownerAddress;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!tokenId || !library) return [
                            2,
                            null
                        ];
                        contract = PLAYZ_V1_CONTRACT;
                        if (assetTitle === "PLAYZ V2") {
                            contract = PLAYZ_V2_CONTRACT;
                        } else if (assetTitle === "DRGNZ") {
                            contract = DRAGON_CONTRACT;
                        }
                        if (!contract) return [
                            2,
                            ""
                        ];
                        return [
                            4,
                            contract.ownerOf(tokenId)
                        ];
                    case 1:
                        ownerAddress = _state.sent();
                        return [
                            2,
                            ownerAddress
                        ];
                }
            });
        });
        return function handleOwnerOf(tokenId, assetTitle) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var PLAYDAPP_TOWN_ASSET_IDS, PLAYDAPP_DRAGON_ASSET_IDS, res, assets, playdappDragonAssetId, playdappTownList, playdappDragonList, playdappTownGroupBy, playdappDragonGroupBy, originalDragonR, originalTownR, originalTownSR, newNormalList, newJokerList;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!account || !activeChainId) {
                            throw new Error("No account or chainId");
                        }
                        PLAYDAPP_TOWN_ASSET_IDS = data_merge/* ASSET_IDS.PLAYDAPP_TOWN */.Zy.PLAYDAPP_TOWN[activeChainId];
                        PLAYDAPP_DRAGON_ASSET_IDS = data_merge/* ASSET_IDS.PLAYDAPP_DRAGON */.Zy.PLAYDAPP_DRAGON[activeChainId];
                        return [
                            4,
                            getMyAssets({
                                from: 0,
                                count: 9999,
                                andOperations: [
                                    {
                                        key: "order.sale",
                                        value: "$not_exist"
                                    },
                                    {
                                        key: "order.auction",
                                        value: "$not_exist"
                                    },
                                    {
                                        key: "owner",
                                        value: account
                                    },
                                    {
                                        key: "network",
                                        value: lib_network/* chainIdToMainNetworkName */.$4[activeChainId]
                                    }
                                ],
                                orOperations: [
                                    (0,_to_consumable_array/* default */.Z)(PLAYDAPP_TOWN_ASSET_IDS).concat((0,_to_consumable_array/* default */.Z)(PLAYDAPP_DRAGON_ASSET_IDS)),
                                    [
                                        {
                                            key: "attributes.Grade.keyword",
                                            value: "R"
                                        },
                                        {
                                            key: "attributes.Grade.keyword",
                                            value: "SR"
                                        }
                                    ]
                                ],
                                sortBy: "Transfer",
                                sortAscending: false
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        assets = res.assets;
                        playdappDragonAssetId = Number(PLAYDAPP_DRAGON_ASSET_IDS[0].value);
                        playdappTownList = assets.filter(function(item) {
                            return item.assetId !== playdappDragonAssetId;
                        });
                        playdappDragonList = assets.filter(function(item) {
                            return item.assetId === playdappDragonAssetId;
                        });
                        playdappTownGroupBy = lodash_default().groupBy(playdappTownList, "name");
                        playdappDragonGroupBy = lodash_default().groupBy(playdappDragonList, "name");
                        originalDragonR = data_merge/* INIT_DRAGON_R_LIST.map */.pO.map(function(item) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                isSelected: false,
                                count: item.apiName in playdappDragonGroupBy ? playdappDragonGroupBy[item.apiName].length : 0,
                                tokens: item.apiName in playdappDragonGroupBy ? playdappDragonGroupBy[item.apiName] : []
                            });
                        });
                        originalTownR = {
                            normal: data_merge/* INIT_TOWN_R_LIST.map */.x9.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    image: "".concat(item.image, "-r.png"),
                                    isSelected: false,
                                    count: item.apiName in playdappTownGroupBy ? playdappTownGroupBy[item.apiName].length : 0,
                                    tokens: item.apiName in playdappTownGroupBy ? playdappTownGroupBy[item.apiName] : []
                                });
                            }),
                            joker: (0,_to_consumable_array/* default */.Z)(originalDragonR)
                        };
                        originalTownSR = {
                            normal: data_merge/* INIT_TOWN_SR_LIST.map */.Md.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    image: "".concat(item.image, "-sr.png"),
                                    isSelected: false,
                                    count: item.apiName in playdappTownGroupBy ? playdappTownGroupBy[item.apiName].length : 0,
                                    tokens: item.apiName in playdappTownGroupBy ? playdappTownGroupBy[item.apiName] : []
                                });
                            }),
                            joker: [
                                {
                                    name: "demetalir",
                                    image: "/merge/demetalir-sr.png",
                                    isSelected: false,
                                    count: "Demetalir SR" in playdappDragonGroupBy ? playdappDragonGroupBy["Demetalir SR"].length : 0,
                                    tokens: "Demetalir SR" in playdappDragonGroupBy ? playdappDragonGroupBy["Demetalir SR"] : []
                                }
                            ]
                        };
                        newNormalList = isDragon ? originalDragonR : selectedTab === "PLAYDAPP_TOWN_R" ? originalTownR.normal : originalTownSR.normal;
                        newJokerList = isDragon ? [] : selectedTab === "PLAYDAPP_TOWN_R" ? originalTownR.joker : originalTownSR.joker;
                        setNormalList(newNormalList);
                        setJokerList(newJokerList);
                        return [
                            2,
                            {
                                originalDragonR: originalDragonR,
                                originalTownR: originalTownR,
                                originalTownSR: originalTownSR
                            }
                        ];
                }
            });
        });
        return function fetchList() {
            return _ref.apply(this, arguments);
        };
    }();
    var ref21 = (0,es.useQuery)([
        "merge",
        account
    ], fetchList, {
        enabled: !!account && !!activeChainId,
        refetchOnWindowFocus: false
    }), isLoading = ref21.isLoading, data = ref21.data, error = ref21.error, refetch = ref21.refetch;
    var handleClear = function(tab) {
        setSelectedTab(tab);
        setSelectedTokens([]);
        setIsJokerSelected(false);
        setIsNeedPlayzV1Approve(false);
        setIsNeedPlayzV2Approve(false);
        setIsNeedDragonApprove(false);
        setOwnerTokenIds([]);
        setRecaptcha(null);
    };
    var handleTabClick = function(tab, isClear) {
        return function() {
            if (!data || tab === selectedTab && !isClear) return;
            handleClear(tab);
            if (tab === "PLAYDAPP_TOWN_R") {
                setNormalList(data.originalTownR.normal);
                setJokerList(data.originalTownR.joker);
            }
            if (tab === "PLAYDAPP_TOWN_SR") {
                setNormalList(data.originalTownSR.normal);
                setJokerList(data.originalTownSR.joker);
            }
            if (tab === "PLAYDAPP_DRAGON_R") {
                setNormalList(data.originalDragonR);
                setJokerList([]);
            }
        };
    };
    var handleMergeClose = function() {
        if (pageBlock.current) {
            pageBlock.current.style.left = "100%";
        }
        setTimeout(function() {
            handleToggleMerge();
            if ("merge" in router.query) {
                router.push("/my-page/items");
            }
        }, 500);
    };
    var handlePurchaseClick = function(assetTitle, base, grade) {
        return function() {
            var link = data_merge/* PURCHASE_LINK */.lG[assetTitle][activeChainId];
            var PLAYDAPP_TOWN_ASSET_IDS = data_merge/* ASSET_IDS.PLAYDAPP_TOWN */.Zy.PLAYDAPP_TOWN[activeChainId];
            var PLAYDAPP_DRAGON_ASSET_IDS = data_merge/* ASSET_IDS.PLAYDAPP_DRAGON */.Zy.PLAYDAPP_DRAGON[activeChainId];
            var orOperations = [
                assetTitle === "PLAYDAPP_TOWN" ? PLAYDAPP_TOWN_ASSET_IDS : PLAYDAPP_DRAGON_ASSET_IDS,
                [
                    {
                        key: "attributes.Base.keyword",
                        value: assetTitle === "PLAYDAPP_TOWN" ? base.toUpperCase() : (0,util/* toPascalCase */.Mh)(base)
                    }, 
                ],
                [
                    {
                        key: "attributes.Grade.keyword",
                        value: grade
                    }, 
                ], 
            ];
            dispatch((0,filters/* setPrevUrl */.vF)("merge"));
            dispatch((0,filters/* setOrOperations */.Zx)(orOperations));
            setTimeout(function() {
                return router.push(link);
            }, 50);
        };
    };
    var handleOwnerCheckFail = function() {
        setIsOwnerCheckFail(true);
        handleMergeErrorModalOpen(true);
    };
    var handleOwnerCheck = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(assetList, selectedAssetName, needCount) {
            var ref, asset, newOwnerTokenIds, i, _i, assetTitle, tokenId, ownerAddress, totalOwnerTokenIds;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsOwnerCheckLoading(true);
                        asset = assetList.find(function(item) {
                            return item.name === selectedAssetName;
                        });
                        if (!asset || !((ref = asset.tokens) === null || ref === void 0 ? void 0 : ref.length)) return [
                            2,
                            false
                        ];
                        newOwnerTokenIds = [];
                        i = 0;
                        _state.label = 1;
                    case 1:
                        if (!(i < asset.tokens.length)) return [
                            3,
                            4
                        ];
                        _i = asset.tokens[i], assetTitle = _i.assetTitle, tokenId = _i.tokenId;
                        if (!assetTitle || !tokenId) {
                            return [
                                3,
                                3
                            ];
                        }
                        return [
                            4,
                            handleOwnerOf(parseInt(tokenId, 10), assetTitle)
                        ];
                    case 2:
                        ownerAddress = _state.sent();
                        if (newOwnerTokenIds.length === needCount) {
                            return [
                                3,
                                4
                            ];
                        }
                        if (account === ownerAddress) {
                            newOwnerTokenIds = newOwnerTokenIds.concat(tokenId);
                        }
                        _state.label = 3;
                    case 3:
                        i++;
                        return [
                            3,
                            1
                        ];
                    case 4:
                        totalOwnerTokenIds = (0,_to_consumable_array/* default */.Z)(newOwnerTokenIds).concat((0,_to_consumable_array/* default */.Z)(ownerTokenIds));
                        setOwnerTokenIds(lodash_default().uniq(totalOwnerTokenIds));
                        setIsOwnerCheckLoading(false);
                        return [
                            2,
                            newOwnerTokenIds.length === needCount
                        ];
                }
            });
        });
        return function handleOwnerCheck(assetList, selectedAssetName, needCount) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSelectClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(name, isAdd, isJoker) {
            var target, selectedCount, ownerCheck, isChange, newTokens, ownerCheck1, totalCount;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // 선택한 개수 총합이랑 최대선택개수랑 같고 plus면 리턴
                        if (selectedTotalCount === data_merge/* MAX_SELECT_COUNT */._H && isAdd) return [
                            2
                        ];
                        if (!isJoker) return [
                            3,
                            3
                        ];
                        target = jokerList.find(function(item) {
                            return item.name === name;
                        });
                        if (!target) return [
                            2
                        ];
                        selectedCount = target === null || target === void 0 ? void 0 : target.tokens.filter(function(item) {
                            return "isSelected" in item;
                        }).length;
                        // 선택한 카운트가 0이고 마이너스 일 경우 리턴
                        if (!selectedCount && !isAdd) return [
                            2
                        ];
                        // 선택한 조커 총합이 4보다 크고 plus일 경우 (조커는 최대 5개 선택 가능)
                        if (selectedJokerCount > 4 && isAdd) return [
                            2
                        ];
                        // 남은 카운트가 0이고 플러스 일 경우 리턴
                        if (!target.count && isAdd) return [
                            2
                        ];
                        if (!isAdd) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            handleOwnerCheck(jokerList, name, selectedCount + 1)
                        ];
                    case 1:
                        ownerCheck = _state.sent();
                        if (!ownerCheck) {
                            handleOwnerCheckFail();
                            return [
                                2
                            ];
                        }
                        _state.label = 2;
                    case 2:
                        isChange = false;
                        newTokens = target.tokens.map(function(item) {
                            // plus인 경우 isSelected가 없는 token에 하나만 isSelected 추가
                            if (!isChange && isAdd && !Object.keys(item).includes("isSelected")) {
                                isChange = true;
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    isSelected: true
                                });
                            }
                            // minus인 경우 첫번째로 isSelected가 있는 token의 isSelected를 삭제
                            if (!isChange && !isAdd && Object.keys(item).includes("isSelected")) {
                                isChange = true;
                                delete item.isSelected;
                                return (0,_object_spread/* default */.Z)({}, item);
                            }
                            return (0,_object_spread/* default */.Z)({}, item);
                        });
                        setJokerList(function(prev) {
                            return prev.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    isSelected: name === item.name ? selectedCount > 0 : item.isSelected,
                                    count: name === item.name ? isAdd ? item.count - 1 : item.count + 1 : item.count,
                                    tokens: name === item.name ? (0,_to_consumable_array/* default */.Z)(newTokens) : item.tokens
                                });
                            });
                        });
                        _state.label = 3;
                    case 3:
                        if (!!isJoker) return [
                            3,
                            6
                        ];
                        if (!isAdd) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleOwnerCheck(normalList, name, 1)
                        ];
                    case 4:
                        ownerCheck1 = _state.sent();
                        if (!ownerCheck1) {
                            handleOwnerCheckFail();
                            return [
                                2
                            ];
                        }
                        _state.label = 5;
                    case 5:
                        setNormalList(function(prev) {
                            return prev.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    isSelected: name === item.name ? !item.isSelected : item.isSelected,
                                    count: name === item.name ? isAdd ? item.count - 1 : item.count + 1 : item.count
                                });
                            });
                        });
                        _state.label = 6;
                    case 6:
                        totalCount = isAdd ? selectedTotalCount + 1 : selectedTotalCount - 1;
                        if (!isOwnerCheckLoading && totalCount === data_merge/* MAX_SELECT_COUNT */._H) {
                            handleUpdateToast("YOU HAVE SELECTED ALL ".concat(data_merge/* MAX_SELECT_COUNT */._H, " NFTs. YOU ARE NOW READY TO MERGE!"), "success", true);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSelectClick(name, isAdd, isJoker) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchMergeFee = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api_merge/* getMergeFee */.eq)()
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status !== 200) {
                            throw new Error("Fee Error");
                        }
                        setMergeFee(Number(res.data));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        setMergeFee(-1);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMergeFee() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchMergeAvailable = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api_merge/* getMergeAvailable */.tk)()
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.status !== 200) {
                            throw new Error("Available Error");
                        }
                        setMergeAvailable((0,_object_spread/* default */.Z)({}, res.data));
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        console.error(e);
                        setMergeAvailable(data_merge/* INIT_MERGE_AVAILABLE */.C5);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function fetchMergeAvailable() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var selectedAssetList, selectedNormalList, selectedJokerList, selectedJokerParseList, selectedTokenCount, playzV1Check, playzV2Check, playzV1IsApproved, playzV2IsApproved, dragonCheck, dragonIsApproved, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSubmit) return [
                            2
                        ];
                        handleCloseToast();
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        if (!balance || !mergeFee || !activeChainId || !PLAYZ_V1_CONTRACT || !PLAYZ_V2_CONTRACT || !DRAGON_CONTRACT || !ownerTokenIds.length) {
                            throw new Error("An unexpected error occurred");
                        }
                        if (!isVerified) {
                            handleEmailModalOpen(true);
                            return [
                                2
                            ];
                        }
                        if (balance.pla < mergeFee) {
                            handleBalanceModalOpen(true);
                            return [
                                2
                            ];
                        }
                        selectedAssetList = [];
                        selectedNormalList = normalList.filter(function(item) {
                            return item.isSelected;
                        });
                        if (selectedNormalList.length) {
                            selectedAssetList = selectedNormalList.map(function(item) {
                                var findOwnerToken = item.tokens.find(function(token) {
                                    return ownerTokenIds.includes(token.tokenId);
                                });
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    tokens: item.tokens.length && findOwnerToken ? [
                                        findOwnerToken
                                    ] : []
                                });
                            });
                        }
                        selectedJokerList = jokerList.filter(function(item) {
                            return item.tokens.filter(function(item2) {
                                return item2.isSelected;
                            }).length;
                        });
                        if (selectedJokerList.length) {
                            selectedJokerParseList = selectedJokerList.map(function(item) {
                                var selectedJokerTokens = item.tokens.filter(function(item2) {
                                    return item2.isSelected && ownerTokenIds.includes(item2.tokenId);
                                });
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    tokens: (0,_to_consumable_array/* default */.Z)(selectedJokerTokens)
                                });
                            });
                            selectedAssetList = (0,_to_consumable_array/* default */.Z)(selectedAssetList).concat((0,_to_consumable_array/* default */.Z)(selectedJokerParseList));
                            setIsJokerSelected(true);
                        }
                        selectedTokenCount = 0;
                        selectedAssetList.forEach(function(asset) {
                            selectedTokenCount += asset.tokens.length;
                        });
                        if (selectedTokenCount !== data_merge/* MAX_SELECT_COUNT */._H) {
                            console.error("fewer than ".concat(data_merge/* MAX_SELECT_COUNT */._H, " tokens in your possession"));
                            handleMergeErrorModalOpen(true);
                            return [
                                2
                            ];
                        }
                        setSelectedTokens(selectedAssetList);
                        if (!selectedNormalList.length) return [
                            3,
                            5
                        ];
                        playzV1Check = selectedNormalList.find(function(item) {
                            return item.tokens[0].assetId !== data_merge/* PLAYZ_V1_ASSET_ID */.Pi[activeChainId] && item.tokens[0].assetId !== 4;
                        });
                        playzV2Check = selectedNormalList.find(function(item) {
                            return item.tokens[0].assetId === data_merge/* PLAYZ_V2_ASSET_ID */.wD[activeChainId];
                        });
                        if (!playzV1Check) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            PLAYZ_V1_CONTRACT.isApprovedForAll(account, PLAYDAPP_CONTRACT)
                        ];
                    case 2:
                        playzV1IsApproved = _state.sent();
                        setIsNeedPlayzV1Approve(!playzV1IsApproved);
                        _state.label = 3;
                    case 3:
                        if (!playzV2Check) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            PLAYZ_V2_CONTRACT.isApprovedForAll(account, PLAYDAPP_CONTRACT)
                        ];
                    case 4:
                        playzV2IsApproved = _state.sent();
                        setIsNeedPlayzV2Approve(!playzV2IsApproved);
                        _state.label = 5;
                    case 5:
                        dragonCheck = selectedNormalList.find(function(item) {
                            return item.tokens[0].assetId === data_merge/* PLAYDAPP_DRAGON_ASSET_ID */.gU[activeChainId];
                        });
                        if (!(dragonCheck || selectedJokerList.length)) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            DRAGON_CONTRACT.isApprovedForAll(account, PLAYDAPP_CONTRACT)
                        ];
                    case 6:
                        dragonIsApproved = _state.sent();
                        setIsNeedDragonApprove(!dragonIsApproved);
                        _state.label = 7;
                    case 7:
                        handleMergeModalOpen(true);
                        return [
                            3,
                            9
                        ];
                    case 8:
                        e = _state.sent();
                        console.error(e);
                        handleMergeErrorModalOpen(true);
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSubmit() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleFetchMerge = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, resAllowance, txApprove, txApprove1, txApprove2, txApprove3, materials, payload, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dispatch((0,merge/* setMergeStatus */.DI)("loading"));
                        handleMergeModalOpen(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            15,
                            ,
                            16
                        ]);
                        if (!mergeFee || !activeChainId || !library || !PLA_CONTRACT || !PLAYZ_V1_CONTRACT || !PLAYZ_V2_CONTRACT || !DRAGON_CONTRACT || !recaptcha) {
                            throw new Error("An unexpected error occurred");
                        }
                        return [
                            4,
                            PLA_CONTRACT.allowance(account, PLAYDAPP_CONTRACT)
                        ];
                    case 2:
                        resAllowance = _state.sent();
                        if (!(parseFloat((0,lib_esm.formatEther)(resAllowance)) < parseFloat(mergeFee.toString()))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            PLA_CONTRACT.approve(PLAYDAPP_CONTRACT, bignumbers/* MaxUint256 */.Bz)
                        ];
                    case 3:
                        txApprove = _state.sent();
                        return [
                            4,
                            txApprove.wait()
                        ];
                    case 4:
                        _state.sent();
                        _state.label = 5;
                    case 5:
                        if (!isNeedPlayzV1Approve) return [
                            3,
                            8
                        ];
                        return [
                            4,
                            PLAYZ_V1_CONTRACT.setApprovalForAll(PLAYDAPP_CONTRACT, isNeedPlayzV1Approve)
                        ];
                    case 6:
                        txApprove1 = _state.sent();
                        return [
                            4,
                            txApprove1.wait()
                        ];
                    case 7:
                        _state.sent();
                        _state.label = 8;
                    case 8:
                        if (!isNeedPlayzV2Approve) return [
                            3,
                            11
                        ];
                        return [
                            4,
                            PLAYZ_V2_CONTRACT.setApprovalForAll(PLAYDAPP_CONTRACT, isNeedPlayzV2Approve)
                        ];
                    case 9:
                        txApprove2 = _state.sent();
                        return [
                            4,
                            txApprove2.wait()
                        ];
                    case 10:
                        _state.sent();
                        _state.label = 11;
                    case 11:
                        if (!isNeedDragonApprove) return [
                            3,
                            14
                        ];
                        return [
                            4,
                            DRAGON_CONTRACT.setApprovalForAll(PLAYDAPP_CONTRACT, isNeedDragonApprove)
                        ];
                    case 12:
                        txApprove3 = _state.sent();
                        return [
                            4,
                            txApprove3.wait()
                        ];
                    case 13:
                        _state.sent();
                        _state.label = 14;
                    case 14:
                        materials = {
                            Playz: [],
                            PlayzV2: [],
                            Dragon: []
                        };
                        selectedTokens.forEach(function(item) {
                            var tokensGroupBy = lodash_default().groupBy(item.tokens, "assetTitle");
                            Object.keys(tokensGroupBy).forEach(function(key) {
                                var tokenIds = tokensGroupBy[key].map(function(token) {
                                    return token.tokenId;
                                });
                                if (key === "PLAYZ V2" && materials.PlayzV2) {
                                    materials.PlayzV2 = (0,_to_consumable_array/* default */.Z)(materials.PlayzV2).concat((0,_to_consumable_array/* default */.Z)(tokenIds));
                                } else if (key === "DRGNZ" && materials.Dragon) {
                                    materials.Dragon = (0,_to_consumable_array/* default */.Z)(materials.Dragon).concat((0,_to_consumable_array/* default */.Z)(tokenIds));
                                } else if (materials.Playz) {
                                    materials.Playz = (0,_to_consumable_array/* default */.Z)(materials.Playz).concat((0,_to_consumable_array/* default */.Z)(tokenIds));
                                }
                            });
                        });
                        if (!((ref = materials.Playz) === null || ref === void 0 ? void 0 : ref.length)) delete materials.Playz;
                        if (!((ref1 = materials.PlayzV2) === null || ref1 === void 0 ? void 0 : ref1.length)) delete materials.PlayzV2;
                        if (!((ref2 = materials.Dragon) === null || ref2 === void 0 ? void 0 : ref2.length)) delete materials.Dragon;
                        payload = {
                            eventType: isJokerSelected ? "Joker" : "Normal",
                            materials: materials,
                            recaptcha: recaptcha
                        };
                        dispatch((0,merge/* fetchMerge */.Tq)(payload));
                        return [
                            3,
                            16
                        ];
                    case 15:
                        e = _state.sent();
                        console.error(e);
                        handleMergeErrorModalOpen(true);
                        return [
                            3,
                            16
                        ];
                    case 16:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleFetchMerge() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReCAPTCHA = function(token) {
        setRecaptcha(token);
    };
    (0,react.useEffect)(function() {
        fetchMergeFee();
        fetchMergeAvailable();
    }, [
        token
    ]);
    (0,react.useEffect)(function() {
        if (mergeStatus === "success") {
            handleClear(selectedTab);
            refetch();
            fetchMergeAvailable();
        }
    }, [
        mergeStatus,
        selectedTab,
        refetch
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,filters/* setPrevUrl */.vF)("collection"));
    }, [
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (networkName !== "polygon") router.push("/my-page/items");
    }, [
        networkName
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageBlock, {
        ref: pageBlock,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileHeader, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileHeaderTitle, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: "Merge > Upgrade"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        name: "close-circle",
                        size: "32px",
                        onClick: handleMergeClose
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileButtonBlock, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileClearButton, {
                        color: "purple",
                        onClick: handleTabClick(selectedTab, true),
                        children: "Clear"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileButton, {
                        disabled: !isSubmit || mergeStatus === "loading",
                        onClick: handleSubmit,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                            children: mergeStatus === "loading" ? "Merging..." : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    "Merge NFT (",
                                    selectedTotalCount,
                                    "/",
                                    data_merge/* MAX_SELECT_COUNT */._H,
                                    ")"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageWrapper, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeBlock, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabBlock, {
                                children: [
                                    data_merge/* PLAYDAPP_TOWN_TAB_LIST.map */.QK.map(function(item) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabItem, {
                                            isSelected: selectedTab === item.tab,
                                            onClick: handleTabClick(item.tab),
                                            children: [
                                                item.tab === "PLAYDAPP_TOWN_R" && mergeAvailable.playz.R && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabNotification, {}),
                                                item.tab === "PLAYDAPP_TOWN_SR" && mergeAvailable.playz.SR && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabNotification, {}),
                                                item.text
                                            ]
                                        }, item.tab);
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TabItem, {
                                        isSelected: isDragon,
                                        onClick: handleTabClick("PLAYDAPP_DRAGON_R"),
                                        children: [
                                            mergeAvailable.dragon.R && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabNotification, {}),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DragonTextBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                        children: "R > SR"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                        className: "light",
                                                        children: "(Dragon)"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterBlock, {
                                isDragon: isDragon,
                                children: [
                                    isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingLayer/* default */.Z, {}),
                                    !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ErrorBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "tx-error",
                                                width: isMdDownScreen ? "48px" : "64px",
                                                height: isMdDownScreen ? "42.68px" : "56.9px"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorTitleBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                    children: "Error"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorDescBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                    children: "Please refresh data or reconnect wallet."
                                                })
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(RefreshButton, {
                                                variant: "outline",
                                                onClick: function() {
                                                    return refetch();
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "refresh-primary",
                                                        width: isMdDownScreen ? "11.42px" : "17.13px",
                                                        height: isMdDownScreen ? "13.34px" : "20px"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                        children: "Refresh"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isLoading && !error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterSection, {
                                        isDragon: isDragon,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterTitleBlock, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                            children: [
                                                                "PLAYDAPP ",
                                                                isDragon ? "DRAGON" : "TOWN"
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterListBlock, {
                                                        isSrPlaydappTown: selectedTab === "PLAYDAPP_TOWN_SR",
                                                        isDragon: isDragon,
                                                        children: normalList && normalList.map(function(item, idx) {
                                                            var name = item.name, count = item.count, image = item.image, isSelected = item.isSelected;
                                                            var isPurchase = !isSelected && !count;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Character, {
                                                                        isPurchase: isPurchase,
                                                                        isCursorPointer: !isPurchase,
                                                                        onClick: function() {
                                                                            return !isPurchase && handleSelectClick(name, !isSelected, false);
                                                                        },
                                                                        children: [
                                                                            !isPurchase && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterCount, {
                                                                                children: count
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                                                prefix: "s3",
                                                                                src: image,
                                                                                width: "132px",
                                                                                height: "132px",
                                                                                layout: "responsive",
                                                                                alt: ""
                                                                            }),
                                                                            isSelected && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                                className: "selected",
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                                    name: "check-awesome",
                                                                                    width: "53.33px",
                                                                                    height: "36.67px"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isPurchase ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterButton, {
                                                                        variant: "outline",
                                                                        color: "blue",
                                                                        onClick: handlePurchaseClick(isDragon ? "PLAYDAPP_DRAGON" : "PLAYDAPP_TOWN", name, selectedTab === "PLAYDAPP_TOWN_SR" ? "SR" : "R"),
                                                                        children: "Purchase"
                                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterButton, {
                                                                        variant: "outline",
                                                                        isActive: isSelected,
                                                                        disabled: !isSelected && (selectedTotalCount === 6 || !!mergeStatus),
                                                                        onClick: function() {
                                                                            return handleSelectClick(name, !isSelected, false);
                                                                        },
                                                                        children: [
                                                                            "Select",
                                                                            isSelected && "ed"
                                                                        ]
                                                                    })
                                                                ]
                                                            }, "playdapp-town-character-".concat(idx));
                                                        })
                                                    })
                                                ]
                                            }),
                                            selectedTab !== "PLAYDAPP_DRAGON_R" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CharacterTitleBlock, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "PLAYDAPP DRAGON"
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                className: "joker",
                                                                children: "JOKER"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterListBlock, {
                                                        isSingle: selectedTab === "PLAYDAPP_TOWN_SR",
                                                        children: jokerList && jokerList.map(function(item, idx) {
                                                            var name = item.name, count = item.count, image = item.image;
                                                            var selectedCount = item.tokens.filter(function(item2) {
                                                                return "isSelected" in item2;
                                                            }).length;
                                                            var isPurchase = !selectedCount && !count;
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Character, {
                                                                        isPurchase: isPurchase,
                                                                        children: [
                                                                            !isPurchase && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterCount, {
                                                                                children: count
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                                                prefix: "s3",
                                                                                src: image,
                                                                                width: "132px",
                                                                                height: "132px",
                                                                                layout: "responsive",
                                                                                alt: ""
                                                                            }),
                                                                            selectedCount > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                                                className: "selected",
                                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                                    name: "check-awesome",
                                                                                    width: "53.33px",
                                                                                    height: "36.67px"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isPurchase ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CharacterButton, {
                                                                            variant: "outline",
                                                                            color: "blue",
                                                                            onClick: handlePurchaseClick("PLAYDAPP_DRAGON", name, selectedTab === "PLAYDAPP_TOWN_R" ? "R" : "SR"),
                                                                            children: "Purchase"
                                                                        })
                                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(JokerCountBox, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JokerCountButton, {
                                                                                variant: "outline",
                                                                                disabled: !selectedCount && (selectedTotalCount === 6 || !!mergeStatus),
                                                                                onClick: function() {
                                                                                    return handleSelectClick(name, false, true);
                                                                                },
                                                                                children: "-"
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                className: "number",
                                                                                children: selectedCount
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JokerCountButton, {
                                                                                variant: "outline",
                                                                                disabled: selectedTotalCount === 6 || selectedJokerCount > 4 || count === 0 || !!mergeStatus,
                                                                                onClick: function() {
                                                                                    return handleSelectClick(name, true, true);
                                                                                },
                                                                                children: "+"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }, "playdapp-town-character-".concat(idx));
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeButtonSection, {
                                        isDragon: isDragon,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                className: "merge-button-bg01"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                className: "merge-button-bg02"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClearButton, {
                                                onClick: handleTabClick(selectedTab, true),
                                                children: "Clear"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MergeButtonImageBox, {
                                                selectedTab: selectedTab
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MergeButtonBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectedStatusBox, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                className: "strong",
                                                                children: selectedTotalCount
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                className: "max",
                                                                children: [
                                                                    "\xa0/\xa0",
                                                                    data_merge/* MAX_SELECT_COUNT */._H,
                                                                    "\xa0"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "ITEMS"
                                                            })
                                                        ]
                                                    }),
                                                    selectedTab !== "PLAYDAPP_DRAGON_R" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectedJokerStatusBox, {
                                                        children: [
                                                            "(",
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                                className: "strong",
                                                                children: [
                                                                    "\xa0",
                                                                    selectedJokerCount
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "\xa0Joker"
                                                            }),
                                                            ")"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CustomButton, {
                                                        disabled: !isSubmit || mergeStatus === "loading",
                                                        onClick: handleSubmit,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                            children: mergeStatus === "loading" ? "Merging..." : "Merge NFT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CostBox, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                                            children: [
                                                                "Merge Cost : ",
                                                                mergeFee && mergeFee > 0 && "".concat(mergeFee, " PLA")
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExplainBlock, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExplainSection, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "title",
                                        children: "What is Merge?"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("p", {
                                        className: "desc",
                                        children: [
                                            "Merge makes your NFTs more valuable.",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                            "All PLAYZ NFT have a rarity rank. With Merge, you can upgrade them into higher ranks, all the way to SSR!"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "title",
                                        children: "Why Should I Merge My NFT?"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "desc",
                                        children: "PlayDapp’sNFTs are intended to be interoperable. That ’s our mission, and we are building a marketplace that connects different games, by letting you seamlessly use and trade your NFTs.You can now use PlayDapp Town NFTs for staking in Along with the Gods (AWTG) via Item Manager."
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "title",
                                        children: "How to start merging?"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "desc",
                                        children: "The merge requires 6 R or SR rank NFTs. Combine these into one higher rank NFT (ex. R\xa0>\xa0SR, or SR\xa0>\xa0SSR) as shown above."
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "title",
                                        children: "PlayDapp Dragon NFT"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        className: "desc",
                                        children: "PlayDapp Dragon NFTs are special, because they can be substituted for PlayDapp NFTs of equivalent rank when merging."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GuideSection, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideBox, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Redirect/* default */.Z, {
                                            to: "https://medium.com/playdappgames/along-with-the-gods-play-to-earn-2-0-guide-82fd455cfd02",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GuideTitleBlock, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideTitleBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "AWTG guide"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideDescBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "Find out what is AWTG and how PlayDapp Town NFTs are used"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                    prefix: "s3",
                                                    src: "/merge/awtg-guide3.png",
                                                    width: "72px",
                                                    height: "72px",
                                                    alt: "awtg-guide",
                                                    layout: "fixed"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideBox, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Redirect/* default */.Z, {
                                            to: "https://medium.com/playdappgames/along-with-the-gods-play-to-earn-2-0-staking-guidelines-d9bded4b8665",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GuideTitleBlock, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideTitleBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "Staking guide"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideDescBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "Discover more about Item Manager and Staking"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                    prefix: "s3",
                                                    src: "/merge/staking-guide3.png",
                                                    width: "72px",
                                                    height: "72px",
                                                    alt: "staking-guide",
                                                    layout: "fixed"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideBox, {
                                        isExplore: true,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Redirect/* default */.Z, {
                                            to: "/collection/polygon/1",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(GuideTitleBlock, {
                                                    isExplore: true,
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideTitleBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "Don’t have NFTs to merge?"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideDescBox, {
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                children: "Don’t worry! Use the PlayDapp Marketplace to get any NFTs you’re missing!"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideExploreButtonBox, {
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(GuideExploreButton, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Redirect/* default */.Z, {
                                                            to: "/collection/polygon/1",
                                                            children: "Explore"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isMergeModalOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_MergeConfirmModal, {
                isOpen: isMergeModalOpen,
                selectedTab: selectedTab,
                selectedTokens: selectedTokens,
                isApproved: isNeedPlayzV1Approve || isNeedPlayzV2Approve || isNeedDragonApprove,
                recaptcha: recaptcha,
                handleOpen: handleMergeModalOpen,
                handleFetchMerge: handleFetchMerge,
                handleReCAPTCHA: handleReCAPTCHA
            }),
            account && balance && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceModal/* default */.Z, {
                isOpen: isBalanceModalOpen,
                handleOpen: handleBalanceModalOpen,
                currency: "pla",
                balance: balance.pla
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmailVerifyModal/* default */.Z, {
                isOpen: isEmailModalOpen,
                handleOpen: handleEmailModalOpen
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MergeErrorModal/* default */.Z, {
                isOpen: isMergeErrorModalOpen,
                isOwnerCheckFail: isOwnerCheckFail,
                textList: isOwnerCheckFail ? data_merge/* MERGE_OWNER_CHECK_ERROR_TEXT_LIST */.Lj : data_merge/* MERGE_ERROR_TEXT_LIST */.wM,
                isShowIcon: !isOwnerCheckFail,
                handleOpen: function(isOpen) {
                    setIsOwnerCheckFail(false);
                    handleMergeErrorModalOpen(isOpen);
                }
            }),
            isOwnerCheckLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingLayer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_Merge = (Merge);

;// CONCATENATED MODULE: ./src/components/MyItems2.tsx







function MyItems2_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      touch-action: none;\n    "
    ]);
    MyItems2_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyItems2_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    MyItems2_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}

































var MyItems2_PageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt660"
})(function(param) {
    var isMergeOpen = param.isMergeOpen;
    return isMergeOpen && (0,emotion_react_browser_esm/* css */.iv)(MyItems2_templateObject());
}, ";");
var ItemOptionButtonWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt661"
})("position:", function(param) {
    var isMdDown = param.isMdDown;
    return isMdDown && "sticky";
}, ";top:64px;display:", function(param) {
    var isMdDown = param.isMdDown;
    return isMdDown ? "block" : "flex";
}, ";justify-content:", function(param) {
    var isBetween = param.isBetween;
    return isBetween === "space-between" ? "space-between" : "flex-end";
}, ";align-items:center;height:100%;gap:", index_esm/* spacing.s */.W0.s, ";border-radius:8px;order:1;z-index:1;", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;}");
var ItemReserves = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt662"
})((0,index_esm/* fontStyle */.p_)("b4"), ";text-align:left;color:", index_esm/* palette.dgray400 */.DG.dgray400, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(100);
}, ";margin-top:", index_esm/* spacing.xl */.W0.xl, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", index_esm/* spacing.m */.W0.m, ";}");
var MyItems2_CustomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e14nmt663"
})("display:flex;align-items:center;justify-content:center;width:100%;height:", index_esm/* spacing.xxxl */.W0.xxxl, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";white-space:pre;border-radius:", index_esm/* spacing.xs */.W0.xs, ";background-color:white;:hover{background-color:", function(param) {
    var disabled = param.disabled;
    return !disabled && "rgba(43, 202, 176, 0.08)";
}, ";}& + a,a + &{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;height:", index_esm/* spacing.xxxl */.W0.xxxl, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";padding:", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.s */.W0.s, ";}");
var SelectBundle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e14nmt664"
})("display:flex;align-items:center;justify-content:center;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";.bundle-count{width:", index_esm/* spacing.xl */.W0.xl, ";height:", index_esm/* spacing.xl */.W0.xl, ";padding-top:", index_esm/* spacing.xxs */.W0.xxs, ";margin-left:", index_esm/* spacing.xxs */.W0.xxs, ";background-color:", index_esm/* palette.white */.DG.white, ";color:", index_esm/* palette.marketplace */.DG.marketplace, ";border-radius:50%;}& > span{margin-left:", index_esm/* spacing.s */.W0.s, " !important;}", index_esm/* breakpoints.down */.AV.down("md"), "{min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(65);
}, ";height:100%;font-size:", index_esm/* fontSize.b3 */.JB.b3, ";padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.xs */.W0.xs, ";& > input{margin-right:", index_esm/* spacing.xs */.W0.xs, ";}}");
var MyItems2_DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt665"
})("display:flex;flex-direction:column;overflow-y:auto;height:", function(param) {
    var theme = param.theme;
    return theme.rem(500);
}, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";padding:0;box-shadow:0px 4px 4px rgba(0,0,0,0.25);");
var DropDownItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e14nmt666"
})("display:flex;align-items:center;width:100%;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";outline:0;border-radius:", index_esm/* spacing.xs */.W0.xs, ";background-color:transparent;text-align:left;font-family:initial;white-space:pre-line;&:hover{background-color:", index_esm/* palette.gray400 */.DG.gray400, ";}& > span{flex:none;border-radius:50%;}& > p{margin-left:", index_esm/* spacing.s */.W0.s, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:", index_esm/* spacing.s */.W0.s, ";}");
var MyItems2_ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt667"
})("width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(540);
}, ";");
var CardListBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt668"
})("display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:", index_esm/* spacing.xl */.W0.xl, ";margin-top:", index_esm/* spacing.m */.W0.m, ";", index_esm/* breakpoints.down */.AV.down("xxl"), "{grid-template-columns:repeat(4,minmax(0,1fr));}", index_esm/* breakpoints.down */.AV.down("xl"), "{grid-template-columns:repeat(3,minmax(0,1fr));}", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", index_esm/* spacing.l */.W0.l, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{grid-template-columns:repeat(2,minmax(0,1fr));grid-template-rows:auto;gap:", index_esm/* spacing.xs */.W0.xs, ";}@media screen and (max-width:359px){grid-template-columns:minmax(0,1fr);gap:", index_esm/* spacing.s */.W0.s, ";}");
var MyItems2_EmptyItemBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt669"
})("margin-top:10rem;");
var FloatingButtonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt6610"
})("position:fixed;bottom:3rem;left:50%;z-index:1000;transform:translateX(-50%);button{color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? index_esm/* palette.white */.DG.white : index_esm/* palette.marketplace */.DG.marketplace;
}, ";", function(param) {
    var isSelected = param.isSelected;
    return !isSelected && (0,emotion_react_browser_esm/* css */.iv)(MyItems2_templateObject1(), index_esm/* palette.marketplace */.DG.marketplace);
}, "    box-shadow:0px 4px 4px rgba(0,0,0,0.25);}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0 ", index_esm/* spacing.xl */.W0.xl, ";&,button{width:100%;}}");
var NetworkStatusNotice = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt6611"
})("position:relative;display:flex;align-items:center;min-height:", index_esm/* spacing.xxl */.W0.xxl, ";padding:0 10px;font-size:14px;color:", index_esm/* palette.yellow700 */.DG.yellow700, ";background-color:", index_esm/* palette.yellow100 */.DG.yellow100, ";gap:10px;border-radius:", index_esm/* spacing.xs */.W0.xs, ";", index_esm/* breakpoints.down */.AV.down("md"), "{display:none;}");
var CenterNavigation = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt6612"
})("display:flex;position:sticky;align-items:flex-start;justify-content:flex-end;gap:1rem;z-index:2;", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0;}");
var MyItems2_CategoryListBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt6613"
})("display:flex;flex-direction:column;align-items:flex-start;");
var CollectionListDropDown = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e14nmt6614"
})("position:relative;align-items:flex-end;", (0,index_esm/* fontStyle */.p_)("p3"), ";& > div{color:", index_esm/* palette.dgray400 */.DG.dgray400, ";border-radius:10px;:hover{background-color:", index_esm/* palette.gray100 */.DG.gray100, ";}transition:0.3s;", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;white-space:pre;}}", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;}");
var MobileNetworkStatusNotice = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e14nmt6615"
})("position:relative;display:flex;align-items:center;padding:6px 10px;margin-top:", index_esm/* spacing.l */.W0.l, ";gap:10px;", (0,index_esm/* fontStyle */.p_)("p4"), ";color:", index_esm/* palette.yellow700 */.DG.yellow700, ";background-color:", index_esm/* palette.yellow100 */.DG.yellow100, ";", index_esm/* breakpoints.up */.AV.up("md"), "{display:none;}");
var MyItems = function() {
    var isMdDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")));
    var isLgDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("lg")));
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var ref = (0,react.useState)(false), isClose = ref[0], setIsClose = ref[1];
    var ref1 = (0,react.useState)(false), isSendClicked = ref1[0], setIsSendClicked = ref1[1];
    var ref2 = (0,react.useState)(false), isReceiveClicked = ref2[0], setIsReceiveClicked = ref2[1];
    var ref3 = (0,react.useState)(false), isReceivable = ref3[0], setIsReceivable = ref3[1];
    var ref4 = (0,react.useState)([]), receivableItems = ref4[0], setReceivableItems = ref4[1];
    var ref5 = (0,react.useState)(0), myItemCount = ref5[0], setMyItemCount = ref5[1];
    var ref6 = (0,react.useState)(null), selectMode = ref6[0], setSelectMode = ref6[1];
    var ref7 = (0,react.useState)(null), txHash = ref7[0], setTxHash = ref7[1];
    var ref8 = (0,react.useState)(null), transactionModalStatus = ref8[0], setTransactionModalStatus = ref8[1];
    var ref9 = (0,hooks/* useAppSelector */.C)(function(param) {
        var myAccount = param.myAccount;
        return myAccount;
    }, react_redux_es/* shallowEqual */.wU), selectedItems = ref9.selectedItems, selectedMyItemsCollection = ref9.selectedMyItemsCollection, firstCategory = ref9.firstCategory;
    var ref10 = (0,hooks/* useAppSelector */.C)(function(param) {
        var marketplace = param.marketplace;
        return marketplace;
    }), txStatus = ref10.txStatus, transactionHash = ref10.transactionHash;
    var collectionList = (0,hooks/* useAppSelector */.C)(function(param) {
        var collections = param.collections;
        return collections;
    }).collectionList;
    var ref11 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref11.account, activeChainId = ref11.activeChainId;
    var prev = (0,hooks/* useAppSelector */.C)(function(param) {
        var page = param.page;
        return page;
    }).prev;
    var isMergeOpen = (0,hooks/* useAppSelector */.C)(function(param) {
        var merge = param.merge;
        return merge;
    }).isMergeOpen;
    var ref12 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isBridgeSendModalOpen = ref12[0], handleBridgeSendModalOpen = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isBridgeReceiveModalOpen = ref13[0], handleBridgeReceiveModalOpen = ref13[1];
    var ref14 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isTransactionResultModalOpen = ref14[0], handleTransactionResultModalOpen = ref14[1];
    var ref15 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isTransactionModalOpen = ref15[0], handleTransactionModalOpen = ref15[1];
    var ref16 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)(), 2), loadMoreRef = ref16[0], loadMoreRefInView = ref16[1];
    var ref17 = (0,useToastMessage/* default */.Z)({
        position: "top",
        duration: 5000
    }), handleUpdateToast = ref17.handleUpdateToast, handleCloseToast = ref17.handleCloseToast;
    var toggleSelectMode = function(e) {
        e === null || e === void 0 ? void 0 : e.preventDefault();
        if (selectMode === "sell") {
            dispatch((0,my_account/* setSelectedItems */.LD)([]));
            dispatch((0,my_account/* setFirstCategory */.WE)(null));
            setSelectMode(null);
            return;
        }
        dispatch((0,my_account/* setSelectedItems */.LD)([]));
        setSelectMode("sell");
        dispatch((0,merge/* setIsMergeOpen */.NI)(false));
    };
    var toggleTransferSuccessModal = function(isOpen) {
        return function() {
            handleTransactionResultModalOpen(isOpen);
            handleTransactionModalOpen(false);
            refetch();
            dispatch((0,marketplace/* clearTxStatus */.Tz)());
        };
    };
    var moveToSellPage = function() {
        if (!activeChainId || !selectedItems.length) {
            return;
        }
        if (selectedItems.length === 1) {
            router.push("/sell/".concat(lib_network/* chainIdToMainNetworkName */.$4[activeChainId], "/").concat(selectedItems[0].assetAddress, "/").concat(selectedItems[0].tokenId));
            dispatch((0,my_account/* setSelectedItems */.LD)([]));
            dispatch((0,my_account/* setFirstCategory */.WE)(null));
            return;
        }
        router.push("/sell/bundle");
    };
    var handleSendBridge = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, tokenId, assetAddress, auction, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            3,
                            4,
                            5
                        ]);
                        if (selectedItems.length === 0 || !account) {
                            return [
                                2
                            ];
                        }
                        ref = selectedItems[0], tokenId = ref.tokenId, assetAddress = ref.assetAddress;
                        setIsSendClicked(true);
                        return [
                            4,
                            bridgeSend({
                                tokenId: tokenId
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            dispatch((0,marketplace/* transferAsset */.JZ)({
                                from: account,
                                to: "0xd27882a9815DBBD54DBdc937B62f000143Bd53c1",
                                tokenId: tokenId,
                                tokenAddress: assetAddress
                            }))
                        ];
                    case 2:
                        auction = _state.sent();
                        if (auction.payload) {
                            setTxHash(auction.payload);
                            handleTransactionResultModalOpen(true);
                            dispatch((0,my_account/* setSelectedItems */.LD)([]));
                            refetch();
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        /* eslint-disable-next-line no-console */ console.error(err);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSendClicked(false);
                        handleBridgeSendModalOpen(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleSendBridge() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleReceiveBridge = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var res, err;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            3,
                            4
                        ]);
                        setIsReceiveClicked(true);
                        return [
                            4,
                            bridgeReceive()
                        ];
                    case 1:
                        res = _state.sent();
                        if (res.data) {
                            setTimeout(function() {
                                handleUpdateToast("Your ".concat(res.data.length > 1 ? "[".concat(res.data.length, "] NFTs have") : "NFT has", "  been transferred successfully"), "success", true);
                            }, 2000);
                        }
                        return [
                            3,
                            4
                        ];
                    case 2:
                        err = _state.sent();
                        console.error(err);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsReceiveClicked(false);
                        handleBridgeReceiveModalOpen(false);
                        setIsReceivable(false);
                        setReceivableItems([]);
                        return [
                            7
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReceiveBridge() {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!account || !activeChainId) {
                            throw new Error("No account or chainId");
                        }
                        return [
                            4,
                            getMyAssets({
                                from: (pageParam - 1) * 30,
                                count: 30,
                                andOperations: [
                                    {
                                        key: "order.sale",
                                        value: "$not_exist"
                                    },
                                    {
                                        key: "order.auction",
                                        value: "$not_exist"
                                    },
                                    {
                                        key: "owner",
                                        value: account
                                    },
                                    {
                                        key: "network",
                                        value: lib_network/* chainIdToMainNetworkName */.$4[activeChainId]
                                    }
                                ],
                                orOperations: [
                                    selectedMyItemsCollection ? selectedMyItemsCollection.assets.map(function(id) {
                                        return {
                                            key: "assetId",
                                            value: id.toString()
                                        };
                                    }) : []
                                ],
                                sortBy: "Transfer",
                                sortAscending: false
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                                from: (pageParam - 1) * 30,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref18 = (0,es.useInfiniteQuery)([
        "myitems",
        account,
        selectedMyItemsCollection
    ], fetchList, {
        getNextPageParam: function(lastPage) {
            if (lastPage.total > lastPage.from + 30) {
                return lastPage.nextPage;
            }
        },
        enabled: !!account && !!activeChainId,
        refetchOnWindowFocus: false
    }), isLoading = ref18.isLoading, data = ref18.data, hasNextPage = ref18.hasNextPage, error = ref18.error, fetchNextPage = ref18.fetchNextPage, refetch = ref18.refetch;
    var handleNextPage = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = hasNextPage;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchNextPage()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchNextPage,
        hasNextPage
    ]);
    var handleCollectionItemClick = function(categoryId) {
        return function() {
            if (!categoryId) {
                dispatch((0,my_account/* setSelectedMyItemsCollection */.OL)(null));
            }
            if (activeChainId) {
                var activeCollection = collectionList[lib_network/* chainIdToMainNetworkName */.$4[activeChainId]].find(function(category) {
                    return category.categoryId === categoryId;
                });
                if (activeCollection) {
                    dispatch((0,my_account/* setSelectedMyItemsCollection */.OL)(activeCollection));
                }
                setIsClose(true);
            }
        };
    };
    var handleCardClick = function(tokenId, collectionInfo, image, title, attributes, assetAddress, isDisbaled) {
        return function() {
            if (!tokenId || !activeChainId) {
                return;
            }
            if (!selectMode || isDisbaled) {
                return;
            }
            var checkSameTokenId = selectedItems.find(function(list) {
                return list.tokenId === tokenId;
            });
            if (checkSameTokenId) {
                var deletedOverlapItem = selectedItems.filter(function(list) {
                    return list.tokenId !== tokenId;
                });
                dispatch((0,my_account/* setSelectedItems */.LD)(deletedOverlapItem));
                return;
            }
            if (selectedItems.length >= 30) {
                handleUpdateToast("You can select a maximum of 30 items.", "error", true);
                return;
            }
            if (lib_network/* chainIdToMainNetworkName */.$4[activeChainId] === "solana" && selectedItems.length >= 1) {
                handleUpdateToast("Bundle sell is coming soon.", "error", true);
                return;
            }
            if (checkSameTokenId === undefined && selectedItems.length < 30) {
                var selectedItemData = {
                    tokenId: tokenId,
                    imageUrl: image !== null && image !== void 0 ? image : "",
                    name: title !== null && title !== void 0 ? title : "",
                    assetAddress: assetAddress !== null && assetAddress !== void 0 ? assetAddress : "",
                    attributes: attributes !== null && attributes !== void 0 ? attributes : []
                };
                if (selectMode === "send") {
                    dispatch((0,my_account/* setSelectedItems */.LD)([
                        selectedItemData
                    ]));
                    handleBridgeSendModalOpen(true);
                    return;
                }
                collectionInfo && firstCategory !== collectionInfo.title && dispatch((0,my_account/* setFirstCategory */.WE)(collectionInfo.title));
                dispatch((0,my_account/* setSelectedItems */.LD)((0,_to_consumable_array/* default */.Z)(selectedItems).concat([
                    selectedItemData
                ])));
            }
        };
    };
    var handleToggleMerge = function() {
        dispatch((0,merge/* setIsMergeOpen */.NI)(!isMergeOpen));
        if (selectMode === "sell") {
            dispatch((0,my_account/* setSelectedItems */.LD)([]));
            dispatch((0,my_account/* setFirstCategory */.WE)(null));
            setSelectMode(null);
        }
    };
    (0,react.useEffect)(function() {
        return function() {
            handleCloseToast();
        };
    }, [
        handleCloseToast
    ]);
    (0,react.useEffect)(function() {
        if (isClose) {
            setIsClose(function() {
                return false;
            });
        }
    }, [
        isClose
    ]);
    (0,react.useEffect)(function() {
        if (loadMoreRefInView) {
            handleNextPage();
        }
    }, [
        loadMoreRefInView,
        handleNextPage
    ]);
    (0,react.useEffect)(function() {
        if (selectedItems.length === 0) {
            selectMode !== "send" && dispatch((0,my_account/* setFirstCategory */.WE)(null));
        } else {
            !selectMode && firstCategory && setSelectMode("sell");
        }
    }, [
        selectedItems,
        dispatch,
        firstCategory,
        selectMode
    ]);
    (0,react.useEffect)(function() {
        if (!prev.startsWith("/item/") && !prev.startsWith("/my-page/items")) {
            dispatch((0,my_account/* setSelectedItems */.LD)([]));
            dispatch((0,my_account/* setFirstCategory */.WE)(null));
        }
    }, [
        account,
        activeChainId,
        prev,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        switch(txStatus){
            case "INITIALIZE_PROXY":
            case "APPROVE_ALL_ASSETS":
            case "APPROVE_ASSET":
            case "TRANSFER_ALL":
                setTransactionModalStatus(txStatus);
                handleTransactionModalOpen(true);
                break;
            case "TX_SUCCESS":
                handleTransactionResultModalOpen(true);
                setTransactionModalStatus("");
                break;
            case "TX_DENIED":
                setTransactionModalStatus("");
                break;
            case "TX_FAILED":
                setTransactionModalStatus("");
                break;
            case "SET_PENDING_TRANSACTION_HASH":
                break;
            default:
                break;
        }
    }, [
        handleTransactionResultModalOpen,
        handleTransactionModalOpen,
        txStatus
    ]);
    (0,react.useEffect)(function() {
        if ("merge" in router.query) {
            dispatch((0,merge/* setIsMergeOpen */.NI)(true));
        } else {
            dispatch((0,merge/* setIsMergeOpen */.NI)(false));
        }
        return function() {
            dispatch((0,merge/* setIsMergeOpen */.NI)(false));
        };
    }, [
        dispatch,
        router.query
    ]);
    (0,react.useEffect)(function() {
        if (data) {
            data.pages.map(function(info) {
                return setMyItemCount(info.total);
            });
        }
    }, [
        data
    ]);
    var ref19;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyItems2_PageBlock, {
        isMergeOpen: isMergeOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaTag/* default */.Z, {
                title: "My Items | PlayDapp"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemOptionButtonWrapper, {
                isMdDown: isMdDownScreen,
                isBetween: "space-between",
                children: [
                    !isLgDownScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemReserves, {
                        children: [
                            myItemCount ? myItemCount === null || myItemCount === void 0 ? void 0 : myItemCount.toLocaleString() : 0,
                            " items"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NetworkStatusNotice, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                name: "warning-yellow",
                                alt: "warning-yellow",
                                width: 24,
                                height: 24
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                children: "NFT status may take a few minutes to update depending to network congestion"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CenterNavigation, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyItems2_CustomButton, {
                                color: "primary",
                                size: "xs",
                                variant: "outline",
                                disabled: !(data === null || data === void 0 ? void 0 : data.pages[0].assets.length),
                                onClick: toggleSelectMode,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                    color: !(data === null || data === void 0 ? void 0 : data.pages[0].assets.length) ? "dgray200" : "primary700",
                                    type: "p3",
                                    children: "Sell Bundle"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionListDropDown, {
                                title: (ref19 = selectedMyItemsCollection === null || selectedMyItemsCollection === void 0 ? void 0 : selectedMyItemsCollection.title) !== null && ref19 !== void 0 ? ref19 : "All Collection",
                                width: "262",
                                height: "36",
                                top: "46",
                                isBorder: true,
                                isDropBox: true,
                                floatingContent: true,
                                isClose: isClose,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyItems2_DropDownSortContent, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyItems2_CategoryListBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropDownItem, {
                                                onClick: handleCollectionItemClick(0),
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                        prefix: "s3",
                                                        src: "/collections/all.png",
                                                        alt: "all",
                                                        width: 24,
                                                        height: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                        type: "p3",
                                                        color: "dgray400",
                                                        component: "p",
                                                        children: "All Collection"
                                                    })
                                                ]
                                            }),
                                            activeChainId && collectionList[lib_network/* chainIdToMainNetworkName */.$4[activeChainId]].map(function(category) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DropDownItem, {
                                                    onClick: handleCollectionItemClick(category.categoryId),
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                            src: category.thumbnailUrl,
                                                            alt: "collection",
                                                            width: 24,
                                                            height: 24
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                            type: "p4",
                                                            color: "dgray400",
                                                            component: "p",
                                                            children: category.title
                                                        })
                                                    ]
                                                }, category.categoryId);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            !isMdDownScreen && isLgDownScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemReserves, {
                children: [
                    myItemCount ? myItemCount === null || myItemCount === void 0 ? void 0 : myItemCount.toLocaleString() : 0,
                    " items"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MobileNetworkStatusNotice, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        name: "warning-yellow",
                        alt: "warning-yellow",
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                        children: "NFT status may take a few minutes to update depending to network congestion"
                    })
                ]
            }),
            isMdDownScreen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemReserves, {
                children: [
                    myItemCount ? myItemCount === null || myItemCount === void 0 ? void 0 : myItemCount.toLocaleString() : 0,
                    " items"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyItems2_ContentBody, {
                children: [
                    (!isMergeOpen || isMdDownScreen) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardListBox, {
                                children: [
                                    isLoading && times_default()(30, function(index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                            isLoading: true
                                        }, index);
                                    }),
                                    data === null || data === void 0 ? void 0 : data.pages.map(function(items) {
                                        var assets = items.assets;
                                        return Object.values(assets).map(function(param, index) {
                                            var name = param.name, imageUri = param.imageUri, animationUri = param.animationUri, tokenId = param.tokenId, network = param.network, assetAddress = param.assetAddress, owner = param.owner, order = param.order, collectionInfo = param.collectionInfo, attributes = param.attributes, likeCount = param.likeCount;
                                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                                collectionInfo: collectionInfo,
                                                imageUri: imageUri,
                                                animationUri: animationUri,
                                                tokenId: tokenId,
                                                name: name,
                                                order: order,
                                                network: network,
                                                href: "/item/".concat(network, "/").concat(assetAddress, "/").concat(tokenId),
                                                assetAddress: assetAddress,
                                                attributes: attributes,
                                                isOwner: owner === account,
                                                isSelectable: !!selectMode,
                                                like: likeCount,
                                                isActive: !!selectMode && selectedItems.some(function(item) {
                                                    return item.tokenId === tokenId;
                                                }),
                                                disabled: selectMode === "sell" && firstCategory !== null && (collectionInfo === null || collectionInfo === void 0 ? void 0 : collectionInfo.title) !== firstCategory || selectMode === "send" && !(name === null || name === void 0 ? void 0 : name.includes("SSR")),
                                                onClick: handleCardClick
                                            }, "".concat(name, "_").concat(tokenId, "-").concat(index));
                                        });
                                    }),
                                    hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                                isLoading: true,
                                                ref: loadMoreRef
                                            }),
                                            times_default()(9, function(index) {
                                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                                    isLoading: true
                                                }, index);
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyItems2_EmptyItemBlock, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                            }),
                            !error && (data === null || data === void 0 ? void 0 : data.pages) && (data === null || data === void 0 ? void 0 : data.pages.length) > 0 && (data === null || data === void 0 ? void 0 : data.pages[0].total) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyItems2_EmptyItemBlock, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {})
                            }),
                            selectMode === "sell" && selectedItems.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingButtonBlock, {
                                isSelected: selectMode === "sell",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectBundle, {
                                    onClick: moveToSellPage,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                            name: "grid-white",
                                            size: 18
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            children: "Sell Bundle of"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                            className: "bundle-count",
                                            children: selectedItems.length
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    isMergeOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Merge, {
                        handleToggleMerge: handleToggleMerge
                    })
                ]
            }),
            activeChainId && lib_network/* chainIdToMainNetworkName */.$4[activeChainId] === "ethereum" && isBridgeSendModalOpen && selectedItems.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_BridgeSendModal, {
                isOpen: isBridgeSendModalOpen,
                handleOpen: handleBridgeSendModalOpen,
                handleSend: handleSendBridge,
                image: selectedItems[0].imageUrl,
                isSendClicked: isSendClicked
            }),
            activeChainId && lib_network/* chainIdToMainNetworkName */.$4[activeChainId] === "polygon" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeReceiveModal, {
                isOpen: isBridgeReceiveModalOpen,
                handleOpen: handleBridgeReceiveModalOpen,
                handleReceive: handleReceiveBridge,
                isClicked: isReceiveClicked,
                isAvailable: isReceivable,
                items: receivableItems
            }),
            isTransactionModalOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransactionModal/* default */.Z, {
                isOpen: isTransactionModalOpen,
                handleOpen: handleTransactionModalOpen,
                network: "ethereum",
                status: transactionModalStatus,
                shouldCloseOnOverlayClick: false,
                stepTypeSubFix: "transfer",
                txHash: transactionHash
            }),
            isTransactionResultModalOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TransactionResultModal/* default */.Z, {
                isOpen: isTransactionResultModalOpen,
                handleOpen: toggleTransferSuccessModal(false),
                type: "success",
                network: "ethereum",
                txHash: txHash
            })
        ]
    });
};
/* harmony default export */ var MyItems2 = (MyItems);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/api/item.ts
var item = __webpack_require__(57904);
;// CONCATENATED MODULE: ./src/components/MySales2.tsx





























var SalesOptionBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a0"
})("display:flex;align-items:center;height:100%;overflow-x:hidden;div{display:flex;align-items:center;height:100%;width:100%;min-width:420px;", index_esm/* breakpoints.down */.AV.down("xl"), "{min-width:100%;}button + button{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}}", index_esm/* breakpoints.down */.AV.down("md"), "{order:2;}");
var CollectionDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e12t564a1"
})("position:relative;align-items:flex-end;", (0,index_esm/* fontStyle */.p_)("b4"), ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:none;}");
var MobileCollectionDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e12t564a2"
})("display:none;", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;align-items:flex-end;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(200);
}, ";order:2;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:block;align-items:flex-end;width:100%;max-width:100%;margin-right:", index_esm/* spacing.m */.W0.m, ";order:1;div{", (0,index_esm/* fontStyle */.p_)("p3"), ";}}");
var MySales2_DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a3"
})("display:flex;flex-direction:column;overflow-y:auto;border-radius:", index_esm/* spacing.xs */.W0.xs, ";height:500px;padding:0;box-shadow:0px 4px 4px rgba(0,0,0,0.25);");
var MySales2_DropDownItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e12t564a4"
})("display:flex;align-items:center;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";outline:0;border-radius:", index_esm/* spacing.xs */.W0.xs, ";background-color:transparent;text-align:left;font-family:initial;&:hover{background-color:", index_esm/* palette.gray400 */.DG.gray400, ";}& > span{flex:none;border-radius:50%;}& > p{margin-left:", index_esm/* spacing.s */.W0.s, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:", index_esm/* spacing.s */.W0.s, ";}");
var MySales2_CustomButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e12t564a5"
})("display:flex;align-items:center;justify-content:center;:hover{background:rgba(43,202,176,0.08);}& + a,a + &{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}&.selected{background:rgba(43,202,176,0.2);:hover{background:rgba(43,202,176,0.2);}}", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("p3"), ";padding:", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.s */.W0.s, ";}");
var SelectBundleArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a6"
})("display:flex;align-items:flex-start;justify-content:flex-end;flex:auto;text-align:center;", index_esm/* breakpoints.down */.AV.down("md"), "{display:flex;justify-content:space-between;width:100%;margin-bottom:", index_esm/* spacing.m */.W0.m, ";order:1;}");
var SelectBundleBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a7"
})("display:flex;align-items:center;justify-content:space-evenly;height:", function(param) {
    var theme = param.theme;
    return theme.rem(40);
}, ";padding:", index_esm/* spacing.xs */.W0.xs, ";border:1px solid ", index_esm/* palette.gray700 */.DG.gray700, ";border-radius:", index_esm/* spacing.xl */.W0.xl, ";margin-right:", index_esm/* spacing.xs */.W0.xs, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{padding:", index_esm/* spacing.xs */.W0.xs, ";order:2;}", index_esm/* breakpoints.down */.AV.down("md"), "{width:auto;height:auto;padding:", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.xs */.W0.xs, ";order:2;}");
var SelectBundleItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e12t564a8"
})("display:flex;align-items:center;padding:", index_esm/* spacing.xs */.W0.xs, " ", function(param) {
    var theme = param.theme;
    return theme.rem(10);
}, ";height:", index_esm/* spacing.xxl */.W0.xxl, ";text-transform:capitalize;& > span{margin-right:0 !important;}& > p{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{display:flex;justify-content:center;align-items:center;padding:auto;height:auto;& span{margin-right:0;}& > p{display:none;}}");
var MySales2_SelectOptionArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a9"
})("display:flex;justify-content:space-between;align-items:center;width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(40);
}, ";margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.up */.AV.up("md"), "{display:flex;align-items:center;height:auto;}", index_esm/* breakpoints.down */.AV.down("md"), "{flex-direction:column;justify-content:space-between;align-items:flex-start;width:100%;height:auto;margin-bottom:", index_esm/* spacing.m */.W0.m, ";}");
var MySales2_ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a10"
})("width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(540);
}, ";");
var MySales2_CardListBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a11"
})("display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:", index_esm/* spacing.l */.W0.l, ";", index_esm/* breakpoints.down */.AV.down("xxl"), "{grid-template-columns:repeat(4,minmax(0,1fr));gap:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("xl"), "{grid-template-columns:repeat(3,minmax(0,1fr));gap:", index_esm/* spacing.l */.W0.l, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{gap:", index_esm/* spacing.l */.W0.l, ";margin-top:", index_esm/* spacing.l */.W0.l, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{grid-template-columns:repeat(2,minmax(0,1fr));gap:", index_esm/* spacing.m */.W0.m, ";}@media screen and (max-width:359px){grid-template-columns:minmax(0,1fr);gap:", index_esm/* spacing.s */.W0.s, ";}");
var MySales2_EmptyItemBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e12t564a12"
})("margin-top:10rem;");
var MySales = function(param) {
    var salesType = param.salesType;
    var isMobile = (0,useMedia/* default */.Z)("(max-width: 479px)", true);
    var ref = (0,react.useState)(false), isClose = ref[0], setIsClose = ref[1];
    var collectionList = (0,hooks/* useAppSelector */.C)(function(param) {
        var collections = param.collections;
        return collections;
    }).collectionList;
    var ref1 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref1.account, activeChainId = ref1.activeChainId;
    var ref2 = (0,hooks/* useAppSelector */.C)(function(param) {
        var myAccount = param.myAccount;
        return myAccount;
    }, react_redux_es/* shallowEqual */.wU), selectedMySalesOrderFilter = ref2.selectedMySalesOrderFilter, selectedMySalesCollection = ref2.selectedMySalesCollection, isSwitchBundle = ref2.isSwitchBundle;
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,react_intersection_observer_m/* useInView */.YD)(), 2), loadMoreRef = ref3[0], loadMoreRefInView = ref3[1];
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var convertToUsd = (0,useTokenCurrency/* default */.Z)().convertToUsd;
    var fetchSingleItemList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!account || !activeChainId) {
                            // TODO: 예외처리
                            throw new Error("No account or chainId");
                        }
                        return [
                            4,
                            getMyAssets({
                                from: (pageParam - 1) * 30,
                                count: 30,
                                andOperations: [
                                    {
                                        key: "owner",
                                        value: account
                                    },
                                    {
                                        key: "network",
                                        value: lib_network/* chainIdToMainNetworkName */.$4[activeChainId]
                                    },
                                    {
                                        key: "isInBundle",
                                        value: "false"
                                    },
                                    {
                                        key: "order.sale",
                                        value: "$exist"
                                    }
                                ],
                                orOperations: [
                                    Object.values(selectedMySalesOrderFilter).some(function(value) {
                                        return value;
                                    }) ? Object.keys(selectedMySalesOrderFilter).map(function(orderItem) {
                                        return {
                                            key: "order.".concat(orderItem),
                                            value: "$".concat(!selectedMySalesOrderFilter[orderItem] ? "not_" : "", "exist")
                                        };
                                    }) : [
                                        {
                                            key: "order.sale",
                                            value: "$exist"
                                        },
                                        {
                                            key: "order.auction",
                                            value: "$exist"
                                        },
                                        {
                                            key: "order.offer",
                                            value: "$exist"
                                        }
                                    ],
                                    selectedMySalesCollection ? selectedMySalesCollection.assets.map(function(id) {
                                        return {
                                            key: "assetId",
                                            value: id.toString()
                                        };
                                    }) : []
                                ]
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res), {
                                from: (pageParam - 1) * 30,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchSingleItemList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var fetchBundleItemList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, res;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!activeChainId) {
                            // TODO: 예외처리
                            throw new Error("No account or chainId");
                        }
                        return [
                            4,
                            (0,item/* getUserBundleList */.TY)({
                                network: lib_network/* chainIdToMainNetworkName */.$4[activeChainId],
                                page: pageParam,
                                categoryId: selectedMySalesCollection === null || selectedMySalesCollection === void 0 ? void 0 : selectedMySalesCollection.categoryId
                            })
                        ];
                    case 1:
                        res = _state.sent();
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, res.data), {
                                from: (pageParam - 1) * 30,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchBundleItemList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref4 = (0,es.useInfiniteQuery)([
        "mysales-singleitem",
        account,
        isSwitchBundle,
        selectedMySalesOrderFilter,
        selectedMySalesCollection, 
    ], fetchSingleItemList, {
        getNextPageParam: function(lastPage) {
            if (lastPage.total > lastPage.from + 30) {
                return lastPage.nextPage;
            }
        },
        enabled: !!account && !!activeChainId && !isSwitchBundle,
        refetchOnWindowFocus: false
    }), isSingleItemsLoading = ref4.isLoading, singleItems = ref4.data, hasSingleItemsNextPage = ref4.hasNextPage, fetchSingleItemsNextPage = ref4.fetchNextPage, singleItemsError = ref4.error;
    var ref5 = (0,es.useInfiniteQuery)([
        "mysales-bundleitem",
        account,
        selectedMySalesCollection,
        isSwitchBundle
    ], fetchBundleItemList, {
        getNextPageParam: function(lastPage) {
            if (lastPage.total && lastPage.total > lastPage.from + 30) {
                return lastPage.nextPage;
            }
        },
        enabled: !!account && !!activeChainId && isSwitchBundle,
        refetchOnWindowFocus: false
    }), isBundleItemsLoading = ref5.isLoading, bundleItems = ref5.data, hasBundleItemsNextPage = ref5.hasNextPage, fetchBundleItemsNextPage = ref5.fetchNextPage, bundleItemsError = ref5.error;
    var handleSwitchBundle = function(switchState) {
        return function() {
            dispatch((0,my_account/* setIsSwitchBundle */.R7)(switchState));
        };
    };
    var handleNextPage = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _tmp, _tmp1;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _tmp = !isSwitchBundle && hasSingleItemsNextPage;
                    if (!_tmp) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        fetchSingleItemsNextPage()
                    ];
                case 1:
                    _tmp = _state.sent();
                    _state.label = 2;
                case 2:
                    _tmp;
                    _tmp1 = isSwitchBundle && hasBundleItemsNextPage;
                    if (!_tmp1) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        fetchBundleItemsNextPage()
                    ];
                case 3:
                    _tmp1 = _state.sent();
                    _state.label = 4;
                case 4:
                    _tmp1;
                    return [
                        2
                    ];
            }
        });
    }), [
        fetchSingleItemsNextPage,
        fetchBundleItemsNextPage,
        hasSingleItemsNextPage,
        hasBundleItemsNextPage,
        isSwitchBundle, 
    ]);
    var hanadleOrderFilterClick = function(orderState) {
        return function() {
            var newOrderFilter = (0,_object_spread/* default */.Z)({}, selectedMySalesOrderFilter);
            newOrderFilter[orderState] = !selectedMySalesOrderFilter[orderState];
            dispatch((0,my_account/* setSelectedMySalesOrderFilter */.rd)(newOrderFilter));
        };
    };
    var handleCollectionItemClick = function(categoryId) {
        return function() {
            if (!categoryId) {
                dispatch((0,my_account/* setSelectedMySalesCollection */.oG)(null));
            }
            if (activeChainId) {
                var activeCollection = collectionList[lib_network/* chainIdToMainNetworkName */.$4[activeChainId]].find(function(category) {
                    return category.categoryId === categoryId;
                });
                if (activeCollection) {
                    dispatch((0,my_account/* setSelectedMySalesCollection */.oG)(activeCollection));
                }
                setIsClose(true);
            }
        };
    };
    (0,react.useEffect)(function() {
        if (isClose) {
            setIsClose(function() {
                return false;
            });
        }
    }, [
        isClose
    ]);
    (0,react.useEffect)(function() {
        if (isSwitchBundle) {
            dispatch((0,my_account/* setSelectedMySalesCollection */.oG)(null));
        }
    }, [
        isSwitchBundle,
        dispatch
    ]);
    (0,react.useEffect)(function() {
        if (loadMoreRefInView) {
            handleNextPage();
        }
    }, [
        loadMoreRefInView,
        handleNextPage
    ]);
    (0,react.useEffect)(function() {
        dispatch((0,my_account/* setIsSwitchBundle */.R7)(salesType === "bundle"));
    }, [
        dispatch,
        salesType
    ]);
    var ref6, ref7;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaTag/* default */.Z, {
                title: "My Sales | PlayDapp"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_SelectOptionArea, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SalesOptionBox, {
                        children: !isSwitchBundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2_CustomButton, {
                                className: classnames_default()({
                                    selected: selectedMySalesOrderFilter.offer
                                }),
                                onClick: hanadleOrderFilterClick("offer"),
                                size: "xs",
                                variant: "outline",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                    color: "primary700",
                                    type: isMobile ? "b4" : "p3",
                                    children: "Has Offer"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectBundleArea, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectBundleBox, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectBundleItem, {
                                        color: "primary",
                                        variant: isSwitchBundle ? "ghost" : "solid",
                                        size: "xs",
                                        onClick: handleSwitchBundle(false),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "".concat(isSwitchBundle ? "square-blank" : "square-white"),
                                                size: 14
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: "p3",
                                                component: "p",
                                                color: isSwitchBundle ? "gray900" : "white",
                                                children: "single"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SelectBundleItem, {
                                        color: "primary",
                                        variant: !isSwitchBundle ? "ghost" : "solid",
                                        size: "xs",
                                        onClick: handleSwitchBundle(true),
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "".concat(!isSwitchBundle ? "grid-blank" : "grid-white"),
                                                size: 14
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: "p3",
                                                component: "p",
                                                color: !isSwitchBundle ? "gray900" : "white",
                                                children: "bundle"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionDrop, {
                                title: (ref6 = selectedMySalesCollection === null || selectedMySalesCollection === void 0 ? void 0 : selectedMySalesCollection.title) !== null && ref6 !== void 0 ? ref6 : "All Collection",
                                width: "262",
                                height: "36",
                                top: "48",
                                isBorder: true,
                                isDropBox: true,
                                floatingContent: true,
                                isClose: isClose,
                                disabled: isSwitchBundle,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownSortContent, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownItem, {
                                            onClick: handleCollectionItemClick(0),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                    prefix: "s3",
                                                    src: "/collections/all.png",
                                                    alt: "all",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    type: "p3",
                                                    color: "dgray400",
                                                    component: "p",
                                                    children: "All Collection"
                                                })
                                            ]
                                        }),
                                        activeChainId && collectionList[lib_network/* chainIdToMainNetworkName */.$4[activeChainId]].map(function(category) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownItem, {
                                                onClick: handleCollectionItemClick(category.categoryId),
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                        src: category.thumbnailUrl,
                                                        alt: "collection",
                                                        width: 24,
                                                        height: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                        type: "p3",
                                                        color: "dgray400",
                                                        component: "p",
                                                        children: category.title
                                                    })
                                                ]
                                            }, category.categoryId);
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileCollectionDrop, {
                                title: (ref7 = selectedMySalesCollection === null || selectedMySalesCollection === void 0 ? void 0 : selectedMySalesCollection.title) !== null && ref7 !== void 0 ? ref7 : "All Collection",
                                width: "100%",
                                height: "40",
                                top: "40",
                                isBorder: true,
                                floatingContent: true,
                                isMobile: true,
                                isClose: isClose,
                                disabled: isSwitchBundle,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownSortContent, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownItem, {
                                            onClick: handleCollectionItemClick(0),
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                    prefix: "s3",
                                                    src: "/collections/all.png",
                                                    alt: "all",
                                                    width: 24,
                                                    height: 24
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    type: "p3",
                                                    color: "dgray400",
                                                    component: "p",
                                                    children: "All Collection"
                                                })
                                            ]
                                        }),
                                        activeChainId && collectionList[lib_network/* chainIdToMainNetworkName */.$4[activeChainId]].map(function(category) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_DropDownItem, {
                                                onClick: handleCollectionItemClick(category.categoryId),
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                        src: category.thumbnailUrl,
                                                        alt: "collection",
                                                        width: 24,
                                                        height: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                        type: "p3",
                                                        color: "dgray400",
                                                        component: "p",
                                                        children: category.title
                                                    })
                                                ]
                                            }, category.categoryId);
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            !isSwitchBundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_ContentBody, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_CardListBox, {
                        children: [
                            isSingleItemsLoading && times_default()(30, function(index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                    isLoading: true
                                }, index);
                            }),
                            singleItems === null || singleItems === void 0 ? void 0 : singleItems.pages.map(function(items) {
                                var assets = items.assets;
                                return Object.values(assets).map(function(param, index) {
                                    var name = param.name, imageUri = param.imageUri, animationUri = param.animationUri, tokenId = param.tokenId, network = param.network, assetAddress = param.assetAddress, owner = param.owner, order = param.order, likeCount = param.likeCount, collectionInfo = param.collectionInfo;
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                        collectionInfo: collectionInfo,
                                        imageUri: imageUri,
                                        animationUri: animationUri,
                                        tokenId: tokenId,
                                        name: name,
                                        order: order,
                                        convertedPrice: convertToUsd((ref = order.sale) === null || ref === void 0 ? void 0 : ref.price, network, (ref1 = order.sale) === null || ref1 === void 0 ? void 0 : ref1.currency),
                                        like: (0,util/* numberToAbbreviateString */.iT)(likeCount),
                                        network: network,
                                        href: "/item/".concat(network, "/").concat(assetAddress, "/").concat(tokenId),
                                        assetAddress: assetAddress,
                                        isOwner: owner === account
                                    }, "".concat(name, "_").concat(tokenId, "-").concat(index));
                                });
                            }),
                            hasSingleItemsNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                        isLoading: true,
                                        ref: loadMoreRef
                                    }),
                                    times_default()(9, function(index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                            isLoading: true
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    !singleItemsError && (singleItems === null || singleItems === void 0 ? void 0 : singleItems.pages) && (singleItems === null || singleItems === void 0 ? void 0 : singleItems.pages.length) > 0 && (singleItems === null || singleItems === void 0 ? void 0 : singleItems.pages[0].total) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {})
                    }),
                    !isSingleItemsLoading && singleItemsError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                    })
                ]
            }),
            isSwitchBundle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_ContentBody, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MySales2_CardListBox, {
                        children: [
                            isBundleItemsLoading && times_default()(30, function(index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                    isLoading: true
                                }, index);
                            }),
                            bundleItems === null || bundleItems === void 0 ? void 0 : bundleItems.pages.map(function(items) {
                                var bundles = items.bundles;
                                if (!bundles) {
                                    return null;
                                }
                                return Object.values(bundles).map(function(param, index) {
                                    var name = param.name, slug = param.slug, imageUri = param.imageUri, network = param.network, likeCount = param.likeCount, owner = param.owner, order = param.order;
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                        imageUri: imageUri,
                                        name: name,
                                        order: order,
                                        convertedPrice: convertToUsd((ref = order.sale) === null || ref === void 0 ? void 0 : ref.price, network, (ref1 = order.sale) === null || ref1 === void 0 ? void 0 : ref1.currency),
                                        like: (0,util/* numberToAbbreviateString */.iT)(likeCount),
                                        network: network,
                                        href: "/bundle/".concat(network, "/").concat(slug),
                                        isOwner: owner === account
                                    }, "".concat(name, "_").concat(slug, "-").concat(index));
                                });
                            }),
                            hasBundleItemsNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                        isLoading: true,
                                        ref: loadMoreRef
                                    }),
                                    times_default()(9, function(index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                            isLoading: true
                                        }, index);
                                    })
                                ]
                            })
                        ]
                    }),
                    !bundleItemsError && (bundleItems === null || bundleItems === void 0 ? void 0 : bundleItems.pages) && (bundleItems === null || bundleItems === void 0 ? void 0 : bundleItems.pages.length) > 0 && (bundleItems === null || bundleItems === void 0 ? void 0 : bundleItems.pages[0].total) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {})
                    }),
                    !isBundleItemsLoading && bundleItemsError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MySales2 = (MySales);

// EXTERNAL MODULE: ./src/hooks/useMoonpay.tsx
var useMoonpay = __webpack_require__(3485);
// EXTERNAL MODULE: ./src/hooks/useTransak.ts
var useTransak = __webpack_require__(1);
// EXTERNAL MODULE: ./src/hooks/useSimplex.tsx + 2 modules
var useSimplex = __webpack_require__(57575);
;// CONCATENATED MODULE: ./src/components/MyBalance2.tsx
















var MyBalance2_ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy10"
})("width:100%;min-height:40vh;");
var Title = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy11"
})("position:relative;", (0,index_esm/* fontStyle */.p_)("b2"), ";margin:0 auto ", index_esm/* spacing.xl */.W0.xl, " auto;text-align:center;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.h5 */.JB.h5, ";}");
var CardsGroupArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy12"
})("display:flex;justify-content:center;align-items:center;row-gap:", index_esm/* spacing.l */.W0.l, ";column-gap:", function(param) {
    var currency = param.currency;
    return currency ? 0 : index_esm/* spacing.l */.W0.l;
}, ";margin-bottom:", index_esm/* spacing.m */.W0.m, ";border-left:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{flex-direction:", function(props) {
    return props.network !== "solana" && "column";
}, ";}");
var BalanceCardBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy13"
})("display:flex;justify-content:", function(param) {
    var network = param.network;
    return network === "solana" ? "flex-start" : "space-between";
}, ";align-items:center;width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(112);
}, ";padding:0 ", index_esm/* spacing.xl */.W0.xl, ";margin:", function(param) {
    var network = param.network;
    return network === "solana" ? "0 " : "auto";
}, ";border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";border-left:none;border-radius:", function(param) {
    var currency = param.currency;
    return currency ? index_esm/* spacing.m */.W0.m : 0;
}, ";box-shadow:", function(param) {
    var currency = param.currency;
    return currency && "0px ".concat(index_esm/* spacing.xxs */.W0.xxs, " ").concat(index_esm/* spacing.xs */.W0.xs, " 0px #1e1f2426");
}, ";background-color:", index_esm/* palette.white */.DG.white, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{width:100%;height:100%;padding:", index_esm/* spacing.m */.W0.m, ";margin-bottom:0;text-transform:uppercase;}");
var AddFundArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy14"
})("padding:", index_esm/* spacing.xxl */.W0.xxl, ";margin:", index_esm/* spacing.xxl */.W0.xxl, " 0;border-radius:", index_esm/* spacing.xl */.W0.xl, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;text-align:center;margin-bottom:0;}");
var FundTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy15"
})("display:flex;justify-content:center;align-items:center;margin-bottom:28px;gap:", index_esm/* spacing.l */.W0.l, ";", (0,index_esm/* fontStyle */.p_)("b2"), ";font-size:24px;font-weight:600;", index_esm/* breakpoints.down */.AV.down("sm"), "{gap:10px;", (0,index_esm/* fontStyle */.p_)("b3"), ";}");
var BalanceCardText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy16"
})("padding-top:", function(param) {
    var isPlaCurrency = param.isPlaCurrency, isConnection = param.isConnection;
    return isPlaCurrency && isConnection && index_esm/* spacing.xl */.W0.xl;
}, ";text-align:right;> div{display:flex;justify-content:flex-end;align-items:center;}", index_esm/* breakpoints.down */.AV.down("lg"), "{padding:0;}");
var SolanaBalanceCardTextBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy17"
})("margin-left:", index_esm/* spacing.s */.W0.s, ";div:nth-of-type(1){", (0,index_esm/* fontStyle */.p_)("p4"), ";}");
var AddFundButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy18"
})("display:grid;justify-items:center;row-gap:", function(param) {
    var theme = param.theme;
    return theme.rem(10);
}, ";width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(205);
}, ";max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(250);
}, ";padding:", index_esm/* spacing.xl */.W0.xl, " ", index_esm/* spacing.l */.W0.l, ";border-radius:", index_esm/* spacing.m */.W0.m, ";box-shadow:0px 4px 8px rgba(30,31,36,0.15);background-color:", index_esm/* palette.white */.DG.white, ";text-align:center;cursor:pointer;&:hover{opacity:0.8;}&:active{opacity:0.7;}", index_esm/* breakpoints.down */.AV.down("lg"), "{width:100%;height:auto;min-height:auto;margin:auto;row-gap:", index_esm/* spacing.m */.W0.m, ";font-weight:600;}");
var CardButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy19"
})("display:flex;flex-direction:column;align-items:center;width:50%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(84);
}, ";row-gap:", index_esm/* spacing.xxs */.W0.xxs, ";padding:", index_esm/* spacing.xl */.W0.xl, " ", index_esm/* spacing.l */.W0.l, ";", (0,index_esm/* fontStyle */.p_)("b3"), ";border-radius:16px;box-shadow:0px ", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.xs */.W0.xs, " 0px #1e1f2426;background-color:", index_esm/* palette.white */.DG.white, ";text-align:center;cursor:pointer;&:hover{opacity:0.8;}&:active{opacity:0.7;}", index_esm/* breakpoints.down */.AV.down("sm"), "{", (0,index_esm/* fontStyle */.p_)("b5"), "}");
var NoticeText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy110"
})("max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(840);
}, ";margin:", index_esm/* spacing.xl */.W0.xl, " auto 0 auto;font-weight:400;text-align:center;", function(props) {
    return props.network === "solana" ? "".concat(index_esm/* breakpoints.down */.AV.down("sm"), " {\n    font-size: ").concat(index_esm/* fontSize.p5 */.JB.p5, ";\n      };") : "".concat(index_esm/* breakpoints.down */.AV.down("lg"), " {\n    padding: ").concat(index_esm/* spacing.xxs */.W0.xxs, ";\n    margin: ").concat(index_esm/* spacing.l */.W0.l, " auto 0 auto;\n    font-size: ").concat(index_esm/* fontSize.b4 */.JB.b4, ";\n    text-align: left;\n  };");
});
var CardTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy111"
})("font-weight:600;");
var BalanceCount = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "evrwdy112"
})((0,index_esm/* fontStyle */.p_)("b1"), ";");
var BalanceLoadingBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy113"
})("display:flex;align-items:center;justify-content:center;span{", (0,index_esm/* fontStyle */.p_)("b3"), ";margin-right:", index_esm/* spacing.xs */.W0.xs, ";}");
var BalanceCurrency = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "evrwdy114"
})((0,index_esm/* fontStyle */.p_)("p3"), ";margin-left:", index_esm/* spacing.xs */.W0.xs, ";text-transform:uppercase;");
var CurrencyBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy115"
})("display:flex;flex-wrap:wrap;white-space:nowrap;gap:", index_esm/* spacing.xs */.W0.xs, ";");
var BridgeText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy116"
})("margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.rem(10);
}, ";");
var CardModalBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy117"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;");
var CardModalTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy118"
})("text-align:center;line-height:1.5;");
var CardModalContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy119"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;width:100%;padding:", index_esm/* spacing.l */.W0.l, ";margin-top:", index_esm/* spacing.xl */.W0.xl, ";border-radius:", index_esm/* spacing.m */.W0.m, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";& > span{margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";}div{&:hover{opacity:0.8;}&:active{opacity:0.8;}}div + div{margin-top:", index_esm/* spacing.m */.W0.m, ";}");
var CardModalButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy120"
})("display:flex;justify-content:space-between;align-items:center;width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.xxl */.W0.xxl, ";border:1px solid ", index_esm/* palette.black */.DG.black, ";border-radius:", index_esm/* spacing.xl */.W0.xl, ";background-color:", index_esm/* palette.white */.DG.white, ";p{margin-right:", index_esm/* spacing.xs */.W0.xs, ";}");
var ExchangeModalBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy121"
})("display:flex;flex-direction:column;align-items:center;justify-content:center;");
var ExchangeModalTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy122"
})("text-align:center;line-height:1.5;");
var ExchangeModalContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "evrwdy123"
})("display:flex;align-items:center;justify-content:center;flex-direction:column;width:100%;padding:", index_esm/* spacing.l */.W0.l, ";margin-top:", index_esm/* spacing.xl */.W0.xl, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:", index_esm/* spacing.m */.W0.m, ";& > p{margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";}a{&:hover{opacity:0.8;}&:active{opacity:0.8;}}a + a{margin-top:", index_esm/* spacing.m */.W0.m, ";}");
var ExchangeModalLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "evrwdy124"
})("display:flex;justify-content:space-between;align-items:center;width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.xxl */.W0.xxl, ";border:1px solid ", index_esm/* palette.black */.DG.black, ";border-radius:", index_esm/* spacing.xl */.W0.xl, ";background-color:", index_esm/* palette.white */.DG.white, ";p{margin-right:", index_esm/* spacing.xs */.W0.xs, ";}");
var exchangeTarget = {
    ethereum: [
        {
            name: "Coinbase",
            brand: "coinbase",
            imageWidth: "79px",
            imageHeight: "14.11px",
            href: "https://www.coinbase.com/price/playdapp"
        },
        {
            name: "Binance",
            brand: "binance",
            imageWidth: "79px",
            imageHeight: "16px",
            href: "https://www.binance.com/en"
        },
        {
            name: "Upbit - Korea",
            brand: "upbit",
            imageWidth: "85px",
            imageHeight: "14px",
            href: "https://upbit.com/exchange?code=CRIX.UPBIT.KRW-PLA"
        },
        {
            name: "Kraken",
            brand: "krake",
            imageWidth: "83px",
            imageHeight: "13.06px",
            href: "https://www.kraken.com/prices/pla-playdapp-price-chart/usd-us-dollar?interval=1m"
        },
        {
            name: "Find more exchanges",
            brand: "marketcap",
            imageWidth: "93px",
            imageHeight: "16px",
            href: "https://coinmarketcap.com/currencies/playdapp/markets/"
        }, 
    ],
    polygon: [
        {
            name: "Binance",
            brand: "binance",
            imageWidth: "79px",
            imageHeight: "16px",
            href: "https://www.binance.com/en"
        },
        {
            name: "Find more exchanges",
            brand: "marketcap",
            imageWidth: "93px",
            imageHeight: "16px",
            href: "https://coinmarketcap.com/currencies/playdapp/markets/"
        }, 
    ],
    solana: [],
    klaytn: []
};
var MyBalance = function(param) {
    var isTransactionOpen = param.isTransactionOpen;
    var ref = (0,react.useState)(false), isFirstTransacOpen = ref[0], setIsFirstTransacOpen = ref[1];
    var ref1 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), provider = ref1.provider, balance = ref1.balance, isBalanceLoading = ref1.isBalanceLoading, isBalanceError = ref1.isBalanceError, activeChainId = ref1.activeChainId;
    var isMobile = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("sm")), false);
    var ref2 = (0,useMoonpay/* default */.Z)(), MoonPayModal = ref2.MoonPayModal, isOpenMoonpay = ref2.isOpen, handleOpenMoonpay = ref2.handleOpen;
    var ref3 = (0,useSimplex/* default */.Z)(), SimplexModal = ref3.SimplexModal, isOpenSimplex = ref3.isOpen, handleOpenSimplex = ref3.handleOpen;
    var handleOpenTransak = (0,useTransak/* default */.Z)().handleOpenTransak;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isCardModalOpen = ref4[0], handleCardModalOpen = ref4[1];
    var ref5 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isExchangeModalOpen = ref5[0], handleExchangeModalOpen = ref5[1];
    var network = (0,react.useMemo)(function() {
        return lib_network/* chainIdToMainNetworkName */.$4[activeChainId || 137];
    }, [
        activeChainId
    ]);
    var isMdDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")));
    var nativeCurrencyName = (0,react.useMemo)(function() {
        return {
            1: "eth",
            11155111: "eth",
            137: "matic",
            80002: "matic",
            1001: "klay",
            8217: "klay"
        };
    }, []);
    var onBuyWithCard = function() {
        handleCardModalOpen(true);
    };
    var onSwap = function() {
        var swapUrl = {
            ethereum: "https://app.uniswap.org/#/swap",
            polygon: "https://quickswap.exchange/#/swap",
            klaytn: ""
        };
        if (activeChainId && network !== "solana") window.open(swapUrl[network], "_blank");
    };
    var onTransfer = function() {
        window.open("https://wallet.polygon.technology/login?next=%2Fbridge", "_blank");
    };
    var onExchange = function() {
        handleExchangeModalOpen(true);
    };
    (0,react.useEffect)(function() {
        if (isTransactionOpen && !isFirstTransacOpen) {
            setIsFirstTransacOpen(true);
            handleOpenTransak();
        }
    }, [
        isTransactionOpen,
        isFirstTransacOpen,
        handleOpenTransak
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaTag/* default */.Z, {
                title: "My Balance | PlayDapp"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyBalance2_ContentBody, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGroupArea, {
                        network: "",
                        currency: true,
                        children: [
                            !isBalanceLoading && balance && network !== "solana" && Object.keys(balance).map(function(currency) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceCardBox, {
                                    network: network,
                                    currency: false,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                            name: "currency-".concat(currency),
                                            size: 48
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceCardText, {
                                            isPlaCurrency: currency === "pla",
                                            isConnection: provider === "metamask",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceCount, {
                                                        children: balance[currency].toFixed(4)
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceCurrency, {
                                                        children: currency.toUpperCase()
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }, currency);
                            }),
                            network === "solana" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceCardBox, {
                                        network: network,
                                        currency: false,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "currency-sol",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SolanaBalanceCardTextBlock, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        children: "Main Wallet"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceCount, {
                                                                children: [
                                                                    isBalanceLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceLoadingBox, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                children: "loading..."
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Progress */.Ex, {
                                                                                size: "small",
                                                                                color: index_esm/* palette.primary600 */.DG.primary600
                                                                            })
                                                                        ]
                                                                    }),
                                                                    !isBalanceLoading && isBalanceError && "Load Failed",
                                                                    !isBalanceLoading && !isBalanceError && (balance === null || balance === void 0 ? void 0 : balance.sol.toLocaleString())
                                                                ]
                                                            }),
                                                            !isBalanceLoading && !isBalanceError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceCurrency, {
                                                                children: "SOL"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceCardBox, {
                                        network: network,
                                        currency: false,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "currency-sol",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SolanaBalanceCardTextBlock, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                                                        children: "Escrow Wallet"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceCount, {
                                                                children: [
                                                                    isBalanceLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BalanceLoadingBox, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                                                                children: "loading..."
                                                                            }),
                                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Progress */.Ex, {
                                                                                size: "small",
                                                                                color: index_esm/* palette.primary600 */.DG.primary600
                                                                            })
                                                                        ]
                                                                    }),
                                                                    !isBalanceLoading && isBalanceError && "Load Failed",
                                                                    !isBalanceLoading && !isBalanceError && (balance === null || balance === void 0 ? void 0 : balance.escrowSol.toLocaleString())
                                                                ]
                                                            }),
                                                            !isBalanceLoading && !isBalanceError && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BalanceCurrency, {
                                                                children: "SOL"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    network !== "solana" && network !== "klaytn" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundArea, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Title, {
                                children: "Add funds"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGroupArea, {
                                network: "",
                                currency: false,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundButton, {
                                        role: "button",
                                        onClick: onBuyWithCard,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "card",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, {
                                                children: "Buy with card"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrencyBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-pla",
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-".concat(nativeCurrencyName[activeChainId || 137]),
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-weth",
                                                        size: 24
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundButton, {
                                        role: "button",
                                        onClick: onSwap,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "swap",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, {
                                                children: "Swap"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrencyBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-pla",
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-".concat(nativeCurrencyName[activeChainId || 137]),
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-weth",
                                                        size: 24
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    (activeChainId === 137 || activeChainId === 80002) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundButton, {
                                        role: "button",
                                        onClick: onTransfer,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "analyse",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, {
                                                        children: "Transfer"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BridgeText, {
                                                        children: "via Polygon Bridge"
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrencyBox, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "currency-eth",
                                                                size: 24
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "currency-matic-dark",
                                                                size: 24
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "arrow-right",
                                                                size: 24
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "currency-weth",
                                                                size: 24
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "currency-matic",
                                                                size: 24
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundButton, {
                                        role: "button",
                                        onClick: onExchange,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "exchange",
                                                size: 48
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardTitle, {
                                                children: "Buy PLA from Exchange"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrencyBox, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-pla",
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "currency-".concat(nativeCurrencyName[activeChainId || 137]),
                                                        size: 24
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NoticeText, {
                                network: "polygon",
                                currency: false,
                                children: network !== "ethereum" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    children: [
                                        "You can buy PLA, Matic and WETH with your credit card.",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        " If you already have swap-able assets and wish to exchange them for another one, you can use QuickSwap. ",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        "If you have assets on a different main network, you can use Polygon Bridge provided by the official Polygon Wallet service to receive your asset to the Polygon network"
                                    ]
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("span", {
                                    children: [
                                        "You can buy PLA and ETH with your credit card.",
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                                        " If you already have swappable assets and wish to exchange them, you can go to Uniswap via swap button."
                                    ]
                                })
                            })
                        ]
                    }),
                    network === "solana" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(AddFundArea, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FundTitle, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                        name: "card",
                                        size: isMobile ? 20 : 40
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                                        children: "Buy with card"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardsGroupArea, {
                                network: "solana",
                                currency: false,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardButton, {
                                        role: "button",
                                        onClick: function() {
                                            return handleOpenSimplex(!isOpenSimplex);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "simplex",
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: isMobile ? "b5" : "b3",
                                                children: "Simplex"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardButton, {
                                        role: "button",
                                        onClick: function() {
                                            return handleOpenMoonpay(!isOpenMoonpay);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "moonpay",
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: isMobile ? "b5" : "b3",
                                                children: "Moonpay"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardButton, {
                                        role: "button",
                                        onClick: handleOpenTransak,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "transak",
                                                size: 24
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: isMobile ? "b5" : "b3",
                                                children: "Transak"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
                        isOpen: isCardModalOpen,
                        handleOpen: handleCardModalOpen,
                        shouldCloseOnOverlayClick: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalBlock, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardModalTitle, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                        type: "h4",
                                        children: "Buy with card"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalContent, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            type: "b1",
                                            children: "Add Funds"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalButton, {
                                            onClick: function() {
                                                return handleOpenSimplex(!isOpenSimplex);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    type: "b3",
                                                    children: "To Simplex"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                    name: "simplexLogo",
                                                    width: 81,
                                                    height: 39,
                                                    alt: "card-brand"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalButton, {
                                            onClick: function() {
                                                return handleOpenMoonpay(!isOpenMoonpay);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    type: "b3",
                                                    children: "To Moonpay"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                    name: "moonpayLogo",
                                                    width: 81,
                                                    height: 39,
                                                    alt: "card-brand"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardModalButton, {
                                            onClick: handleOpenTransak,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    type: "b3",
                                                    children: "To Transak"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                    name: "transakLogo",
                                                    width: 81,
                                                    height: 39,
                                                    alt: "card-brand"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimplexModal, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MoonPayModal, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Modal */.u_, {
                        isOpen: isExchangeModalOpen,
                        handleOpen: handleExchangeModalOpen,
                        shouldCloseOnOverlayClick: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExchangeModalBlock, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExchangeModalTitle, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            type: "h4",
                                            children: "Buy "
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Typography */.ZT, {
                                            type: "h4",
                                            color: "marketplace",
                                            children: [
                                                (0,util/* toPascalCase */.Mh)(network),
                                                " PLA"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            type: "h4",
                                            children: " from Exchange"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExchangeModalContent, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                            type: "b1",
                                            component: "p",
                                            children: "Add Funds"
                                        }),
                                        exchangeTarget[network].map(function(item) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ExchangeModalLink, {
                                                href: item.href,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Typography */.ZT, {
                                                        type: isMdDownScreen ? "b4" : "b2",
                                                        component: "p",
                                                        children: [
                                                            "To ",
                                                            item.name
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                                        prefix: "s3",
                                                        src: "/exchange/".concat(item.brand, ".png"),
                                                        width: item.imageWidth,
                                                        height: item.imageHeight,
                                                        alt: "exchange-brand"
                                                    })
                                                ]
                                            }, item.name);
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MyBalance2 = (MyBalance);

;// CONCATENATED MODULE: ./src/styles/pages/collection.ts

function collection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n      height: ",
        ";\n      margin-bottom: ",
        ";\n    "
    ]);
    collection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function collection_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      width: ",
        ";\n      height: ",
        ";\n      margin-top: ",
        ";\n      margin-right: ",
        ";\n      margin-bottom: 0;\n    "
    ]);
    collection_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var ExploreBox = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "ea4cjlg0"
})("display:flex;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(1920);
}, ";margin:0 auto;")));
var EmptyBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg1"
})("display:flex;justify-content:center;align-items:center;width:100%;height:100%;min-height:50vh;", index_esm/* breakpoints.down */.AV.down("lg"), "{min-width:100%;}");
var FilterButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "ea4cjlg2"
})("border-radius:", function(param) {
    var theme = param.theme;
    return theme.rem(17);
}, ";color:", function(param) {
    var outline = param.outline;
    return !outline && "white";
}, ";background:", function(param) {
    var outline = param.outline;
    return !outline && "#12CEB0";
}, ";border:", function(param) {
    var outline = param.outline;
    return !outline && "1px solid #0d917b";
}, ";font-size:", function(param) {
    var fullSizing = param.fullSizing;
    return fullSizing ? index_esm/* fontSize.p3 */.JB.p3 : index_esm/* fontSize.p5 */.JB.p5;
}, ";white-space:nowrap;&:hover{background:", function(param) {
    var outline = param.outline;
    return !outline && "#0d917b";
}, ";}");
var FilterButtonBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg3"
})("display:flex;align-items:center;div{margin-left:", index_esm/* spacing.s */.W0.s, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:600;color:", index_esm/* palette.primary600 */.DG.primary600, ";cursor:pointer;}span{max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(180);
}, ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-weight:700;font-size:", index_esm/* fontSize.b5 */.JB.b5, ";color:", index_esm/* palette.dgray500 */.DG.dgray500, ";}");
var FilterButtonMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(FilterButton, {
    target: "ea4cjlg4"
})("align-items:center;width:", function(param) {
    var theme = param.theme;
    return theme.rem(80);
}, ";height:", function(param) {
    var theme = param.theme;
    return theme.rem(32);
}, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:600;border-radius:", function(param) {
    var theme = param.theme;
    return theme.rem(24);
}, ";border:0;");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "ea4cjlg5"
})("position:relative;left:", function(param) {
    var theme = param.theme;
    return theme.rem(308);
}, ";display:flex;flex-direction:column;height:100%;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return "calc(100% - ".concat(theme.rem(340), ")");
}, ";overflow:hidden;margin-top:4.5rem;", index_esm/* breakpoints.down */.AV.down("xl"), "{margin-top:4rem;}", index_esm/* breakpoints.down */.AV.down("lg"), "{left:", function(param) {
    var theme = param.theme;
    return theme.rem(265);
}, ";max-width:", function(param) {
    var theme = param.theme;
    return "calc(100% - ".concat(theme.rem(265), ")");
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{left:0;max-width:100%;margin-top:3.5rem;}");
var CategoryTitleBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg6"
})("position:relative;display:", function(param) {
    var isTitleBanner = param.isTitleBanner;
    return isTitleBanner ? "flex" : "none";
}, ";width:100%;height:100%;margin-top:", index_esm/* spacing.xxl */.W0.xxl, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", index_esm/* spacing.s */.W0.s, ";}");
var CategoryTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg7"
})("display:flex;justify-content:space-between;margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(90);
}, ";width:100%;z-index:2;", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", index_esm/* spacing.xxxl */.W0.xxxl, ";padding-bottom:0px;}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(14);
}, ";align-items:center;border-bottom:0px;}");
var TitleBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg8"
})("position:relative;display:flex;flex-direction:column;align-items:flex-start;align-self:center;margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(110);
}, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(46);
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(335);
}, ";margin-top:0;margin-bottom:0;align-items:center;}");
var CategoryName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg9"
})("display:flex;align-items:center;margin:", function(param) {
    var theme = param.theme;
    return "".concat(theme.rem(30), " ").concat(theme.rem(10), " 0 0");
}, ";span{font-size:", index_esm/* fontSize.h4 */.JB.h4, ";font-weight:700;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.p1 */.JB.p1, ";margin:", function(param) {
    var theme = param.theme;
    return "".concat(theme.rem(12), " ").concat(theme.rem(10), " 0 0");
}, ";max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(270);
}, ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-align:center;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;white-space:normal;text-align:initial;margin:", index_esm/* spacing.s */.W0.s, " 0 0 0;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(200);
}, ";font-size:", index_esm/* fontSize.h4 */.JB.h4, ";font-size:1rem;}}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";margin-top:4rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;}");
var VisitSiteButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "ea4cjlg10"
})("margin:0 0 0 ", index_esm/* spacing.m */.W0.m, ";min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(80);
}, ";background:inherit;color:", index_esm/* palette.dgray600 */.DG.dgray600, ";font-weight:600;font-size:", index_esm/* fontSize.p4 */.JB.p4, ";padding:", function(param) {
    var theme = param.theme;
    return "".concat(theme.rem(6), " ").concat(theme.rem(10), " ").concat(theme.rem(6), " ").concat(theme.rem(14));
}, ";border:1px solid ", index_esm/* palette.gray900 */.DG.gray900, ";border-radius:2rem;& > a{gap:", function(param) {
    var theme = param.theme;
    return theme.rem(6);
}, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{margin:", function(param) {
    var theme = param.theme;
    return "".concat(theme.rem(15), " ").concat(theme.rem(10), " 0 0");
}, ";}:hover,active{background:rgba(153,156,168,0.15);}");
var VisitSiteButtonMobile = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg11"
})("display:inline-flex;align-items:center;justify-content:center;width:", index_esm/* spacing.xl */.W0.xl, ";height:", index_esm/* spacing.xl */.W0.xl, ";margin:", index_esm/* spacing.s */.W0.s, " 0 0 0;margin-left:", index_esm/* spacing.s */.W0.s, ";border:1px solid ", index_esm/* palette.gray900 */.DG.gray900, ";border-radius:100%;cursor:pointer;");
var ThumbnailBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg12"
})("display:flex;align-self:center;margin-top:", index_esm/* spacing.m */.W0.m, ";margin-right:", index_esm/* spacing.xl */.W0.xl, ";border:2px solid ", index_esm/* palette.white */.DG.white, ";border-radius:", function(param) {
    var theme = param.theme;
    return theme.rem(120);
}, ";z-index:2;", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-bottom:0;}", function(param) {
    var isTablet = param.isTablet, theme = param.theme;
    return isTablet && (0,emotion_react_browser_esm/* css */.iv)(collection_templateObject(), theme.rem(94), theme.rem(90), index_esm/* spacing.xxxl */.W0.xxxl);
}, ";", function(param) {
    var isMobile = param.isMobile, theme = param.theme;
    return isMobile && (0,emotion_react_browser_esm/* css */.iv)(collection_templateObject1(), theme.rem(54), theme.rem(50), index_esm/* spacing.xl */.W0.xl, index_esm/* spacing.l */.W0.l);
}, ";");
var CategoryImage = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Image, {
    target: "ea4cjlg13"
})("border-radius:100%;z-index:2;")));
var CategoryDesc = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg14"
})("display:", function(param) {
    var isReadMoreActive = param.isReadMoreActive;
    return isReadMoreActive ? "flex" : " -webkit-box";
}, ";-webkit-box-orient:vertical;-webkit-line-clamp:3;max-width:", function(param) {
    var theme = param.theme;
    return "calc(100% - ".concat(theme.rem(100), ")");
}, ";max-height:", function(param) {
    var isReadMoreActive = param.isReadMoreActive, theme = param.theme;
    return isReadMoreActive ? "100%" : theme.rem(72);
}, ";margin-top:", index_esm/* spacing.xs */.W0.xs, ";overflow:hidden;text-overflow:ellipsis;color:", index_esm/* palette.gray900 */.DG.gray900, ";", index_esm/* breakpoints.down */.AV.down("md"), "{position:initial;width:100%;max-width:100%;margin:0;margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";font-size:", index_esm/* fontSize.p5 */.JB.p5, ";padding-top:0;}");
var CategoryBorder = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg15"
})("display:flex;width:100%;height:1px;border-bottom:1px solid ", index_esm/* palette.gray500 */.DG.gray500, ";margin-top:", index_esm/* spacing.m */.W0.m, ";", index_esm/* breakpoints.down */.AV.down("md"), "{display:none;}");
var ReadMore = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg16"
})("position:absolute;right:0;bottom:", function(param) {
    var theme = param.theme;
    return theme.rem(30);
}, ";text-decoration:underLine;color:", index_esm/* palette.primary600 */.DG.primary600, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:600;cursor:pointer;", index_esm/* breakpoints.down */.AV.down("md"), "{right:calc(50% - 2rem);bottom:0;font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}");
var Banner = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg17"
})("position:absolute;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(1580);
}, ";background-position:center center;background-repeat:no-repeat;background-size:cover;border-radius:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.up */.AV.up("lg"), "{height:", function(param) {
    var theme = param.theme;
    return theme.rem(210);
}, ";background-image:image-set(\n      url(", function(param) {
    var url = param.url;
    return url;
}, ") 1x,url(", function(param) {
    var url = param.url;
    return url;
}, ") 2x\n    );}", index_esm/* breakpoints.between */.AV.between("md", "lg"), "{height:", function(param) {
    var theme = param.theme;
    return theme.rem(110);
}, ";background-image:image-set(\n      url(", function(param) {
    var url = param.url;
    return url;
}, ") 1x,url(", function(param) {
    var url = param.url;
    return url;
}, ") 2x\n    );}", index_esm/* breakpoints.down */.AV.down("md"), "{height:", function(param) {
    var theme = param.theme;
    return theme.rem(80);
}, ";background-image:image-set(\n      url(", function(param) {
    var url = param.url;
    return url;
}, ") 1x,url(", function(param) {
    var url = param.url;
    return url;
}, ") 2x\n    );}");
var ContentWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg18"
})("position:relative;width:calc(100% - ", index_esm/* spacing.xxxl */.W0.xxxl, ");max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(1226);
}, ";height:100%;padding-bottom:", index_esm/* spacing.m */.W0.m, ";margin-left:", index_esm/* spacing.xxxl */.W0.xxxl, ";margin-top:", function(param) {
    var isTitleBanner = param.isTitleBanner;
    return !isTitleBanner && index_esm/* spacing.xl */.W0.xl;
}, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{width:calc(100% - ", index_esm/* spacing.xxxl */.W0.xxxl, ");margin-left:0;margin:0 auto;margin-top:", function(param) {
    var isTitleBanner = param.isTitleBanner;
    return !isTitleBanner && index_esm/* spacing.l */.W0.l;
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{width:", function(param) {
    var theme = param.theme;
    return "calc(100% - ".concat(theme.rem(48), ")");
}, ";margin-top:0;}");
var ContentNavBar = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg19"
})("display:flex;align-items:center;justify-content:space-between;width:100%;margin-bottom:", index_esm/* spacing.m */.W0.m, ";b{display:flex;align-items:center;gap:0.875rem;}");
var ContentNavBarFixed = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "ea4cjlg20"
})("display:flex;position:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "fixed";
}, ";top:", function(param) {
    var isFixed = param.isFixed, theme = param.theme;
    return isFixed && theme.rem(56);
}, ";left:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "0px";
}, ";justify-content:space-between;align-items:center;width:100%;height:", function(param) {
    var isFixed = param.isFixed, theme = param.theme;
    return isFixed && theme.rem(52);
}, ";margin-top:", function(param) {
    var isFixed = param.isFixed;
    return !isFixed && spacing.l;
}, ";padding:", function(param) {
    var isFixed = param.isFixed, theme = param.theme;
    return isFixed && "".concat(theme.rem(10), " ").concat(spacing.xl);
}, ";backdrop-filter:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "blur(8px)";
}, ";border-top:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "1px solid ".concat(palette.gray400);
}, ";background:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "rgba(250, 250, 251, 0.95)";
}, ";box-shadow:", function(param) {
    var isFixed = param.isFixed, theme = param.theme;
    return isFixed && "0px ".concat(theme.rem(4), " ").concat(theme.rem(4), " rgba(0, 0, 0, 0.25)");
}, ";z-index:", function(param) {
    var isFixed = param.isFixed;
    return isFixed && "9";
}, ";")));
var ContentFooterFixed = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "ea4cjlg21"
})("position:fixed;bottom:0;left:0;display:flex;justify-content:center;width:100%;")));
var FixedFooterButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Button, {
    target: "ea4cjlg22"
})("width:", function(param) {
    var theme = param.theme;
    return theme.rem(260);
}, ";height:2.5rem;margin-bottom:1.25rem;box-shadow:0px 4px 4px rgba(0,0,0,0.25);backdrop-filter:blur(8px);font-weight:600;font-size:1rem;")));
var SortByDropDownMobile = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(SortByDropDown, {
    target: "ea4cjlg23"
})("align-items:flex-end;border:0px;width:", function(param) {
    var theme = param.theme;
    return theme.rem(122);
}, ";& > div{padding:0px;}")));
var collection_CardListBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg24"
})("display:grid;grid-template-columns:repeat(5,minmax(0,1fr));gap:", index_esm/* spacing.l */.W0.l, ";", index_esm/* breakpoints.down */.AV.down("xxl"), "{grid-template-columns:repeat(4,minmax(0,1fr));gap:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("xl"), "{grid-template-columns:repeat(3,minmax(0,1fr));row-gap:", index_esm/* spacing.l */.W0.l, ";column-gap:", index_esm/* spacing.xl */.W0.xl, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{grid-template-columns:repeat(2,minmax(0,1fr));gap:", index_esm/* spacing.l */.W0.l, ";margin-top:", index_esm/* spacing.l */.W0.l, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{grid-template-columns:repeat(3,minmax(0,1fr));gap:", index_esm/* spacing.m */.W0.m, ";}@media screen and (max-width:600px){grid-template-columns:repeat(2,minmax(0,1fr));}@media screen and (max-width:359px){grid-template-columns:minmax(0,1fr);gap:", index_esm/* spacing.s */.W0.s, ";}");
var collection_DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ea4cjlg25"
})("display:flex;flex-direction:column;& > div{padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";cursor:pointer;", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}}");

;// CONCATENATED MODULE: ./src/components/MyFavorite2.tsx
/* eslint-disable @typescript-eslint/no-unused-expressions */ /* eslint-disable arrow-body-style */ /* eslint-disable react/function-component-definition */ /* eslint-disable consistent-return */ /* eslint-disable react/no-array-index-key */ /* eslint-disable import/extensions */ 




















var MyFavorite2_SelectOptionArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz70"
})("display:flex;justify-content:flex-end;align-items:flex-start;width:100%;height:", function(param) {
    var theme = param.theme;
    return theme.rem(48);
}, ";margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{flex-direction:column;justify-content:space-between;align-items:flex-start;width:100%;height:auto;margin-bottom:1rem;}");
var MyFavorite2_OfferEventDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e1ecczz71"
})("position:relative;align-items:flex-end;", (0,index_esm/* fontStyle */.p_)("b4"), ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:none;}");
var MyFavorite2_MobileOfferEventDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e1ecczz72"
})("display:none;", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;align-items:flex-end;width:100%;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(200);
}, ";order:2;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:block;align-items:flex-end;width:100%;max-width:100%;order:1;div{", (0,index_esm/* fontStyle */.p_)("p3"), ";}}");
var MyFavorite2_ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz73"
})("width:100%;min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(540);
}, ";");
var MyFavorite2_DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz74"
})("display:flex;flex-direction:column;border-radius:", index_esm/* spacing.xs */.W0.xs, ";padding:0;box-shadow:0px 4px 4px rgba(0,0,0,0.25);");
var MyFavorite2_SelectBundleArea = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz75"
})("display:flex;justify-content:flex-end;align-items:center;flex:auto;text-align:center;", index_esm/* breakpoints.down */.AV.down("md"), "{display:flex;justify-content:space-between;width:100%;margin-bottom:", index_esm/* spacing.m */.W0.m, ";order:1;}");
var MyFavorite2_CollectionLink = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz76"
})("display:flex;justify-content:flex-start;width:100%;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";", (0,index_esm/* fontStyle */.p_)("p4"), ";border:none;cursor:pointer;& > span{flex:none;}&:first-of-type{border-top-left-radius:", index_esm/* spacing.xs */.W0.xs, ";border-top-right-radius:", index_esm/* spacing.xs */.W0.xs, ";}&:last-of-type{border-bottom-left-radius:", index_esm/* spacing.xs */.W0.xs, ";border-bottom-right-radius:", index_esm/* spacing.xs */.W0.xs, ";}p{margin-left:", index_esm/* spacing.s */.W0.s, ";padding-top:1px;margin-bottom:-1px;}&:hover{background-color:", index_esm/* palette.gray300 */.DG.gray300, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("p3"), ";}");
var MyFavorite2_CategoryListBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz77"
})("display:flex;flex-direction:column;align-items:flex-start;");
var MyFavorite2_LoadMore = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e1ecczz78"
})("display:flex;align-items:center;margin:", index_esm/* spacing.l */.W0.l, " auto;:hover{background:rgba(43,202,176,0.08);}& + a,a + &{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}");
var MyFavorite2_EmptyItemBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ecczz79"
})("margin-top:10rem;");
var MyFavorite = function() {
    var ref = (0,react.useState)(true), isClose = ref[0], setIsClose = ref[1];
    var ref1 = (0,react.useState)({
        title: "Recently Added",
        value: "recent"
    }), collection = ref1[0], setCollection = ref1[1];
    var ref2 = (0,react.useState)("recent"), filter = ref2[0], setFilter = ref2[1];
    var isMobile = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")), false);
    var account = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }).account;
    var email = (0,hooks/* useAppSelector */.C)(function(param) {
        var user = param.user;
        return user;
    }).email;
    var convertToUsd = (0,useTokenCurrency/* default */.Z)().convertToUsd;
    var fetchFavoriteList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, data;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!account) {
                            throw new Error("No account");
                        }
                        return [
                            4,
                            (0,user/* getMyFavorite */.pe)({
                                email: email,
                                page: pageParam,
                                filter: filter,
                                isBundle: 0
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, data), {
                                from: pageParam,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchFavoriteList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref3 = (0,es.useInfiniteQuery)([
        "myFavorite",
        account,
        filter
    ], fetchFavoriteList, {
        getNextPageParam: function(lastPage) {
            if (lastPage.count && lastPage.count > lastPage.from + 10) {
                return lastPage.nextPage;
            }
        },
        enabled: !!account && !!email,
        cacheTime: 0,
        refetchOnWindowFocus: false
    }), isLoading = ref3.isLoading, data = ref3.data, fetchNextPage = ref3.fetchNextPage, hasNextPage = ref3.hasNextPage, error = ref3.error;
    var handleFavorite = function(collectionFavoriteParam) {
        if (collection.value !== collectionFavoriteParam.value) {
            setCollection(collectionFavoriteParam);
        }
        setFilter(collectionFavoriteParam.value);
        setIsClose(true);
    };
    var handleLoadMore = function() {
        fetchNextPage();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MetaTag/* default */.Z, {
                title: "My Favorite | PlayDapp"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_SelectOptionArea, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyFavorite2_SelectBundleArea, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_OfferEventDrop, {
                            title: collection.title,
                            collectionName: "all",
                            width: "262",
                            height: "36",
                            top: "48",
                            isBorder: true,
                            isDropBox: true,
                            floatingContent: true,
                            isClose: isClose,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_DropDownSortContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyFavorite2_CategoryListBlock, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_CollectionLink, {
                                            onClick: function() {
                                                handleFavorite({
                                                    title: "Recently Added",
                                                    value: "recent"
                                                });
                                            },
                                            children: "Recently Added"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_CollectionLink, {
                                            onClick: function() {
                                                handleFavorite({
                                                    title: "Most Favorite",
                                                    value: "count"
                                                });
                                            },
                                            children: "Most Favorite"
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_MobileOfferEventDrop, {
                            title: collection.title,
                            width: "100%",
                            height: "40",
                            top: "40",
                            isBorder: true,
                            isDropBox: true,
                            floatingContent: true,
                            isMobile: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_DropDownSortContent, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyFavorite2_CategoryListBlock, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_CollectionLink, {
                                            onClick: function() {
                                                handleFavorite({
                                                    title: "Recently Added",
                                                    value: "recent"
                                                });
                                            },
                                            children: "Recently Added"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_CollectionLink, {
                                            onClick: function() {
                                                handleFavorite({
                                                    title: "Most Favorite",
                                                    value: "count"
                                                });
                                            },
                                            children: "Most Favorite"
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyFavorite2_ContentBody, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(collection_CardListBox, {
                        children: [
                            isLoading && (0,lodash.times)(30, function(index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                    isLoading: true
                                }, index);
                            }),
                            data === null || data === void 0 ? void 0 : data.pages.map(function(items) {
                                var list = items.list;
                                return list === null || list === void 0 ? void 0 : list.map(function(param, index) {
                                    var name = param.name, imageUri = param.imageUri, tokenId = param.tokenId, network = param.network, assetAddress = param.assetAddress, owner = param.owner, order = param.order, likeCount = param.likeCount;
                                    var ref, ref1;
                                    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card/* default */.Z, {
                                        imageUri: imageUri,
                                        tokenId: tokenId,
                                        name: name,
                                        order: order,
                                        convertedPrice: convertToUsd((ref = order.sale) === null || ref === void 0 ? void 0 : ref.price, network, (ref1 = order.sale) === null || ref1 === void 0 ? void 0 : ref1.currency),
                                        network: network,
                                        href: "/item/".concat(network, "/").concat(assetAddress, "/").concat(tokenId),
                                        assetAddress: assetAddress,
                                        isOwner: owner === account,
                                        isBundle: false,
                                        like: (0,util/* numberToAbbreviateString */.iT)(likeCount)
                                    }, "".concat(name, "_").concat(tokenId, "-").concat(index));
                                });
                            })
                        ]
                    }),
                    hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_LoadMore, {
                        color: "primary",
                        size: "md",
                        variant: "outline",
                        onClick: handleLoadMore,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                            color: "primary700",
                            type: isMobile ? "b4" : "b3",
                            children: "Load more +"
                        })
                    }),
                    !error && (data === null || data === void 0 ? void 0 : data.pages) && (data === null || data === void 0 ? void 0 : data.pages.length) > 0 && (data === null || data === void 0 ? void 0 : data.pages[0].count) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {})
                    }),
                    !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2_EmptyItemBlock, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var MyFavorite2 = (MyFavorite);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/chakra-ui-input.esm.js
var chakra_ui_input_esm = __webpack_require__(4612);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/chakra-ui-tooltip.esm.js + 1 modules
var chakra_ui_tooltip_esm = __webpack_require__(3047);
// EXTERNAL MODULE: ./node_modules/@web3-react/core/dist/core.esm.js + 1 modules
var core_esm = __webpack_require__(34713);
// EXTERNAL MODULE: ./node_modules/react-copy-to-clipboard/lib/index.js
var lib = __webpack_require__(74855);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./src/data/word.ts
var word = __webpack_require__(9564);
// EXTERNAL MODULE: ./src/hooks/useSolana.ts
var useSolana = __webpack_require__(49030);
;// CONCATENATED MODULE: ./src/data/constants.ts
/* eslint-disable import/prefer-default-export */ var MEMBERS_URL = "https://members".concat( false ? 0 : "", ".playdapp.com");

// EXTERNAL MODULE: ./src/store/page.ts
var page = __webpack_require__(46234);
// EXTERNAL MODULE: ./src/store/wallet.ts + 2 modules
var wallet = __webpack_require__(19855);
// EXTERNAL MODULE: ./src/store/user.ts + 1 modules
var store_user = __webpack_require__(51367);
// EXTERNAL MODULE: ./src/components/Dimmer.tsx
var Dimmer = __webpack_require__(94356);
;// CONCATENATED MODULE: ./src/components/IFrame.tsx
/* eslint-disable jsx-a11y/iframe-has-title */ 


var IFrame = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("iframe", (0,_object_spread/* default */.Z)({
        ref: ref
    }, props));
});
/* harmony default export */ var components_IFrame = (IFrame);

;// CONCATENATED MODULE: ./src/components/SpinnerLayer.tsx



var LoadingLayerContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejuxsbf0"
})("position:fixed;top:0;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:center;z-index:100;");
var LoadingLayerOverlay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "ejuxsbf1"
})("position:fixed;top:0;left:0;right:0;bottom:0;z-index:-1;");
var SpinnerLayer = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(LoadingLayerContainer, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingLayerOverlay, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Progress */.Ex, {
                size: "large"
            })
        ]
    });
};
/* harmony default export */ var components_SpinnerLayer = (SpinnerLayer);

;// CONCATENATED MODULE: ./src/components/Modal/MembersSignInModal.tsx







var MainDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd0"
})("text-align:center;", (0,index_esm/* fontStyle */.p_)("h4"), " ", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("h5"), "}");
var ButtonContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd1"
})("display:flex;justify-content:center;gap:8px;width:100%;button{padding:0.5rem 1.25rem;", (0,index_esm/* fontStyle */.p_)("p3"), " ", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;}}");
var SubDescription = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd2"
})("display:flex;justify-content:center;padding-top:1.5rem;padding-bottom:1.5rem;", (0,index_esm/* fontStyle */.p_)("p3"), "  color:", index_esm/* palette.gray900 */.DG.gray900, ";", index_esm/* breakpoints.down */.AV.down("sm"), "{", (0,index_esm/* fontStyle */.p_)("p4"), "}");
var DescriptionBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd3"
})("margin-bottom:0.5rem;width:100%;");
var Box = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd4"
})("display:flex;flex-direction:column;align-items:center;padding:22px 2rem;margin:1rem 0 0rem;gap:0.25rem;width:100%;background-color:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:16px;");
var WalletBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd5"
})("display:flex;flex-direction:column;align-items:center;");
var WalletTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1hfxosd6"
})("margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";", (0,index_esm/* fontStyle */.p_)("p5"), "  color:", index_esm/* palette.gray900 */.DG.gray900, ";");
var WalletImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("figure", {
    target: "e1hfxosd7"
})("display:flex;align-items:center;gap:", index_esm/* spacing.xxs */.W0.xxs, ";margin-bottom:14px;p{color:", index_esm/* palette.dgray300 */.DG.dgray300, ";font-size:14px;font-weight:600;}");
var WalletAddress = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1hfxosd8"
})("min-width:190px;padding:", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.m */.W0.m, ";background-color:", index_esm/* palette.white */.DG.white, ";border-radius:24px;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;font-size:12px;");
var MembersSignInModal = function(param) {
    var isOpen = param.isOpen, handleOpen = param.handleOpen, handleContinue = param.handleContinue;
    var ref = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), provider = ref.provider, account = ref.account;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Modal */.u_, {
        isOpen: isOpen,
        shouldCloseOnOverlayClick: true,
        width: {
            xl: "498px",
            lg: "498px",
            md: "498px"
        },
        handleOpen: handleOpen,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MainDescription, {
                children: "Sign In to your PlayDapp Members account"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(DescriptionBox, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletBlock, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WalletTitle, {
                                    children: "Connected with"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletImageBox, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                            alt: "",
                                            src: "/".concat(provider, ".png"),
                                            prefix: "local",
                                            width: 24,
                                            height: 24
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                            children: word/* walletName */.lx[provider]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WalletAddress, {
                                    children: (0,util/* convertAddress */.US)(account !== null && account !== void 0 ? account : "-")
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubDescription, {
                        children: "If you Continue, Your Sign In is complete."
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                        variant: "outline",
                        color: "secondary",
                        onClick: function() {
                            return handleOpen(false);
                        },
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Button */.zx, {
                        onClick: handleContinue,
                        children: "Continue"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Modal_MembersSignInModal = (MembersSignInModal);

;// CONCATENATED MODULE: ./src/components/MyProfile.tsx




































var SideInfoBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg0"
})("padding:", index_esm/* spacing.m */.W0.m, ";margin-bottom:", index_esm/* spacing.m */.W0.m, ";background-color:white;border-radius:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:flex;padding:", index_esm/* spacing.m */.W0.m, ";gap:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{display:flex;padding:", index_esm/* spacing.m */.W0.m, ";}@media screen and (max-width:540px){display:block;gap:", index_esm/* spacing.xxs */.W0.xxs, ";border-radius:0;}");
var ProfileImage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg1"
})("position:relative;width:", function(param) {
    var theme = param.theme;
    return theme.rem(116);
}, ";height:", function(param) {
    var theme = param.theme;
    return theme.rem(116);
}, ";margin:auto;border:3px solid ", function(param) {
    var isStake = param.isStake;
    return !isStake ? index_esm/* palette.gray300 */.DG.gray300 : "#74d1fc";
}, ";border-radius:12px;img{border-radius:9px;object-fit:cover;}", index_esm/* breakpoints.down */.AV.down("lg"), "{min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(214);
}, ";min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(214);
}, ";margin:0 auto ", index_esm/* spacing.l */.W0.l, " auto;}", index_esm/* breakpoints.down */.AV.down("md"), "{display:flex;min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(116);
}, ";min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(116);
}, ";margin:0 auto ", index_esm/* spacing.m */.W0.m, " auto;}@media screen and (max-width:540px){display:block;min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(84);
}, ";min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(84);
}, ";}");
var NonStakeButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg2"
})("position:absolute;max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(68);
}, ";bottom:0;left:0;right:0;padding:", index_esm/* spacing.xxs */.W0.xxs, " 0;margin:auto auto ", index_esm/* spacing.xs */.W0.xs, " auto;border-radius:6px;", (0,index_esm/* fontStyle */.p_)("b5"), ";", index_esm/* breakpoints.down */.AV.down("lg"), "{min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(100);
}, ";min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(32);
}, ";margin-bottom:", index_esm/* spacing.s */.W0.s, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(68);
}, ";min-height:", function(param) {
    var theme = param.theme;
    return theme.rem(24);
}, ";margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";", (0,index_esm/* fontStyle */.p_)("b6"), ";}");
var ImageSetting = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg3"
})("position:absolute;width:", index_esm/* spacing.xl */.W0.xl, ";height:", index_esm/* spacing.xl */.W0.xl, ";bottom:", index_esm/* spacing.xs */.W0.xs, ";right:", index_esm/* spacing.xs */.W0.xs, ";margin:0;cursor:pointer;");
var WalletAddressBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg4"
})("> p{width:100%;word-break:break-all;}", index_esm/* breakpoints.down */.AV.down("lg"), "{display:flex;align-items:flex-start;justify-content:space-between;padding-bottom:", index_esm/* spacing.m */.W0.m, ";margin-bottom:", index_esm/* spacing.s */.W0.s, ";border-bottom:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("p5"), ";}@media screen and (max-width:540px){display:block;}");
var ProfileInfoBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg5"
})("width:", function(param) {
    var theme = param.theme;
    return theme.rem(280);
}, ";margin-top:", index_esm/* spacing.m */.W0.m, ";padding:", index_esm/* spacing.s */.W0.s, ";border-radius:", index_esm/* spacing.m */.W0.m, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{width:100%;margin-top:0;}");
var VerifyEmail = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg6"
})("width:100%;", (0,index_esm/* fontStyle */.p_)("b4"), ";border-radius:6px;");
var ProfileEmailBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg7"
})("display:flex;align-items:center;justify-content:center;gap:", index_esm/* spacing.xxs */.W0.xxs, ";", (0,index_esm/* fontStyle */.p_)("b3"), ";p{max-width:220px;overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:14px;padding:0;}");
var WalletInfoBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg8"
})("height:100%;margin-top:", index_esm/* spacing.s */.W0.s, ";padding:", index_esm/* spacing.s */.W0.s, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";background-color:", index_esm/* palette.white */.DG.white, ";text-align:left;", index_esm/* breakpoints.down */.AV.down("lg"), "{height:auto;margin-top:", index_esm/* spacing.s */.W0.s, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{p{", (0,index_esm/* fontStyle */.p_)("p3"), ";}}");
var WalletCurrencyBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg9"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:", index_esm/* spacing.m */.W0.m, ";");
var NetworkBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg10"
})("height:", index_esm/* spacing.xl */.W0.xl, ";display:flex;align-items:center;gap:", index_esm/* spacing.xxs */.W0.xxs, ";div{display:flex;align-items:center;justify-content:center;gap:", index_esm/* spacing.xxs */.W0.xxs, ";}");
var SettingBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg11"
})("display:flex;align-items:center;justify-content:center;height:", index_esm/* spacing.xl */.W0.xl, ";gap:", index_esm/* spacing.xxs */.W0.xxs, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";cursor:pointer;padding:", index_esm/* spacing.xs */.W0.xs, ";");
var CurrencyTextBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg12"
})("height:100%;padding:0 ", index_esm/* spacing.xxs */.W0.xxs, ";background-color:", index_esm/* palette.gray200 */.DG.gray200, ";border-radius:", index_esm/* spacing.xxs */.W0.xxs, ";");
var WalletAddressText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg13"
})("display:flex;align-items:center;width:100%;padding-bottom:", index_esm/* spacing.s */.W0.s, ";margin:", index_esm/* spacing.xs */.W0.xs, " 0 ", index_esm/* spacing.s */.W0.s, " 0;border-bottom:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";gap:", index_esm/* spacing.xs */.W0.xs, ";color:", index_esm/* palette.dgray100 */.DG.dgray100, ";span{cursor:pointer;}", index_esm/* breakpoints.down */.AV.down("lg"), "{border-bottom:0;padding:0;margin:0;justify-content:flex-end;}@media screen and (max-width:540px){justify-content:flex-start;}");
var UserLogout = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg14"
})("display:flex;align-items:center;justify-content:center;gap:6px;border-radius:", index_esm/* spacing.s */.W0.s, ";margin:auto;cursor:pointer;", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0;}");
var WalletButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "eq9ztsg15"
})("display:flex;justify-content:center;align-items:center;gap:0.5rem;background-color:transparent;cursor:pointer;& > p{", (0,index_esm/* fontStyle */.p_)("p3"), "    color:", index_esm/* palette.dgray100 */.DG.dgray100, ";text-decoration:underline;", index_esm/* breakpoints.down */.AV.down("sm"), "{", (0,index_esm/* fontStyle */.p_)("p5"), "}}& > span{display:none;margin-right:", index_esm/* spacing.xs */.W0.xs, " !important;}", index_esm/* breakpoints.up */.AV.up("md"), "{& > span{display:none;}}");
var ConnectContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg16"
})("position:relative;height:100%;width:100%;max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(600);
}, ";border-bottom:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";overflow-y:auto;text-align:center;", index_esm/* breakpoints.down */.AV.down("lg"), "{max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(380);
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{max-height:", function(param) {
    var theme = param.theme;
    return theme.rem(330);
}, ";text-align:left;-ms-overflow-style:none;scrollbar-width:none;::-webkit-scrollbar{display:none;}}");
var ConnectTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg17"
})((0,index_esm/* fontStyle */.p_)("h4"), ";margin-bottom:", index_esm/* spacing.s */.W0.s, ";", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.h5 */.JB.h5, ";font-weight:800;margin-bottom:", index_esm/* spacing.xl */.W0.xl, ";text-align:left;}");
var ConnectCard = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg18"
})("height:100%;text-align:left;& > div{padding:", index_esm/* spacing.m */.W0.m, ";border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";border-bottom:none;}");
var CardUser = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg19"
})("display:flex;align-items:center;justify-content:space-between;gap:", index_esm/* spacing.xs */.W0.xs, ";span{cursor:pointer;}");
var AddressNickName = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg20"
})((0,index_esm/* fontStyle */.p_)("b3"), ";margin-right:", index_esm/* spacing.s */.W0.s, ";color:", function(param) {
    var isCurrentAddress = param.isCurrentAddress;
    return isCurrentAddress && index_esm/* palette.primary700 */.DG.primary700;
}, ";");
var EditInput = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(chakra_ui_input_esm/* Input */.II, {
    target: "eq9ztsg21"
})("height:38px;padding:0 ", index_esm/* spacing.s */.W0.s, ";background-color:", index_esm/* palette.white */.DG.white, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";border:1px solid ", index_esm/* palette.gray600 */.DG.gray600, ";box-shadow:none;", function(param) {
    var isInvalid = param.isInvalid;
    return isInvalid ? "\n    border: 1px solid #EF586E;\n    box-shadow: none !important;\n\n    &:focus {\n      outline: none;\n      box-shadow: none;\n      border: 1px solid #EF586E;\n    }\n  " : "";
}, "  &.connect-address{max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(324);
}, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{height:34px;font-size:", index_esm/* fontSize.b3 */.JB.b3, ";}");
var CheckButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg22"
})("display:flex;align-items:center;justify-content:center;width:", index_esm/* spacing.xxxl */.W0.xxxl, ";height:", index_esm/* spacing.xxxl */.W0.xxxl, ";padding:", index_esm/* spacing.s */.W0.s, ";border-radius:8px;");
var CancelButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg23"
})("position:relative;display:flex;align-items:center;justify-content:center;width:", index_esm/* spacing.xxxl */.W0.xxxl, ";height:", index_esm/* spacing.xxxl */.W0.xxxl, ";top:0;padding:", index_esm/* spacing.s */.W0.s, ";outline:0;border:1px solid ", index_esm/* palette.gray900 */.DG.gray900, ";border-radius:8px;& > span{margin:0;}:hover{border:1px solid ", index_esm/* palette.gray900 */.DG.gray900, ";}");
var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("label", {
    target: "eq9ztsg24"
})("font-size:", index_esm/* fontSize.p4 */.JB.p4, ";color:", index_esm/* palette.gray900 */.DG.gray900, ";");
var ErrorMessage = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Label, {
    target: "eq9ztsg25"
})("color:#ef586e;font-size:", index_esm/* fontSize.p4 */.JB.p4, ";");
var CardWallet = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg26"
})("display:flex;align-items:center;justify-content:center;max-width:100%;height:", index_esm/* spacing.xxl */.W0.xxl, ";margin-top:", index_esm/* spacing.s */.W0.s, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";font-size:14px;background-color:", function(param) {
    var isCurrentAddress = param.isCurrentAddress;
    return isCurrentAddress ? index_esm/* palette.primary100 */.DG.primary100 : index_esm/* palette.gray200 */.DG.gray200;
}, ";text-align:center;p{overflow:hidden;white-space:nowrap;text-overflow:ellipsis;}");
var ConnectCancel = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "eq9ztsg27"
})("width:100%;border:1px solid ", index_esm/* palette.gray900 */.DG.gray900, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";margin:", index_esm/* spacing.xxl */.W0.xxl, " auto 0 auto;color:", index_esm/* palette.dgray300 */.DG.dgray300, ";", (0,index_esm/* fontStyle */.p_)("p3"), ";:hover{", (0,index_esm/* fontStyle */.p_)("b3"), ";}");
var AccountCopyButton = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var account = param.account, handleCopy = param.handleCopy;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((lib_default()), {
        text: account,
        onCopy: handleCopy,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletButton, {
            ref: ref,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                    children: (0,util/* convertAddress */.US)(account, 5, 38)
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                    name: "copy",
                    size: 14,
                    color: index_esm/* palette.dgray100 */.DG.dgray100
                })
            ]
        })
    });
});
var IFrameWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eq9ztsg28"
})("position:fixed;display:", function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "block" : "none";
}, ";visibility:", function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "visible" : "hidden";
}, ";left:0;top:0;width:100%;height:100%;padding-top:64px;z-index:9;iframe{width:100%;height:100%;}");
var MyProfile = function() {
    var ref;
    var ref1 = (0,react.useState)(false), stake = ref1[0], setStake = ref1[1];
    var ref2 = (0,react.useState)(false), isProfileOpen = ref2[0], handleProfileOpen = ref2[1];
    var ref3 = (0,react.useState)(false), isIframeOpen = ref3[0], setIsIframeOpen = ref3[1];
    var ref4 = (0,react.useState)(true), isIframeLoading = ref4[0], setIsIframeLoading = ref4[1];
    var ref5 = (0,react.useState)(false), copied = ref5[0], setCopied = ref5[1];
    var ref6 = (0,react.useState)(""), connectAccount = ref6[0], setConnectAccount = ref6[1];
    var ref7 = (0,react.useState)([]), connectList = ref7[0], setConnectList = ref7[1];
    var ref8 = (0,react.useState)(false), isGuideOpened = ref8[0], setIsGuideOpened = ref8[1];
    var ref9 = (0,react.useState)(), currentAccount = ref9[0], setCurrentAccount = ref9[1];
    var ref10 = (0,react.useState)([]), myAccounts = ref10[0], setMyAccounts = ref10[1];
    var ref11 = (0,_sliced_to_array/* default */.Z)((0,useOpenControl/* default */.Z)(), 2), isConnectModal = ref11[0], setIsConnectModal = ref11[1];
    var isMdDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")));
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var deactivate = (0,core_esm/* useWeb3React */.Ge)().deactivate;
    var disconnect = (0,useSolana/* default */.Z)().disconnect;
    var iframeRef = (0,react.useRef)(null);
    var ref12 = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }), account = ref12.account, activeChainId = ref12.activeChainId, provider = ref12.provider;
    var ref13 = (0,hooks/* useAppSelector */.C)(function(param) {
        var user = param.user;
        return user;
    }), alias = ref13.alias, email = ref13.email, connected = ref13.connected, profileTokenId = ref13.profileTokenId, membersMikeyGrade = ref13.membersMikeyGrade;
    var networkName = (0,react.useMemo)(function() {
        return activeChainId ? lib_network/* chainIdToMainNetworkName */.$4[activeChainId] : "polygon";
    }, [
        activeChainId
    ]);
    var handleUpdateToast = (0,useToastMessage/* default */.Z)({
        position: "top",
        duration: 3500,
        id: "convertessage"
    }).handleUpdateToast;
    var ref14 = (0,dist_index_esm/* useForm */.cI)({
        mode: "onChange"
    }), register = ref14.register, errors = ref14.formState.errors, setValue = ref14.setValue, watch = ref14.watch, reset = ref14.reset;
    var onSubmitInfo = function(address) {
        return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
            var data, value, response;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        data = watch();
                        value = data[address];
                        return [
                            4,
                            (0,user/* editNickName */.Ax)({
                                account: address,
                                alias: value
                            })
                        ];
                    case 1:
                        response = _state.sent();
                        if (response.status === 200 && response.data) {
                            if (address === account) {
                                dispatch((0,store_user/* setAlias */.oz)(value));
                            }
                            setConnectList(connectList.map(function(item) {
                                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                                    alias: item.address === address ? value : item.alias
                                });
                            }));
                            setConnectAccount("");
                        }
                        return [
                            2
                        ];
                }
            });
        });
    };
    var handleMessage = (0,react.useCallback)(function(e) {
        try {
            if (e.origin === MEMBERS_URL) {
                var action = e.data.action;
                if (action === "get_info" && isIframeOpen) {
                    if (account === e.data.account) {
                        var stakedTokenId = e.data.stakedTokenId;
                        setStake(true);
                        dispatch((0,store_user/* setProfileTokenId */.wK)(stakedTokenId));
                    }
                }
                if (action === "finish_approval" && isIframeOpen) {
                    handleUpdateToast(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: word/* stakingMessage.approved */.nz.approved
                    }), "success", true);
                }
                if (action === "finish_unstaking" && isIframeOpen) {
                    handleUpdateToast(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: word/* stakingMessage.unstaking */.nz.unstaking
                    }), "success", true);
                }
                if (action === "finish_staking" && isIframeOpen) {
                    handleUpdateToast(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                        children: word/* stakingMessage.staking */.nz.staking
                    }), "success", true);
                }
                if (action === "update_info" && isIframeOpen) {
                    if (e.data.account && account !== e.data.account && !isGuideOpened) {
                        setIsGuideOpened(true);
                        setIsIframeOpen(false);
                        window.open("".concat(MEMBERS_URL, "/connect?account=").concat(account), "_blank");
                    }
                }
            }
        } catch (err) {
            handleUpdateToast(/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: "Unknown error. Please try again."
            }), "error", true);
        }
    }, [
        dispatch,
        account,
        isIframeOpen,
        isGuideOpened,
        handleUpdateToast
    ]);
    var handleIframeLoading = function() {
        setIsIframeLoading(false);
        if (iframeRef.current) {
            var ref;
            (ref = iframeRef.current.contentWindow) === null || ref === void 0 ? void 0 : ref.postMessage({
                action: "info"
            }, {
                targetOrigin: MEMBERS_URL
            });
        }
    };
    var handleProfile = function() {
        if ((0,util/* checkMobileDevice */.EY)()) {
            window.open("".concat(MEMBERS_URL, "/my-page/items"), "_blank");
            return;
        }
        handleProfileOpen(true);
    };
    var handleProfileReset = function() {
        reset({
            formState: ""
        });
        setCurrentAccount(undefined);
    };
    var toggleConnectModal = function(isOpen, address, alias) {
        return function() {
            setIsConnectModal(isOpen);
            if (!isOpen) {
                setConnectAccount("");
                setValue(address, alias);
                handleProfileReset();
            }
        };
    };
    var handleConnectNickName = function(address, callback) {
        return function() {
            setConnectAccount(address);
            if (callback) {
                callback();
            }
            if (!isConnectModal) {
                handleProfileReset();
            }
        };
    };
    var handleCancelEdit = function(address, userAlias) {
        return function() {
            setConnectAccount("");
            setValue(address, userAlias);
            handleProfileReset();
        };
    };
    var handleLogout = function() {
        (0,auth/* removeLoginInfo */.NL)();
        dispatch((0,wallet/* resetWalletInfo */.cx)());
        dispatch((0,store_user/* resetUserInfo */.MS)());
        dispatch((0,page/* setPageNetwork */.kA)(null));
        deactivate();
        disconnect();
    };
    var handleCopy = function() {
        setCopied(true);
        setTimeout(function() {
            setCopied(false);
        }, 2000);
    };
    (0,react.useEffect)(function() {
        setConnectList(connected === null || connected === void 0 ? void 0 : connected.map(function(item) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, item), {
                originalAlias: item.alias,
                alias: item.alias
            });
        }));
    }, [
        connected
    ]);
    (0,react.useEffect)(function() {
        var nextCurrentAccount = connectList === null || connectList === void 0 ? void 0 : connectList.find(function(item) {
            return item.address === account;
        });
        var nextMyAccounts = connectList === null || connectList === void 0 ? void 0 : connectList.filter(function(item) {
            return item.address !== account;
        });
        setCurrentAccount(nextCurrentAccount);
        setMyAccounts(nextMyAccounts);
    }, [
        connectList,
        currentAccount
    ]);
    var handleContinue = function() {
        setIsIframeOpen(true);
        setIsIframeLoading(true);
        setIsGuideOpened(false);
        handleProfileOpen(false);
        router.push("/my-page/items?type=members");
    };
    (0,react.useEffect)(function() {
        window.addEventListener("message", handleMessage);
        return function() {
            window.removeEventListener("message", handleMessage);
        };
    }, [
        handleMessage
    ]);
    (0,react.useEffect)(function() {
        router.events.on("routeChangeComplete", function(e) {
            if (e !== "/my-page/items?type=members") {
                setIsIframeOpen(false);
                setIsIframeLoading(true);
                setIsGuideOpened(false);
            }
        });
    }, [
        router,
        isIframeLoading,
        isIframeOpen
    ]);
    (0,react.useEffect)(function() {
        var bodyElement = document.querySelector("body");
        if (isIframeOpen) {
            if (bodyElement && iframeRef.current && !isIframeLoading) {
                bodyElement.style.overflow = "hidden";
            }
        } else {
            bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.removeAttribute("style");
        }
        return function() {
            bodyElement === null || bodyElement === void 0 ? void 0 : bodyElement.removeAttribute("style");
        };
    }, [
        isIframeOpen,
        isIframeLoading
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SideInfoBlock, {
                children: [
                    networkName === "polygon" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                        children: profileTokenId && membersMikeyGrade ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileImage, {
                            isStake: stake,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                    src: "".concat("https://images.playdapp.com/members", "/").concat(membersMikeyGrade, "/gif/").concat(profileTokenId, ".gif"),
                                    layout: "fill",
                                    objectFit: "cover",
                                    width: 32,
                                    height: 32
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ImageSetting, {
                                    onClick: handleProfile,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                        name: "setting-green",
                                        size: 24,
                                        alt: "setting-primary"
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileImage, {
                            isStake: stake,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                                    prefix: "s3",
                                    src: "/mypage/non-stake.png",
                                    layout: "fill",
                                    objectFit: "cover",
                                    alt: "info-img"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NonStakeButton, {
                                    size: "xs",
                                    color: "primary",
                                    onClick: handleProfile,
                                    children: "Stake"
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ProfileImage, {
                        isStake: stake,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_Image/* default */.Z, {
                            prefix: "s3",
                            src: "/mypage/empty-stake.png",
                            layout: "fill",
                            objectFit: "cover",
                            alt: "info-img"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileInfoBlock, {
                        children: [
                            !email ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                                href: "/email/verification",
                                passHref: true,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifyEmail, {
                                    children: "Verify Email"
                                })
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ProfileEmailBlock, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                        children: email
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                        name: "bottle-check",
                                        size: 16
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletInfoBlock, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletCurrencyBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(NetworkBlock, {
                                                children: [
                                                    provider && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "".concat(provider, "-square"),
                                                        size: 24
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CurrencyTextBlock, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "dot-green",
                                                                size: 4
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                                type: "p5",
                                                                children: (0,lodash.capitalize)(networkName)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SettingBlock, {
                                                variant: "ghost",
                                                color: "secondary",
                                                onClick: toggleConnectModal(true, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.alias),
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                        name: "setting",
                                                        size: 12
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                        type: "p5",
                                                        color: "dgray600",
                                                        children: "Setting"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(WalletAddressBlock, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                children: alias
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(WalletAddressText, {
                                                children: account && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_tooltip_esm/* Tooltip */.u, {
                                                    label: "Copied!",
                                                    isOpen: copied,
                                                    placement: "bottom",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccountCopyButton, {
                                                        account: account,
                                                        handleCopy: handleCopy
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(UserLogout, {
                                        variant: "ghost",
                                        color: "secondary",
                                        onClick: handleLogout,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                name: "log-switch",
                                                size: 14,
                                                alt: "login-switch"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                type: "p5",
                                                color: "dgray600",
                                                children: "Sign out"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Modal */.u_, {
                        isOpen: isConnectModal,
                        handleOpen: toggleConnectModal(false, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.alias),
                        shouldCloseOnOverlayClick: true,
                        width: isMdDownScreen ? "100%" : "520px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ConnectContainer, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConnectTitle, {
                                        children: "Connected Addresses"
                                    }),
                                    currentAccount && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConnectCard, {
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                            children: [
                                                account !== connectAccount ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardUser, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressNickName, {
                                                            isCurrentAddress: account === currentAccount.address,
                                                            children: currentAccount.alias ? currentAccount.alias : "Please Setting NickaName"
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                            name: "edit",
                                                            alt: "edit",
                                                            size: 20,
                                                            onClick: handleConnectNickName(currentAccount.address)
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardUser, {
                                                            className: "connect-box",
                                                            children: [
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                    className: "connect-address",
                                                                    type: "text",
                                                                    isRequired: true,
                                                                    isInvalid: !!errors[currentAccount.address],
                                                                    placeholder: "Edit your Nickname"
                                                                }, register(currentAccount.address, {
                                                                    required: "Please Enter Nickname",
                                                                    pattern: {
                                                                        value: /^[a-zA-Z0-9]{2,20}$/,
                                                                        message: "This nickname is not valid"
                                                                    }
                                                                })), {
                                                                    defaultValue: currentAccount.alias
                                                                })),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CancelButton, {
                                                                    variant: "outline",
                                                                    color: "secondary",
                                                                    iconOnly: true,
                                                                    onClick: handleCancelEdit(currentAccount.address, currentAccount.alias),
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                        name: "cancel-mark",
                                                                        size: 12
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckButton, {
                                                                    variant: "solid",
                                                                    color: "primary",
                                                                    iconOnly: true,
                                                                    disabled: !!errors[currentAccount.address],
                                                                    onClick: handleConnectNickName(currentAccount.address, onSubmitInfo(currentAccount.address)),
                                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                        name: "check-mark-white",
                                                                        size: 12
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        errors[currentAccount.address] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorMessage, {
                                                            children: (ref = errors[currentAccount.address]) === null || ref === void 0 ? void 0 : ref.message
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWallet, {
                                                    isCurrentAddress: account === currentAccount.address,
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                        children: currentAccount.address
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    myAccounts === null || myAccounts === void 0 ? void 0 : myAccounts.map(function(info, index) {
                                        var ref;
                                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConnectCard, {
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("div", {
                                                children: [
                                                    info.address !== connectAccount ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardUser, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressNickName, {
                                                                isCurrentAddress: account === info.address,
                                                                children: info.alias ? info.alias : "Please Setting NickaName"
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                name: "edit",
                                                                alt: "edit",
                                                                size: 20,
                                                                onClick: handleConnectNickName(info.address)
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardUser, {
                                                                className: "connect-box",
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EditInput, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                                                        className: "connect-address",
                                                                        type: "text",
                                                                        isRequired: true,
                                                                        isInvalid: !!errors[info.address],
                                                                        placeholder: "Edit your Nickname"
                                                                    }, register(info.address, {
                                                                        required: "Please Enter Nickname",
                                                                        pattern: {
                                                                            value: /^[a-zA-Z0-9]{2,20}$/,
                                                                            message: "This nickname is not valid"
                                                                        }
                                                                    })), {
                                                                        defaultValue: info.alias
                                                                    })),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CancelButton, {
                                                                        variant: "outline",
                                                                        color: "secondary",
                                                                        iconOnly: true,
                                                                        onClick: handleCancelEdit(info.address, info.alias),
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                            name: "cancel-mark",
                                                                            size: 12
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CheckButton, {
                                                                        variant: "solid",
                                                                        color: "primary",
                                                                        iconOnly: true,
                                                                        disabled: !!errors[info.address],
                                                                        onClick: handleConnectNickName(info.address, onSubmitInfo(info.address)),
                                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                                            name: "check-mark-white",
                                                                            size: 12
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            errors[info.address] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorMessage, {
                                                                children: (ref = errors[info.address]) === null || ref === void 0 ? void 0 : ref.message
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardWallet, {
                                                        isCurrentAddress: account === info.address,
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("p", {
                                                            children: info.address
                                                        })
                                                    })
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConnectCancel, {
                                variant: "outline",
                                color: "secondary",
                                onClick: toggleConnectModal(false, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.address, currentAccount === null || currentAccount === void 0 ? void 0 : currentAccount.alias),
                                children: "OK"
                            })
                        ]
                    })
                ]
            }),
            isIframeOpen && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(IFrameWrapper, {
                isVisible: true,
                children: [
                    isIframeLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dimmer/* default */.Z, {
                        isOpen: isIframeLoading,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_SpinnerLayer, {})
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_IFrame, {
                        ref: iframeRef,
                        src: "".concat(MEMBERS_URL, "/my-page-embed?type=market"),
                        width: "100%",
                        height: "100%",
                        frameBorder: "0",
                        allow: "autoplay",
                        onLoad: handleIframeLoading,
                        loading: "lazy"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Modal_MembersSignInModal, {
                isOpen: isProfileOpen,
                handleOpen: handleProfileOpen,
                handleContinue: handleContinue
            })
        ]
    });
};
/* harmony default export */ var components_MyProfile = (MyProfile);

// EXTERNAL MODULE: ./src/components/Spinner.tsx
var Spinner = __webpack_require__(95433);
;// CONCATENATED MODULE: ./src/components/contents/MyPageContent.tsx





function MyPageContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        color: ",
        ";\n      "
    ]);
    MyPageContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function MyPageContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: ",
        ";\n        "
    ]);
    MyPageContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}



























var MyPageContent_Container = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm0"
})("position:relative;display:flex;justify-content:center;padding-top:4.5rem;overflow:unset;", index_esm/* breakpoints.down */.AV.down("xl"), "{padding-top:4rem;}", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;}", index_esm/* breakpoints.down */.AV.down("md"), "{padding-top:3.5rem;}");
var SideInfoContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm1"
})("margin:", index_esm/* spacing.m */.W0.m, " 0 0 ", index_esm/* spacing.m */.W0.m, ";text-align:center;", index_esm/* breakpoints.down */.AV.down("lg"), "{padding:", index_esm/* spacing.m */.W0.m, " ", index_esm/* spacing.m */.W0.m, " 0 ", index_esm/* spacing.m */.W0.m, ";margin:0;}", index_esm/* breakpoints.down */.AV.down("sm"), "{padding:0;}");
var MyPageContent_SideInfoBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm2"
})("padding:", index_esm/* spacing.m */.W0.m, ";margin-bottom:", index_esm/* spacing.m */.W0.m, ";background-color:white;border-radius:", index_esm/* spacing.m */.W0.m, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:flex;padding:", index_esm/* spacing.xs */.W0.xs, ";gap:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{display:", function(param) {
    var isMdDown = param.isMdDown;
    return isMdDown && "none";
}, ";}", index_esm/* breakpoints.down */.AV.down("sm"), "{gap:", index_esm/* spacing.xxs */.W0.xxs, ";border-radius:0;}");
var ContentSubHeadBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm3"
})("width:100%;padding:", index_esm/* spacing.l */.W0.l, ";margin-top:", index_esm/* spacing.xl */.W0.xl, ";", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0 ", index_esm/* spacing.m */.W0.m, " ", index_esm/* spacing.xxxl */.W0.xxxl, " ", index_esm/* spacing.m */.W0.m, ";margin-top:0;}");
var MyPageMainTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm4"
})("font-size:", index_esm/* spacing.xl */.W0.xl, ";font-weight:600;margin-bottom:", index_esm/* spacing.m */.W0.m, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{display:none;}");
var MyPageContent_ContentBody = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm5"
})("position:relative;display:", function(param) {
    var isLoading = param.isLoading;
    return isLoading ? "flex" : "block";
}, ";align-items:center;justify-content:center;gap:", index_esm/* spacing.l */.W0.l, ";margin:auto;min-height:600px;", index_esm/* breakpoints.down */.AV.down("xxl"), "{gap:", index_esm/* spacing.m */.W0.m, ";}", index_esm/* breakpoints.down */.AV.down("xl"), "{row-gap:", index_esm/* spacing.l */.W0.l, ";column-gap:", index_esm/* spacing.xl */.W0.xl, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{padding-bottom:2rem;}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:0;}");
var SubTitleTab = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm6"
})("display:", function(param) {
    var isVisible = param.isVisible;
    return isVisible ? "flex" : "none";
}, ";justify-content:center;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.xxl */.W0.xxl, ";font-size:", index_esm/* fontSize.b3 */.JB.b3, ";font-weight:", function(param) {
    var isSelected = param.isSelected;
    return isSelected && 600;
}, ";border-bottom:", function(param) {
    var isSelected = param.isSelected;
    return isSelected && "1px solid ".concat(index_esm/* palette.dgray600 */.DG.dgray600);
}, ";color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? index_esm/* palette.black */.DG.black : index_esm/* palette.gray800 */.DG.gray800;
}, ";cursor:pointer;&.activity-tab{text-transform:capitalize;}", index_esm/* breakpoints.down */.AV.down("md"), "{width:100%;padding:", index_esm/* spacing.s */.W0.s, " 0;", (0,index_esm/* fontStyle */.p_)("b4"), ";text-align:center;}");
var ItemTab = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1ym8fbm7"
})("display:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? "flex" : "block";
}, ";justify-content:flex-start;flex:1;width:100%;margin-bottom:", function(param) {
    var isBalance = param.isBalance;
    return isBalance && 0;
}, ";padding:", index_esm/* spacing.s */.W0.s, ";", (0,index_esm/* fontStyle */.p_)("b4"), "  border-radius:10px;color:", index_esm/* palette.black */.DG.black, ";background-color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? index_esm/* palette.gray200 */.DG.gray200 : index_esm/* palette.white */.DG.white;
}, ";text-align:left;&.activity-tab{text-transform:capitalize;}&:hover{", function(param) {
    var isSelected = param.isSelected;
    return !isSelected && (0,emotion_react_browser_esm/* css */.iv)(MyPageContent_templateObject(), index_esm/* palette.dgray600 */.DG.dgray600);
}, ";background-color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? index_esm/* palette.gray200 */.DG.gray200 : index_esm/* palette.gray100 */.DG.gray100;
}, ";}&:active{background-color:", index_esm/* palette.gray200 */.DG.gray200, ";}", index_esm/* breakpoints.down */.AV.down("lg"), "{justify-content:center;text-align:center;border-radius:10px;}", index_esm/* breakpoints.down */.AV.down("md"), "{min-width:", function(param) {
    var theme = param.theme;
    return theme.rem(72);
}, ";max-width:", function(param) {
    var theme = param.theme;
    return theme.rem(162);
}, ";padding:", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.l */.W0.l, ";font-size:", index_esm/* fontSize.b5 */.JB.b5, ";font-weight:700;border-radius:6px;&:hover{", function(param) {
    var isSelected = param.isSelected;
    return !isSelected && (0,emotion_react_browser_esm/* css */.iv)(MyPageContent_templateObject1(), index_esm/* palette.dgray600 */.DG.dgray600);
}, ";background-color:", function(param) {
    var isSelected = param.isSelected;
    return isSelected ? index_esm/* palette.dgray600 */.DG.dgray600 : index_esm/* palette.gray300 */.DG.gray300;
}, ";}&:active{color:", index_esm/* palette.white */.DG.white, ";background-color:", index_esm/* palette.dgray600 */.DG.dgray600, ";}}");
var TabNavContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm8"
})("position:relative;", index_esm/* breakpoints.down */.AV.down("lg"), "{display:flex;width:100%;}");
var SubTabNavContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm9"
})("display:flex;margin-bottom:", function(param) {
    var isVisible = param.isVisible;
    return isVisible ? index_esm/* spacing.l */.W0.l : 0;
}, ";border-bottom:", function(param) {
    var isVisible = param.isVisible;
    return isVisible !== "balance" && "1px solid ".concat(index_esm/* palette.gray400 */.DG.gray400);
}, ";");
var ItemOptionBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm10"
})("width:100%;gap:10px;& > div{width:100%;}");
var MobileTabDrop = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(components_SortByDropDown/* default */.Z, {
    target: "e1ym8fbm11"
})("display:none;& > div{justify-content:flex-start;", (0,index_esm/* fontStyle */.p_)("b1"), ";margin-bottom:", index_esm/* spacing.m */.W0.m, ";gap:0.5rem;border:none;}", index_esm/* breakpoints.down */.AV.down("lg"), "{display:block;order:2;}", index_esm/* breakpoints.down */.AV.down("md"), "{width:50%;margin:0;& > div{margin-bottom:6px;}}");
var MyPageContent_DropDownSortContent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm12"
})("display:flex;flex-direction:column;max-height:", function(param) {
    var isUnits = param.isUnits;
    return isUnits && "24rem";
}, ";overflow-y:", function(param) {
    var isUnits = param.isUnits;
    return isUnits ? "scroll" : "auto";
}, ";border-radius:", index_esm/* spacing.xs */.W0.xs, ";padding:0;box-shadow:0px 20px 32px 0px #4c4f6e1a;", index_esm/* breakpoints.down */.AV.down("md"), "{overflow-y:auto;}");
var MyPageContent_DropDownItem = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("button", {
    target: "e1ym8fbm13"
})("display:flex;align-items:center;outline:0;padding:", index_esm/* spacing.s */.W0.s, " ", index_esm/* spacing.l */.W0.l, ";background-color:white;text-align:left;font-family:initial;&:hover{background-color:", index_esm/* palette.gray400 */.DG.gray400, ";}& > span{flex:none;border-radius:50%;}", index_esm/* breakpoints.down */.AV.down("md"), "{padding:", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.m */.W0.m, ";& > p{width:100%;padding:", index_esm/* spacing.xs */.W0.xs, ";}:hover{border-radius:", index_esm/* spacing.xs */.W0.xs, ";}}");
var tabItem = [
    {
        key: "items",
        value: "Items"
    },
    {
        key: "activity",
        value: "Activity"
    }, 
];
var subTabItem = [
    {
        key: "my-items",
        value: "My Items",
        type: "items"
    },
    {
        key: "my-sales",
        value: "My Sales",
        type: "items"
    },
    {
        key: "favorite",
        value: "Favorite",
        type: "items"
    },
    {
        key: "trading-history",
        value: "Trading History",
        type: "activity"
    },
    {
        key: "offers",
        value: "Offers",
        type: "activity"
    }, 
];
var MyPageContent_EmptyItemBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ym8fbm14"
})("display:flex;flex-direction:column;align-items:center;margin-top:10rem;gap:", index_esm/* spacing.xl */.W0.xl, ";button{color:", index_esm/* palette.white */.DG.white, ";font-weight:600;border-radius:1.5rem;}");
var MyPageContent_LoadMore = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(index_esm/* Button */.zx, {
    target: "e1ym8fbm15"
})("display:flex;align-items:center;height:", index_esm/* spacing.xxl */.W0.xxl, ";padding:6px ", index_esm/* spacing.m */.W0.m, ";margin:", index_esm/* spacing.l */.W0.l, " auto;border-radius:6px;& + a,a + &{margin-left:", index_esm/* spacing.xs */.W0.xs, ";}");
var MyPageContent = function(param) {
    var tab = param.tab;
    var ref = (0,react.useState)(true), isPageLoading = ref[0], setIsPageLoading = ref[1];
    var ref1 = (0,react.useState)(false), isClose = ref1[0], setIsClose = ref1[1];
    var ref2 = (0,react.useState)(false), isMount = ref2[0], setIsMount = ref2[1];
    var ref3 = (0,react.useState)(false), isTransactionOpen = ref3[0], setIsTransactionOpen = ref3[1];
    var ref4 = (0,react.useState)("My Items"), subTab = ref4[0], setSubTab = ref4[1];
    var ref5 = (0,react.useState)("single"), salesType = ref5[0], setSalesType = ref5[1];
    var router = (0,next_router.useRouter)();
    var dispatch = (0,hooks/* useAppDispatch */.T)();
    var ref6 = (0,react.useRef)(null);
    var ref7 = (0,hooks/* useAppSelector */.C)(function(param) {
        var user = param.user;
        return user;
    }), isUserLoading = ref7.isUserLoading, active = ref7.active;
    var account = (0,hooks/* useAppSelector */.C)(function(param) {
        var wallet = param.wallet;
        return wallet;
    }).account;
    var isMdDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("md")));
    var pagePath = Object.keys(router.query)[0].toString();
    var CurrentPage = subTabItem.find(function(item) {
        return router.asPath.includes(item.key);
    });
    var convertToUsd = (0,useTokenCurrency/* default */.Z)().convertToUsd;
    var fetchActivityList = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
            var _pageParam, pageParam, tradingData, data, mergeData, data1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _pageParam = param.pageParam, pageParam = _pageParam === void 0 ? 1 : _pageParam;
                        if (!account) {
                            throw new Error("No account");
                        }
                        tradingData = [];
                        if (!(subTab === "Trading History")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,user/* getMyActivity */.PK)({
                                account: account,
                                type: (0,lodash.capitalize)("market"),
                                page: pageParam
                            })
                        ];
                    case 1:
                        data = _state.sent().data;
                        if (data) tradingData = tradingData.concat(data);
                        _state.label = 2;
                    case 2:
                        mergeData = [];
                        if (!(subTab !== "Trading History")) return [
                            3,
                            4
                        ];
                        return [
                            4,
                            (0,user/* getMyMergeHistory */.vW)({
                                count: 20,
                                offset: 0
                            })
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        if (data1) mergeData = mergeData.concat(data1);
                        _state.label = 4;
                    case 4:
                        return [
                            2,
                            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tradingData[0], mergeData[0]), {
                                from: pageParam * 10,
                                nextPage: pageParam + 1
                            })
                        ];
                }
            });
        });
        return function fetchActivityList(_) {
            return _ref.apply(this, arguments);
        };
    }();
    var ref8 = (0,es.useInfiniteQuery)([
        "myActivity",
        account,
        subTab
    ], fetchActivityList, {
        getNextPageParam: function(table) {
            if (Math.floor((table.total || table.count) / 10) >= table.nextPage && (table.total || table.count) > 10) {
                return table.nextPage;
            }
        },
        enabled: !!account,
        refetchOnWindowFocus: false,
        cacheTime: 0
    }), isLoading = ref8.isLoading, requestData = ref8.data, fetchNextPage = ref8.fetchNextPage, refetch = ref8.refetch, hasNextPage = ref8.hasNextPage, error = ref8.error;
    var handleTabClick = function(selectedTab) {
        return function(e) {
            e.preventDefault();
            if (selectedTab === "items") {
                dispatch((0,merge/* setIsMergeOpen */.NI)(false));
            }
            if (selectedTab !== tab) {
                router.push("/my-page/".concat(selectedTab, "?")//  || (selectedTab === 'balance' && 'balance')
                .concat(selectedTab === "items" && "my-items" || selectedTab === "activity" && "trading-history"));
            }
        };
    };
    var handleSubTabClick = function(subTab) {
        return function() {
            setSubTab(subTab);
            if (subTab) {
                router.push("/my-page/".concat(tab, "?").concat(subTab === "My Items" && "my-items" || subTab === "My Sales" && "my-sales" || subTab === "Favorite" && "favorite" || subTab === "Trading History" && "trading-history" || subTab === "Offers" && "offers"));
            }
        };
    };
    var handleCheckUrl = (0,react.useMemo)(function() {
        return function() {
            var checkUrl = subTabItem.find(function(menu) {
                return pagePath.includes(menu.key);
            });
            if (checkUrl === null || checkUrl === void 0 ? void 0 : checkUrl.key) {
                router.push("/my-page/".concat(tab, "?").concat(checkUrl === null || checkUrl === void 0 ? void 0 : checkUrl.key));
            }
            if (!checkUrl && tab) {
                router.push("/my-page/".concat(tab, "?")//  || (tab === 'balance' && 'balance')
                .concat(tab === "items" && "my-items" || tab === "activity" && "trading-history"));
            }
        };
    }, []);
    var handleLoadMore = function() {
        fetchNextPage();
    };
    (0,react.useEffect)(function() {
        if (account) {
            handleCheckUrl();
        }
    }, [
        account
    ]);
    (0,react.useEffect)(function() {
        if (isClose) {
            setIsClose(function() {
                return false;
            });
        }
    }, [
        isClose
    ]);
    (0,react.useEffect)(function() {
        if (!(0,auth/* isTokenExist */.MN)() || !isUserLoading && (!account || !active) && isMount) {
            router.push("/");
        } else if (isPageLoading) {
            setIsPageLoading(false);
        }
    }, [
        account,
        active,
        router,
        isPageLoading,
        isUserLoading,
        isMount,
        handleCheckUrl, 
    ]);
    (0,react.useEffect)(function() {
        if (isClose) {
            setIsClose(function() {
                return false;
            });
        }
    }, [
        isClose
    ]);
    (0,react.useEffect)(function() {
        if (tab === "items") {
            setSubTab("My Items");
        }
        if (tab === "activity") {
            setSubTab("Trading History");
        }
        if (tab === "balance") {
            // setSubTab('');
            router.push("/my-page/items?my-items");
        }
    }, [
        tab
    ]);
    (0,react.useEffect)(function() {
        if (isUserLoading) {
            setIsMount(true);
        }
    }, [
        isUserLoading
    ]);
    (0,react.useEffect)(function() {
        if (account && tab === "balance" && router.query.funds && router.query.funds === "buy") {
            setIsTransactionOpen(true);
        }
        if (account && tab === "sales" && router.query.type && (router.query.type === "single" || router.query.type === "bundle")) {
            setSalesType(router.query.type);
        }
        return function() {
            setIsTransactionOpen(false);
            setSalesType("single");
        };
    }, [
        router.query,
        account
    ]);
    (0,react.useEffect)(function() {
        refetch();
    }, [
        refetch
    ]);
    (0,react.useEffect)(function() {
        if (CurrentPage) {
            setSubTab(CurrentPage === null || CurrentPage === void 0 ? void 0 : CurrentPage.value);
        }
    }, [
        CurrentPage
    ]);
    if (isPageLoading || isUserLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingLayer/* default */.Z, {});
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyPageContent_Container, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SideInfoContainer, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MyProfile, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_SideInfoBlock, {
                        isMdDown: isMdDownScreen,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabNavContainer, {
                            children: tabItem.map(function(item) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemTab, {
                                    className: "activity-tab",
                                    isSelected: tab === item.key,
                                    isBalance: item.key === "balance",
                                    onClick: handleTabClick(item.key),
                                    ref: ref6,
                                    children: item.value
                                }, item.key);
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ContentSubHeadBlock, {
                children: [
                    isMdDownScreen ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileTabDrop, {
                        title: (0,lodash.capitalize)(tab),
                        width: "100%",
                        height: "36px",
                        top: "40px",
                        isClose: isClose,
                        isBorder: true,
                        isDropBox: true,
                        floatingContent: true,
                        isMobile: true,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_DropDownSortContent, {
                            isUnits: true,
                            children: tabItem.map(function(info) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_DropDownItem, {
                                    onClick: handleTabClick(info.key),
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                        type: "b3",
                                        color: "dgray200",
                                        component: "p",
                                        children: (0,lodash.capitalize)(info.key)
                                    })
                                }, info.key);
                            })
                        })
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageMainTitle, {
                        children: (0,lodash.capitalize)(tab)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTabNavContainer, {
                        isVisible: tab,
                        children: subTabItem.map(function(item) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SubTitleTab, {
                                className: "activity-tab",
                                isVisible: item.type === tab,
                                isSelected: pagePath === item.key,
                                onClick: handleSubTabClick(item.value),
                                children: item.type === tab && item.value
                            }, "subtab-menu-".concat(item.key));
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MyPageContent_ContentBody, {
                        isLoading: isLoading,
                        children: [
                            isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LoadingLayer/* LoadingBox */.p, {
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spinner/* default */.Z, {})
                            }),
                            !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemOptionBox, {
                                children: [
                                    subTab === "My Items" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyItems2, {}),
                                    subTab === "My Sales" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MySales2, {
                                        salesType: salesType
                                    }),
                                    subTab === "Favorite" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyFavorite2, {}),
                                    subTab === "Trading History" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default */.Z, {
                                                title: "TradingHistory",
                                                headers: [
                                                    "Event",
                                                    "NFT Name",
                                                    "Price",
                                                    "From",
                                                    "To",
                                                    "Date", 
                                                ],
                                                children: requestData === null || requestData === void 0 ? void 0 : requestData.pages.map(function(activityData) {
                                                    var activityList = activityData.activityList;
                                                    return activityList === null || activityList === void 0 ? void 0 : activityList.map(function(info, idx) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default.MyActivityItem */.Z.MyActivityItem, {
                                                            name: info.name,
                                                            event: info.event,
                                                            from: info.from,
                                                            to: info.to,
                                                            tokenId: info.tokenId,
                                                            isValid: info.isValid,
                                                            contractAddress: info.contractAddress,
                                                            price: info.price,
                                                            currency: info.currency,
                                                            timestamp: info.timestamp,
                                                            hash: info.hash,
                                                            slug: info.slug,
                                                            imageUri: info.imageUri,
                                                            network: info.network,
                                                            toUsd: convertToUsd(info.price, info.network, info.currency),
                                                            isOwner: true
                                                        }, idx);
                                                    });
                                                })
                                            }),
                                            hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_LoadMore, {
                                                onClick: handleLoadMore,
                                                color: "secondary",
                                                size: "md",
                                                variant: "outline",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    color: "dgray600",
                                                    type: "p5",
                                                    children: "Load More +"
                                                })
                                            }),
                                            !error && (requestData === null || requestData === void 0 ? void 0 : requestData.pages) && (requestData === null || requestData === void 0 ? void 0 : requestData.pages.length) > 0 && (requestData === null || requestData === void 0 ? void 0 : requestData.pages[0].activityList.length) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_EmptyItemBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {
                                                    text: "No Trading yet"
                                                })
                                            }),
                                            !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_EmptyItemBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    subTab === "Merge history" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default */.Z, {
                                                title: "MergeHistory",
                                                headers: [
                                                    "Merge Type",
                                                    "NFT Used",
                                                    "Result",
                                                    "Date",
                                                    "VRF", 
                                                ],
                                                children: requestData === null || requestData === void 0 ? void 0 : requestData.pages.map(function(mergeData) {
                                                    var histories = mergeData.histories;
                                                    return histories === null || histories === void 0 ? void 0 : histories.map(function(info, idx) {
                                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Table/* default.MyMergeHistoryItem */.Z.MyMergeHistoryItem, {
                                                            date: info.date,
                                                            eventType: info.eventType,
                                                            materialToken: info.materialTokens,
                                                            resultTokens: info.resultTokens,
                                                            txhashVRF: info.txHashVRF
                                                        }, idx);
                                                    });
                                                })
                                            }),
                                            hasNextPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_LoadMore, {
                                                onClick: handleLoadMore,
                                                size: "xs",
                                                variant: "outline",
                                                color: "secondary",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Typography */.ZT, {
                                                    color: "dgray600",
                                                    type: "p5",
                                                    children: "Load More +"
                                                })
                                            }),
                                            !error && (requestData === null || requestData === void 0 ? void 0 : requestData.pages) && (requestData === null || requestData === void 0 ? void 0 : requestData.pages.length) > 0 && (requestData === null || requestData === void 0 ? void 0 : requestData.pages[0].histories.length) === 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_EmptyItemBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyItem/* default */.Z, {
                                                    text: "No Merge yet"
                                                })
                                            }),
                                            !isLoading && error && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyPageContent_EmptyItemBlock, {
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ErrorContents/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    subTab === "Offers" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_MyOffers, {}),
                                    tab === "balance" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MyBalance2, {
                                        isTransactionOpen: isTransactionOpen
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var contents_MyPageContent = (MyPageContent);


/***/ }),

/***/ 39086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80871);


var useFeeValues = function(fee) {
    var originPrice = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(originPrice), price = ref[0], setPrice = ref[1];
    var feeValues = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        var ref, ref1, ref2;
        var playdappFee = (fee === null || fee === void 0 ? void 0 : (ref = fee.playdapp) === null || ref === void 0 ? void 0 : ref.baseFee) ? (fee === null || fee === void 0 ? void 0 : (ref1 = fee.playdapp) === null || ref1 === void 0 ? void 0 : ref1.baseFee) / 100 : 0;
        var developerFee = (fee === null || fee === void 0 ? void 0 : (ref2 = fee.developer) === null || ref2 === void 0 ? void 0 : ref2.baseFee) ? (fee === null || fee === void 0 ? void 0 : fee.developer.baseFee) / 100 : 0;
        var totalFee = Number(playdappFee) + Number(developerFee);
        return {
            playdapp: {
                price: (0,lib_util__WEBPACK_IMPORTED_MODULE_1__/* .getFeePrice */ .Q2)(price, playdappFee),
                percent: playdappFee
            },
            developer: {
                price: (0,lib_util__WEBPACK_IMPORTED_MODULE_1__/* .getFeePrice */ .Q2)(price, developerFee),
                percent: developerFee
            },
            total: {
                price: (0,lib_util__WEBPACK_IMPORTED_MODULE_1__/* .getFeePrice */ .Q2)(price, totalFee),
                percent: totalFee
            }
        };
    }, [
        fee,
        price
    ]);
    var handleUpdatePrice = function(price) {
        setPrice(price);
    };
    return {
        feeValues: feeValues,
        handleUpdatePrice: handleUpdatePrice
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useFeeValues);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 85046:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('[{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"from","type":"address"},{"name":"to","type":"address"},{"name":"value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"addedValue","type":"uint256"}],"name":"increaseAllowance","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"to","type":"address"},{"name":"value","type":"uint256"}],"name":"mint","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"value","type":"uint256"}],"name":"burn","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"from","type":"address"},{"name":"value","type":"uint256"}],"name":"burnFrom","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"account","type":"address"}],"name":"addMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[],"name":"renounceMinter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"spender","type":"address"},{"name":"subtractedValue","type":"uint256"}],"name":"decreaseAllowance","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"name":"to","type":"address"},{"name":"value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"account","type":"address"}],"name":"isMinter","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"owner","type":"address"},{"name":"spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"inputs":[{"name":"_name","type":"string"},{"name":"_symbol","type":"string"},{"name":"_value","type":"uint256"},{"name":"_decimals","type":"uint8"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"name":"account","type":"address"}],"name":"MinterAdded","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"account","type":"address"}],"name":"MinterRemoved","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"}]');

/***/ })

}]);